import * as Action from "@actions/index";

// const InitialState = {
//   status: "loading",
//   data: {},
//   error: "",
// };

const InitialState = {
  // list: [
  //   {
  //     label: "ОТКРЫТИЕ",
  //     companyTitle: null,
  //     description:
  //       "<p><strong>12:00 &mdash; 12:05</strong><br />\r\n<strong>СЕО Profi.Travel Алексей&nbsp;Венгин</strong></p>\r\n\r\n<ul>\r\n\t<li>Приветственное слово для участников ОТМ: Лето 2021</li>\r\n</ul>\r\n\r\n<p><strong>12:05 &mdash; 12:20<br />\r\nАртем Чумак, главный редактор Profi.Travel</strong></p>\r\n\r\n<ul>\r\n\t<li>Поехали! Или каким будет сезон-2021.</li>\r\n</ul>\r\n\r\n<p><strong>12:20 &mdash; 12:45<br />\r\nТом Дженкинс, генеральный директор Европейской туристической ассоциации (ETOA)</strong></p>\r\n\r\n<ul>\r\n\t<li>Похищение Европы: как будет восстанавливаться туризм, перспективы открытия стран.</li>\r\n</ul>\r\n\r\n<p><strong>12:45 &mdash; 13:10<br />\r\nОливер Мартин, член Исполнительного совета Туристической ассоциации стран Азии и Тихого океана (PATA), партнер в Twenty31 Consulting</strong></p>\r\n\r\n<ul>\r\n\t<li>Путь Азии &mdash; 2021: прогнозы по восстановлению турпотоков, новые возможности дестинаций и туроператоров.</li>\r\n</ul>\r\n\r\n<p><strong>13:10 &mdash; 13:35</strong><br />\r\n<strong>Андрей Игнатьев, президент Российского союза туриндустрии</strong></p>\r\n\r\n<ul>\r\n\t<li>Россия &mdash; перезагрузка: как поменялась ситуация на туристическом рынке за время пандемии.</li>\r\n</ul>\r\n\r\n<p><strong>13:35 &mdash; 14:00<br />\r\nЕгор Плахов, региональный директор Emirates по коммерческим операциям в Европе и Российской Федерации</strong></p>\r\n\r\n<ul>\r\n\t<li>Первым делом самолеты: серьезный разговор с&nbsp;Emirates о&nbsp;том, когда, куда и&nbsp;за&nbsp;сколько мы&nbsp;будем летать после коронакризиса.</li>\r\n</ul>\r\n\r\n<p><strong>14:00 &mdash; 14:40<br />\r\nОлеся Олейникова, директор по развитию Profi.Travel</strong></p>\r\n\r\n<ul>\r\n\t<li>Бизнес без границ: как в пандемию укрепить сотрудничество с зарубежными партнерами и найти новых? Уникальная система нетворкинга от Profi.Travel.</li>\r\n</ul>\r\n\r\n<p><strong>Сергей Перемутов, куратор программы лояльности для турбизнеса Profi.Travel Loyalty</strong></p>\r\n\r\n<ul>\r\n\t<li>Как укрепить сотрудничество с зарубежными партнерами и найти новых, когда границы закрыты: уникальность и преимущества новой системы нетворкинга от Profi.Travel.</li>\r\n</ul>",
  //     scheduleDescription:
  //       "Какие страны откроются для российских туристов быстрее других, какими будут ключевые тренды в сезоне-2021 и как новая система нетворкинга от Profi.Travel помогает не растерять бизнес-связи и приобрести новых партнеров в эпоху закрытых границ.",
  //     experts: [
  //       {
  //         id: 7721,
  //         sorting: 1,
  //         image:
  //           "https://cdn.profi.travel/local-storage/profi-travel/uploads/expert/photo/5f742f4db6685741719718.png",
  //         fullName: "Алексей Венгин",
  //         position: "CEO Profi.Travel",
  //       },
  //       {
  //         id: 7722,
  //         sorting: 2,
  //         image:
  //           "https://cdn.profi.travel/local-storage/profi-travel/uploads/expert/photo/606434101376f248077593.png",
  //         fullName: "Артем Чумак",
  //         position: "Главный редактор портала Profi.Travel",
  //       },
  //       {
  //         id: 7723,
  //         sorting: 3,
  //         image:
  //           "https://cdn.profi.travel/local-storage/profi-travel/uploads/expert/photo/606434b56fafc286910854.png",
  //         fullName: "Том Дженкинс",
  //         position: "Генеральный директор Европейской туристической ассоциации (ETOA)",
  //       },
  //       {
  //         id: 7724,
  //         sorting: 4,
  //         image:
  //           "https://cdn.profi.travel/local-storage/profi-travel/uploads/expert/photo/60643514d9629319568286.png",
  //         fullName: "Оливер Мартин",
  //         position:
  //           "Член Исполнительного совета Туристической ассоциации стран Азии и Тихого океана (PATA), партнер Twenty31 в Consulting",
  //       },
  //       {
  //         id: 7762,
  //         sorting: 5,
  //         image:
  //           "https://cdn.profi.travel/local-storage/profi-travel/uploads/expert/photo/606ef75e2e6ec037813810.png",
  //         fullName: "Андрей Игнатьев",
  //         position: "Президент Российского союза туриндустрии",
  //       },
  //       {
  //         id: 7725,
  //         sorting: 6,
  //         image:
  //           "https://cdn.profi.travel/local-storage/profi-travel/uploads/expert/photo/60645d0376029545769826.jpg",
  //         fullName: "Олеся Олейникова",
  //         position: "Директор по развитию Profi.Travel",
  //       },
  //       {
  //         id: 7726,
  //         sorting: 7,
  //         image:
  //           "https://cdn.profi.travel/local-storage/profi-travel/uploads/expert/photo/6064614641bb8508286528.png",
  //         fullName: "Сергей Перемутов",
  //         position: "Куратор программы лояльности для турбизнеса Profi.Travel Loyalty",
  //       },
  //     ],
  //     id: 23,
  //     type: "broadcast",
  //     title: "Торжественное открытие ОТМ: Лето 2021",
  //     viewsCount: 4449,
  //     participantsCount: 644,
  //     path: "/broadcast/23",
  //     date: "2021-04-12T12:00:00+03:00",
  //     dateEnd: "2021-04-12T15:00:00+03:00",
  //     status: 1,
  //     subscribed: true,
  //   },
  //   {
  //     label: null,
  //     companyTitle: "Гостиничная сеть Falkensteiner Hotels & Residences",
  //     description:
  //       "<ol>\r\n\t<li>Общая информация о&nbsp;Falkensteiner Hotels &amp;&nbsp;Residences&nbsp;&mdash; история бренда, девиз, география.</li>\r\n\t<li>Презентации отелей:\r\n\t<ul>\r\n\t\t<li><strong>Италия, Сардиния&nbsp;&mdash; Capo Boi&nbsp;5*:</strong>&nbsp;песчаный пляж, виллы до&nbsp;4&nbsp;спален, детский клуб и&nbsp;мини<strong>-</strong>зоопарк.</li>\r\n\t\t<li><strong>Италия, Венето&nbsp;&mdash; Hotel &amp;&nbsp;Spa Jesolo&nbsp;5*:</strong>&nbsp;один из&nbsp;двух отелей 5*&nbsp;в регионе с&nbsp;детским центром, пляжем и&nbsp;спа.</li>\r\n\t\t<li><strong>Австрия&nbsp;&mdash; Schlosshotel Velden&nbsp;5*:</strong>&nbsp;отель-замок на&nbsp;берегу озера, свой пляж, спа-центр.</li>\r\n\t\t<li><strong>Черногория, Бечичи&nbsp;&mdash; Hotel Montenegro&nbsp;4*:</strong>&nbsp;обновленные номера, песчано-галечный пляж, активности на&nbsp;территории отеля.</li>\r\n\t\t<li><strong>Хорватия, Пунта Скала&nbsp;&mdash; Hotel &amp;&nbsp;SPA Iadera&nbsp;5*, Family&nbsp;</strong><strong>H</strong><strong>otel Diaora&nbsp;4*, Premium&nbsp;</strong><strong>A</strong><strong>partments Senia</strong>: комплекс отелей с&nbsp;потрясающими возможностями для отдыха и&nbsp;MICE.</li>\r\n\t\t<li><strong>Хорватия, Задар, Борик&nbsp;&mdash;&nbsp;</strong>отели&nbsp;<strong>Club Funimation Borik&nbsp;4*</strong>,&nbsp;<strong>H</strong><strong>otel Adriana 4*</strong>&nbsp;для отдыха без детей, а&nbsp;также расположенный рядом комплекс&nbsp;<strong>Premium Camping Zadar</strong>&nbsp;со&nbsp;спа-центром Acquapura.</li>\r\n\t\t<li><strong>Чехия, Марианские Лазне&nbsp;&mdash; Spa Resort Marianske Lazne&nbsp;5*</strong>: идеальное место для восстановления и&nbsp;оздоровления.</li>\r\n\t\t<li><strong>Сербия, Белград&nbsp;&mdash; Hotel Belgrade&nbsp;4*</strong>: городской отель с&nbsp;детским клубом, возможностями для MICE и&nbsp;отдыха. Прямой эфир из&nbsp;отеля.</li>\r\n\t</ul>\r\n\t</li>\r\n</ol>",
  //     scheduleDescription: null,
  //     experts: [
  //       {
  //         id: 7729,
  //         sorting: 0,
  //         image:
  //           "https://cdn.profi.travel/local-storage/profi-travel/uploads/expert/photo/606464727de0c053759700.jpg",
  //         fullName: "Евгения Дунаева",
  //         position: "Менеджер по продажам в России",
  //       },
  //       {
  //         id: 7772,
  //         sorting: 0,
  //         image:
  //           "https://cdn.profi.travel/local-storage/profi-travel/uploads/expert/photo/6070047054a82662702476.jpg",
  //         fullName: "Таня Милошевич",
  //         position: "Менеджер по продажам Россия и СНГ",
  //       },
  //     ],
  //     id: 167027,
  //     type: "webinar",
  //     title:
  //       "Летний сезон — 2021 в Европе: отдых на озерах, лечение и восстановление организма. Онлайн-включение из отеля в Белграде!",
  //     viewsCount: 115,
  //     participantsCount: 673,
  //     path: "/events/webinars/show/167027",
  //     date: "2021-04-12T15:00:00+03:00",
  //     dateEnd: "2021-04-12T16:00:00+03:00",
  //     status: 1,
  //     subscribed: false,
  //   },
  //   {
  //     label: null,
  //     companyTitle: "Греческая Национальная Туристическая Организация",
  //     description:
  //       "<ul>\r\n\t<li>Греция после пандемии: апдейт по&nbsp;ситуации в&nbsp;стране.</li>\r\n\t<li>Откроется&nbsp;ли Греция 14&nbsp;мая? Прогнозы представителя ГНТО.</li>\r\n\t<li>Какие протоколы безопасности нужно будет соблюдать туристам?</li>\r\n\t<li>Как страна готовится к&nbsp;возобновлению турпотока?</li>\r\n\t<li>Какие отели возобновят работу и&nbsp;как будет организовано пребывание в&nbsp;них после карантина?</li>\r\n\t<li>Какие виды туризма станут приоритетными в&nbsp;этом сезоне?</li>\r\n\t<li>Как турагентам взаимодействовать с&nbsp;клиентами, чтобы успешно продавать направление?</li>\r\n</ul>",
  //     scheduleDescription: null,
  //     experts: [
  //       {
  //         id: 7773,
  //         sorting: 0,
  //         image:
  //           "https://cdn.profi.travel/local-storage/profi-travel/uploads/expert/photo/5af19fc3bba92273651856.jpeg",
  //         fullName: "Георгий Мавроматис",
  //         position: "Специалист по маркетингу Греческой Национальной Туристической Организации",
  //       },
  //     ],
  //     id: 167061,
  //     type: "webinar",
  //     title:
  //       "Осуществится ли план по открытию Греции 14 мая и какая сейчас обстановка в стране? Подробности и прогнозы представителя ГНТО",
  //     viewsCount: 211,
  //     participantsCount: 650,
  //     path: "/events/webinars/show/167061",
  //     date: "2021-04-13T11:00:00+03:00",
  //     dateEnd: "2021-04-13T13:00:00+03:00",
  //     status: 1,
  //     subscribed: true,
  //   },
  //   {
  //     label: null,
  //     companyTitle: "Курорт Porto Carras Grand Resort",
  //     description:
  //       "<ul>\r\n\t<li>Видеоэкскурсия по основным объектам Porto Carras.</li>\r\n\t<li>Презентация Porto Carras Meliton и всех видов номеров.</li>\r\n\t<li>Винодельня Domaine Porto Carras &mdash; крупнейший органический виноградник в Греции.</li>\r\n\t<li>Зеленая территория комплекса, 9 км песчаных пляжей и 25 бухт.</li>\r\n\t<li>Досуг: водные горки, гольф, дайвинг, казино, талассотерапия, верховая езда и многое другое.</li>\r\n\t<li><strong>Розыгрыш двух ночей на полупансионе с дегустацией вина для двоих в Domaine Porto Carras!</strong></li>\r\n</ul>",
  //     scheduleDescription: null,
  //     experts: [
  //       {
  //         id: 7744,
  //         sorting: 0,
  //         image:
  //           "https://cdn.profi.travel/local-storage/profi-travel/uploads/expert/photo/6069a01d4069a463328626.jpg",
  //         fullName: "Татьяна Веденеева",
  //         position: "Sales Representation SK Hospitality",
  //       },
  //     ],
  //     id: 167039,
  //     type: "webinar",
  //     title:
  //       "Презентация курорта с новой структурой и новым менеджментом. Розыгрыш отдыха на Халкидиках!",
  //     viewsCount: 106,
  //     participantsCount: 821,
  //     path: "/events/webinars/show/167039",
  //     date: "2021-04-13T13:00:00+03:00",
  //     dateEnd: "2021-04-13T14:00:00+03:00",
  //     status: 1,
  //     subscribed: true,
  //   },
  //   {
  //     label: null,
  //     companyTitle: "Отель Kassandra Palace",
  //     description:
  //       "<p><strong>Знакомство с семейным отелем Kassandra Palace Hotel &amp; Spa:&nbsp;</strong></p>\r\n\r\n<ol>\r\n\t<li>Варианты размещения: множество бунгало с элегантно оформленными номерами и сьютами.</li>\r\n\t<li>Питание:&nbsp;3 ресторана и 3 бара.&nbsp;</li>\r\n\t<li>Досуг:&nbsp;SPA,&nbsp;велнес-центр, 3 открытых бассейна, мини-клуб и другие развлечения.</li>\r\n\t<li><strong>Розыгрыш&nbsp;трех ночей на полупансионе и двух фирменных коктейлей у нового бассейна!</strong></li>\r\n</ol>",
  //     scheduleDescription: null,
  //     experts: [
  //       {
  //         id: 7743,
  //         sorting: 0,
  //         image:
  //           "https://cdn.profi.travel/local-storage/profi-travel/uploads/expert/photo/6065ee1e9b0bf917268126.jpg",
  //         fullName: "Татьяна Веденеева",
  //         position: "Торговый представитель SK Hospitality",
  //       },
  //     ],
  //     id: 167038,
  //     type: "webinar",
  //     title:
  //       "«Пятизвездочный» семейный отдых на Халкидиках: спа-центр, греческая кухня и номера на любой вкус. Розыгрыш проживания!",
  //     viewsCount: 100,
  //     participantsCount: 796,
  //     path: "/events/webinars/show/167038",
  //     date: "2021-04-13T14:00:00+03:00",
  //     dateEnd: "2021-04-13T15:00:00+03:00",
  //     status: 1,
  //     subscribed: true,
  //   },
  //   {
  //     label: null,
  //     companyTitle: "Сеть отелей MarBella Collection",
  //     description:
  //       "<ol>\r\n\t<li><strong>MarBella Corfu:</strong>\r\n\t<ul>\r\n\t\t<li>семейный отдых премиум-уровня на&nbsp;базе питания &laquo;полупансион&raquo; или &laquo;все включено&raquo;;</li>\r\n\t\t<li>инфраструктура: 388 номеров и&nbsp;сьютов, 4&nbsp;ресторана, 4&nbsp;бара, 2&nbsp;бассейна (Infinity и&nbsp;Lagoon), SPA, тренажерный зал, приватный пляж;</li>\r\n\t\t<li>развлечения: аквапарк, детский клуб, ясли, приключенческий клуб, экскурсии, спорт, водные активности, ночное кино, пляжные вечеринки, живая музыка.</li>\r\n\t</ul>\r\n\t</li>\r\n\t<li><strong>MarBella Nido:</strong>\r\n\t<ul>\r\n\t\t<li>бутик-отель класса люкс с&nbsp;панорамными видами на&nbsp;Ионическое море;</li>\r\n\t\t<li>инфраструктура: 70&nbsp;сьютов, 2&nbsp;ресторана, 2&nbsp;бара, Оранжерея и&nbsp;Патио Лаундж, SPA, тренажерный зал, приватный пляж;</li>\r\n\t\t<li>фишки отеля: персонализированный сервис, размещение 18+;</li>\r\n\t\t<li>развлечения Tailor Made: дегустация вина, кулинарные мастер-классы, воскресный полдник в&nbsp;сопровождении живой музыки.</li>\r\n\t</ul>\r\n\t</li>\r\n\t<li><strong>MarBella Elix:</strong>\r\n\t<ul>\r\n\t\t<li>расположение: материковая Греция, Теспроти, пляж Каравостаси&nbsp;&mdash; рядом Парга, река Ахерон, Метеора, Загори;</li>\r\n\t\t<li>услуги: 3&nbsp;бара, 2&nbsp;ресторана, SPA, тренажерный зал, теннисный корт, дневные и&nbsp;вечерние мероприятия, активный отдых для детей и&nbsp;подростков, услуги няни (по&nbsp;запросу), фуникулер на&nbsp;оборудованный пляж.</li>\r\n\t</ul>\r\n\t</li>\r\n\t<li><strong>Обзор мобильного приложения MarBella Collection Contactless Journey.</strong></li>\r\n</ol>",
  //     scheduleDescription: null,
  //     experts: [
  //       {
  //         id: 7754,
  //         sorting: 0,
  //         image:
  //           "https://cdn.profi.travel/local-storage/profi-travel/uploads/expert/photo/606ea2ecb7ed7767281461.png",
  //         fullName: "Милана Тонева",
  //         position: "Представитель компании MarBella Collection в России и странах СНГ",
  //       },
  //     ],
  //     id: 167046,
  //     type: "webinar",
  //     title:
  //       "Отели на Корфу и Каравостаси в Греции: семейный отдых премиум-уровня, бутик-отель 18+ и мобильное приложение для туристов",
  //     viewsCount: 118,
  //     participantsCount: 712,
  //     path: "/events/webinars/show/167046",
  //     date: "2021-04-13T15:00:00+03:00",
  //     dateEnd: "2021-04-13T16:00:00+03:00",
  //     status: 1,
  //     subscribed: true,
  //   },
  //   {
  //     label: null,
  //     companyTitle: "Принимающая компания Kalamaki Travel",
  //     description:
  //       "<ul>\r\n\t<li>Остров Крит и&nbsp;его особенности.</li>\r\n\t<li>Регионы острова и&nbsp;их&nbsp;направленность.</li>\r\n\t<li>Новинки сезона-2021.</li>\r\n\t<li>Чем удобно сотрудничество с&nbsp;Kalamaki Travel?</li>\r\n\t<li><strong>Розыгрыш проживаний: 3&nbsp;ночи в&nbsp;отеле Stefan Village 4*,&nbsp;3&nbsp;ночи в&nbsp;отеле Kavros Beach&nbsp;3*, 7 ночей в отеле Galini Sea View 5* и 7 ночей в отеле Airis Boutique Hotel &amp; Suites 4*!</strong></li>\r\n</ul>",
  //     scheduleDescription: null,
  //     experts: [
  //       {
  //         id: 7769,
  //         sorting: 0,
  //         image:
  //           "https://cdn.profi.travel/local-storage/profi-travel/uploads/expert/photo/606f673f5e06b357755597.jpg",
  //         fullName: "Евгения Морозова",
  //         position: "Руководитель отдела продаж Kalamaki Travel",
  //       },
  //     ],
  //     id: 167058,
  //     type: "webinar",
  //     title:
  //       "Крит: обзор направления от принимающего туроператора и новинки сезона-2021. Розыгрыш проживаний в четырех отелях!",
  //     viewsCount: 138,
  //     participantsCount: 641,
  //     path: "/events/webinars/show/167058",
  //     date: "2021-04-13T16:00:00+03:00",
  //     dateEnd: "2021-04-13T17:00:00+03:00",
  //     status: 1,
  //     subscribed: true,
  //   },
  //   {
  //     label: null,
  //     companyTitle: "Сеть курортов и отелей JA Resorts & Hotels",
  //     description:
  //       "<ol>\r\n\t<li>Новости и&nbsp;новинки JA&nbsp;Resorts &amp;&nbsp;Hotels.</li>\r\n\t<li>Открытие JA&nbsp;Lake View Hotel.</li>\r\n\t<li>Популярные отели на&nbsp;The Walk, JBR.</li>\r\n\t<li>Новой резорт на&nbsp;Сейшелах&nbsp;&mdash; Enchanted Waterfront Villas.</li>\r\n\t<li>Идиллия на&nbsp;Мальдивском острове&nbsp;&mdash; JA&nbsp;Manafaru.</li>\r\n</ol>",
  //     scheduleDescription: null,
  //     experts: [
  //       {
  //         id: 7759,
  //         sorting: 0,
  //         image:
  //           "https://cdn.profi.travel/local-storage/profi-travel/uploads/expert/photo/5f7c244bb612c503284793.jpg",
  //         fullName: "Анастасия Коваленко",
  //         position: "Менеджер по продажам сети отелей JA Resorts & Hotels",
  //       },
  //     ],
  //     id: 167050,
  //     type: "webinar",
  //     title: "Незабываемый отдых летом 2021-го с новинками сети отелей в ОАЭ и Индийском океане!",
  //     viewsCount: 84,
  //     participantsCount: 641,
  //     path: "/events/webinars/show/167050",
  //     date: "2021-04-14T11:00:00+03:00",
  //     dateEnd: "2021-04-14T12:00:00+03:00",
  //     status: 1,
  //     subscribed: false,
  //   },
  //   {
  //     label: null,
  //     companyTitle: "Отель Hotel Indigo Dubai Downtown",
  //     description:
  //       "<ol>\r\n\t<li>Презентация первого арт-бутик-отеля в эмиратах в сердце Дубая.</li>\r\n\t<li>Услуги и&nbsp;возможности для туристов: ресторан, бар, бизнес-центр, бесплатная&nbsp;частная&nbsp;парковка, открытый&nbsp;бассейн и фитнес-центр.</li>\r\n\t<li>Питание:&nbsp;континентальный завтрак или завтрак &mdash; шведский стол.</li>\r\n\t<li><strong>Розыгрыш призов!</strong></li>\r\n</ol>",
  //     scheduleDescription: null,
  //     experts: [
  //       {
  //         id: 7745,
  //         sorting: 0,
  //         image:
  //           "https://cdn.profi.travel/local-storage/profi-travel/uploads/expert/photo/606726f93b5ba469209721.jpg",
  //         fullName: "Дания Жумашева",
  //         position: "Менеджер по развитию бизнеса в Hotel Indigo Dubai Downtown",
  //       },
  //     ],
  //     id: 167040,
  //     type: "webinar",
  //     title:
  //       "Первый арт-бутик-отель в эмиратах! Знакомство с уголком арабской культуры в самом центре Дубая. Розыгрыш призов!",
  //     viewsCount: 66,
  //     participantsCount: 769,
  //     path: "/events/webinars/show/167040",
  //     date: "2021-04-14T12:00:00+03:00",
  //     dateEnd: "2021-04-14T13:00:00+03:00",
  //     status: 1,
  //     subscribed: false,
  //   },
  //   {
  //     label: null,
  //     companyTitle: "Комплекс отелей Caesars Palace Dubai",
  //     description:
  //       "<ol>\r\n\t<li>Объекты на острове Bluewaters: luxury-отель Caesars Palace Dubai, самое большое в мире колесо обозрения Ain Dubai, резиденции, рестораны, игровые площадки, сады и развлекательные комплексы.&nbsp;</li>\r\n\t<li>Ребрендинг. Новая концепция отеля Caesars Palace Dubai: атмосфера Древнего Рима и роскошный отдых для пар и всей семьи &mdash; от королевского спа до детского клуба Empire Club:\r\n\t<ul>\r\n\t\t<li>Palace Tower;</li>\r\n\t\t<li>Julius Tower;</li>\r\n\t\t<li>Apartments и The Residences.</li>\r\n\t</ul>\r\n\t</li>\r\n\t<li>Hell&rsquo;s Kitchen&nbsp;&mdash; второй в&nbsp;мире ресторан Гордона Рамзи:\r\n\t<ul>\r\n\t\t<li>удостоен нескольких звезд Мишлен;</li>\r\n\t\t<li>кулинарное шоу мирового класса;</li>\r\n\t\t<li>фирменные блюда Шефа: бургеры, пудинг и&nbsp;знаменитая говядина &laquo;Веллингтон&raquo;.</li>\r\n\t</ul>\r\n\t</li>\r\n\t<li>Молодежная тусовка ROAM&nbsp;&mdash; креативное пространство с&nbsp;игровыми зонами для подростков.</li>\r\n\t<li>Специальные предложения для семей на лето: семейные категории номеров.&nbsp;</li>\r\n\t<li>Коллекция предметов искусства Caesars Palace Dubai от&nbsp;американского дизайнера Джонатана Адлера и&nbsp;другие &laquo;фишки&raquo; отеля.</li>\r\n</ol>",
  //     scheduleDescription: null,
  //     experts: [
  //       {
  //         id: 7775,
  //         sorting: 0,
  //         image:
  //           "https://cdn.profi.travel/local-storage/profi-travel/uploads/expert/photo/5e2184f18897b573779294.jpg",
  //         fullName: "Татьяна Шумилова",
  //         position: "Senior Sales Manager",
  //       },
  //     ],
  //     id: 167062,
  //     type: "webinar",
  //     title:
  //       "Знакомство с отелем-островом в Дубае: 500-метровый пляж, «Адская кухня» Гордона Рамзи и королевский спа-центр",
  //     viewsCount: 62,
  //     participantsCount: 500,
  //     path: "/events/webinars/show/167062",
  //     date: "2021-04-14T13:00:00+03:00",
  //     dateEnd: "2021-04-14T14:00:00+03:00",
  //     status: 1,
  //     subscribed: false,
  //   },
  //   {
  //     label: null,
  //     companyTitle:
  //       "Отели Le Meridien Al Aqah Beach Hotel, JW Marriott Marquis Dubai Hotel, Al Maha, a Luxury Collection Desert Resort & Spa",
  //     description:
  //       "<ol>\r\n\t<li>Новости из Объединенных Арабских Эмиратов.</li>\r\n\t<li><strong>Le Meridien Al Aqah Beach Resort:</strong> обновленные номера после реновации 2014 года, типы питания и развлечения.</li>\r\n\t<li><strong>JW Marriott Marquis Dubai Hotel:</strong> знакомство с самым высоким в мире пятизвездочным отелем.</li>\r\n\t<li><strong>Al Maha, a Luxury Collection Desert Resort and Spa:</strong> роскошный отель в пустыне, на территории Национального Дубайского Заповедника.</li>\r\n</ol>",
  //     scheduleDescription: null,
  //     experts: [
  //       {
  //         id: 7770,
  //         sorting: 0,
  //         image:
  //           "https://cdn.profi.travel/local-storage/profi-travel/uploads/expert/photo/5f777836a119d508513943.jpg",
  //         fullName: "Нигяр Самедова",
  //         position:
  //           "Менеджер по продажам отелей Le Meridien Al Aqah Beach Hotel, JW Marriott Marquis Dubai Hotel, Al Maha, a Luxury Collection Desert Resort & Spa",
  //       },
  //     ],
  //     id: 167059,
  //     type: "webinar",
  //     title:
  //       "Три уникальных отеля Marriott International в ОАЭ: откройте туристам величие арабской культуры!",
  //     viewsCount: 53,
  //     participantsCount: 602,
  //     path: "/events/webinars/show/167059",
  //     date: "2021-04-14T14:00:00+03:00",
  //     dateEnd: "2021-04-14T15:00:00+03:00",
  //     status: 1,
  //     subscribed: true,
  //   },
  //   {
  //     label: null,
  //     companyTitle: "Сеть отелей Rotana Hotels & Resorts",
  //     description:
  //       "<ol>\r\n\t<li>Amwaj Rotana Dubai 5*&nbsp;и&nbsp;новые семейные номера.</li>\r\n\t<li>Rose Rayhaan 4*&nbsp;с увеличенным количеством трансферов на&nbsp;пляж.</li>\r\n\t<li>Обзоры отелей Towers Rotana&nbsp;4*, Media Rotana&nbsp;5*, Al&nbsp;Bandar Rotana&nbsp;5*, Jumeira Rotana&nbsp;4*, Centro Barsha 3*&nbsp;и&nbsp;Centro Sharjah&nbsp;3*.</li>\r\n\t<li>Новинка Дубая&nbsp;&mdash; Al&nbsp;Jaddaf Rotana deluxe. Открылся в&nbsp;2020&nbsp;году!</li>\r\n\t<li><strong>Розыгрыш ваучера на проживание!&nbsp;</strong></li>\r\n</ol>",
  //     scheduleDescription: null,
  //     experts: [
  //       {
  //         id: 7755,
  //         sorting: 0,
  //         image:
  //           "https://cdn.profi.travel/local-storage/profi-travel/uploads/expert/photo/5f7c8367c5a3d132567308.png",
  //         fullName: "Надежда Щербакова",
  //         position: "Директор по продажам Rotana Hotels & Resorts в России",
  //       },
  //     ],
  //     id: 167047,
  //     type: "webinar",
  //     title: "Новости сети отелей в Дубае и Шардже. Розыгрыш ваучера на проживание!",
  //     viewsCount: 71,
  //     participantsCount: 767,
  //     path: "/events/webinars/show/167047",
  //     date: "2021-04-14T15:00:00+03:00",
  //     dateEnd: "2021-04-14T16:00:00+03:00",
  //     status: 1,
  //     subscribed: true,
  //   },
  //   {
  //     label: null,
  //     companyTitle: "Сеть отелей Rotana Hotels & Resorts",
  //     description:
  //       "<ul>\r\n\t<li>Отели Дубая и&nbsp;Шарджи:\r\n\t<ul>\r\n\t\t<li>новые семейные номера 42&nbsp;кв.&nbsp;м&nbsp;Amwaj Rotana Dubai&nbsp;5*;</li>\r\n\t\t<li>Rose Rayhaan&nbsp;4*: увеличение количества трансферов на&nbsp;пляж;</li>\r\n\t\t<li>Towers Rotana&nbsp;4*, Media Rotana&nbsp;5*, Al&nbsp;Bandar Rotana&nbsp;5*, Jumeira Rotana&nbsp;4*, Centro Barsha 3*&nbsp;&amp; Centro Sharjah&nbsp;3*, новинка Дубая 2020&nbsp;&mdash;&nbsp;Al&nbsp;Jaddaf Rotana*;</li>\r\n\t</ul>\r\n\t</li>\r\n\t<li>Fujairah Rotana Resort &amp;&nbsp;SPA 5*&nbsp;&mdash; презентация отеля после ремонта, новые категории номеров и&nbsp;системы питания в&nbsp;деталях;</li>\r\n\t<li>Saadiyat Rotana Resort &amp;&nbsp;SPA 5*&nbsp;&mdash; категории номеров и&nbsp;система питания в&nbsp;деталях.</li>\r\n\t<li><strong>Розыгрыш ваучера на проживание!&nbsp;</strong></li>\r\n</ul>",
  //     scheduleDescription: null,
  //     experts: [
  //       {
  //         id: 7748,
  //         sorting: 0,
  //         image:
  //           "https://cdn.profi.travel/local-storage/profi-travel/uploads/expert/photo/5f7c841d3f10c161494351.jpg",
  //         fullName: "Жанна Злобина",
  //         position: "Менеджер по продажам, Rotana Hotels & Resorts",
  //       },
  //       {
  //         id: 7749,
  //         sorting: 0,
  //         image:
  //           "https://cdn.profi.travel/local-storage/profi-travel/uploads/expert/photo/606f2cb6554b0565233702.jpg",
  //         fullName: "Ирина Шустваль",
  //         position: "Sales Manager, Rotana Hotels & Resorts",
  //       },
  //     ],
  //     id: 167042,
  //     type: "webinar",
  //     title:
  //       "Обзор отелей Fujairah Rotana после ремонта и Saadiyat Rotana 5* deluxe в Абу-Даби. Розыгрыш проживания!",
  //     viewsCount: 97,
  //     participantsCount: 745,
  //     path: "/events/webinars/show/167042",
  //     date: "2021-04-14T16:00:00+03:00",
  //     dateEnd: "2021-04-14T17:00:00+03:00",
  //     status: 1,
  //     subscribed: true,
  //   },
  //   {
  //     label: null,
  //     companyTitle: "Министерство по туризму Республики Кипр",
  //     description:
  //       "<ol>\r\n\t<li>Как туристам попасть на Кипр без карантина?</li>\r\n\t<li>Что нужно знать агенту перед продажей тура?</li>\r\n\t<li>Правила въезда на остров, протоколы безопасности: CyprusFlightPass, ПЦР-тест за 72 часа до вылета и другие требования для въезда.</li>\r\n</ol>",
  //     scheduleDescription: null,
  //     experts: [
  //       {
  //         id: 7771,
  //         sorting: 0,
  //         image:
  //           "https://cdn.profi.travel/local-storage/profi-travel/uploads/expert/photo/606f0b95712ee779058839.png",
  //         fullName: "Мария Михайлова",
  //         position: "Менеджер по маркетингу, Министерство Туризма Кипра",
  //       },
  //     ],
  //     id: 167060,
  //     type: "webinar",
  //     title:
  //       "Кипр открыт для россиян с 1 апреля! Правила въезда на остров, протоколы безопасности: что нужно знать агенту перед продажей тура?",
  //     viewsCount: 313,
  //     participantsCount: 894,
  //     path: "/events/webinars/show/167060",
  //     date: "2021-04-15T10:00:00+03:00",
  //     dateEnd: "2021-04-15T11:00:00+03:00",
  //     status: 1,
  //     subscribed: false,
  //   },
  //   {
  //     label: null,
  //     companyTitle: "Сеть отелей Rotana Hotels & Resorts",
  //     description:
  //       "<ul>\r\n\t<li>Прямое включение с&nbsp;отелем Grand Rotana Resort &amp;&nbsp;SPA 5*&nbsp;&mdash; презентация от&nbsp;представителя отеля в&nbsp;деталях, все категории номеров и&nbsp;системы питания.</li>\r\n\t<li>Обзор новых номеров после ремонта.</li>\r\n\t<li><strong>Розыгрыш ваучера на проживание!&nbsp;</strong></li>\r\n</ul>",
  //     scheduleDescription: null,
  //     experts: [
  //       {
  //         id: 7757,
  //         sorting: 0,
  //         image:
  //           "https://cdn.profi.travel/local-storage/profi-travel/uploads/expert/photo/606ec4d667ff1451627181.png",
  //         fullName: "Елена Иванушкина",
  //         position: "Менеджер по продажам Grand Rotana Resort & SPA, Sharm El Sheikh",
  //       },
  //     ],
  //     id: 167048,
  //     type: "webinar",
  //     title:
  //       "Отель Grand Rotana 5* deluxe в Шарм-эль-Шейхе — новости и презентация в деталях. Розыгрыш проживания!",
  //     viewsCount: 69,
  //     participantsCount: 811,
  //     path: "/events/webinars/show/167048",
  //     date: "2021-04-15T11:00:00+03:00",
  //     dateEnd: "2021-04-15T12:00:00+03:00",
  //     status: 1,
  //     subscribed: false,
  //   },
  //   {
  //     label: null,
  //     companyTitle: "Сеть отелей Leptos Calypso Hotels",
  //     description:
  //       "<ul>\r\n\t<li>Краткое знакомство с&nbsp;группой Leptos Calypso.</li>\r\n\t<li>Описание отеля Coral Beach&nbsp;5*: локация, основные преимущества, спортивные возможности и&nbsp;MICE, анонс открытия.</li>\r\n\t<li>Краткое описание отеля Paphos Gardens&nbsp;3*: инфраструктура, локация, преимущества.</li>\r\n\t<li>Возможности Кипра, преимущества направления.</li>\r\n</ul>",
  //     scheduleDescription: null,
  //     experts: [
  //       {
  //         id: 7768,
  //         sorting: 0,
  //         image:
  //           "https://cdn.profi.travel/local-storage/profi-travel/uploads/expert/photo/606f5b1c8f5b2648318072.png",
  //         fullName: "Лайма Венде",
  //         position: "Представитель группы Leptos Calypso Hotels",
  //       },
  //     ],
  //     id: 167057,
  //     type: "webinar",
  //     title:
  //       "Отели на Кипре: Paphos Gardens Holiday Resort в центре курорта и крупнейший на побережье отель 5* The Coral Beach Hotel & Resort",
  //     viewsCount: 92,
  //     participantsCount: 639,
  //     path: "/events/webinars/show/167057",
  //     date: "2021-04-15T12:00:00+03:00",
  //     dateEnd: "2021-04-15T13:00:00+03:00",
  //     status: 1,
  //     subscribed: false,
  //   },
  //   {
  //     label: null,
  //     companyTitle: "Принимающая компания CARPE-DIEM Travel",
  //     description:
  //       "<ul>\r\n\t<li>Обзор авторских туров в&nbsp;Камеруне: приключенческое сафари и&nbsp;другие яркие предложения лета.</li>\r\n\t<li>Презентация апарт- и&nbsp;бутик-отелей на&nbsp;Кипре, в&nbsp;Турции и&nbsp;Грузии.</li>\r\n\t<li><strong>Розыгрыш призов!</strong></li>\r\n</ul>",
  //     scheduleDescription: null,
  //     experts: [
  //       {
  //         id: 7777,
  //         sorting: 0,
  //         image: null,
  //         fullName: "Сергей Червяк",
  //         position: "Генеральный директор",
  //       },
  //     ],
  //     id: 167064,
  //     type: "webinar",
  //     title:
  //       "Приключенческое сафари в Камеруне и гид по Кипру — где отдохнуть и что посмотреть летом-2021? Розыгрыш призов!",
  //     viewsCount: 89,
  //     participantsCount: 572,
  //     path: "/events/webinars/show/167064",
  //     date: "2021-04-15T13:00:00+03:00",
  //     dateEnd: "2021-04-15T14:00:00+03:00",
  //     status: 1,
  //     subscribed: false,
  //   },
  //   {
  //     label: null,
  //     companyTitle: "Отель Bellis Deluxe Hotel 5*, Турция, Белек",
  //     description:
  //       "<ol>\r\n\t<li>Общая информация об&nbsp;отеле.</li>\r\n\t<li>Последние новинки и&nbsp;реновация отеля.</li>\r\n\t<li>Анимационная программа на&nbsp;летний сезон 2021&nbsp;года.</li>\r\n\t<li>Постпандемический период отеля и&nbsp;ситуация в&nbsp;Турции на&nbsp;данный момент.</li>\r\n\t<li><strong>Розыгрыш четырех ночей в&nbsp;отеле Bellis Deluxe!</strong></li>\r\n</ol>",
  //     scheduleDescription: null,
  //     experts: [
  //       {
  //         id: 7761,
  //         sorting: 0,
  //         image:
  //           "https://cdn.profi.travel/local-storage/profi-travel/uploads/expert/photo/606583fabfb49831071880.jpg",
  //         fullName: "Анастасия Шаваринская",
  //         position: "Представитель отдела маркетинга и продаж",
  //       },
  //     ],
  //     id: 167052,
  //     type: "webinar",
  //     title:
  //       "Традиционная встреча с отелем в Белеке: последние новинки, планы на летний сезон 2021 года и розыгрыш отдыха!",
  //     viewsCount: 64,
  //     participantsCount: 801,
  //     path: "/events/webinars/show/167052",
  //     date: "2021-04-16T11:00:00+03:00",
  //     dateEnd: "2021-04-16T12:00:00+03:00",
  //     status: 1,
  //     subscribed: false,
  //   },
  //   {
  //     label: null,
  //     companyTitle: "Сеть отелей Barut Hotels",
  //     description:
  //       "<ol>\r\n\t<li>Особенности и&nbsp;нюансы продаж.</li>\r\n\t<li>Последние новинки сети за&nbsp;2019&nbsp;&mdash; 2021&nbsp;гг.: изменение концепции, выход на&nbsp;рынок СНГ отеля Barut Sunwing Side Beach&nbsp;4*.</li>\r\n</ol>",
  //     scheduleDescription: null,
  //     experts: [
  //       {
  //         id: 7735,
  //         sorting: 0,
  //         image:
  //           "https://cdn.profi.travel/local-storage/profi-travel/uploads/expert/photo/605f25d8b56ef724032574.jpg",
  //         fullName: "Анна Кондратова",
  //         position: "Представитель Barut Hotels на рынке СНГ",
  //       },
  //     ],
  //     id: 167033,
  //     type: "webinar",
  //     title: "Отдых в Турции: описание отелей, особенности продаж и новинки сети",
  //     viewsCount: 88,
  //     participantsCount: 790,
  //     path: "/events/webinars/show/167033",
  //     date: "2021-04-16T12:00:00+03:00",
  //     dateEnd: "2021-04-16T14:00:00+03:00",
  //     status: 1,
  //     subscribed: false,
  //   },
  //   {
  //     label: null,
  //     companyTitle: "Отель Riolavitas SPA & Resort 5*, Турция",
  //     description:
  //       "<ol>\r\n\t<li>История и&nbsp;задачи компании.</li>\r\n\t<li>Общая информация об&nbsp;отеле.</li>\r\n\t<li>Здоровый безопасный туризм и&nbsp;другие новинки летнего сезона&nbsp;&mdash; 2021.</li>\r\n\t<li>Партнеры, раннее бронирование.</li>\r\n\t<li>Бонусная программа для турагентов.</li>\r\n\t<li><strong>Розыгрыш бесплатного отдыха на&nbsp;двоих в&nbsp;октябре 2021 года на&nbsp;7&nbsp;ночей по&nbsp;системе &laquo;ультра все включено&raquo;!</strong></li>\r\n</ol>",
  //     scheduleDescription: null,
  //     experts: [
  //       {
  //         id: 7705,
  //         sorting: 0,
  //         image:
  //           "https://cdn.profi.travel/local-storage/profi-travel/uploads/expert/photo/5e16d2ba99657037266651.jpg",
  //         fullName: "Чинара Балиймез",
  //         position: "Руководитель отдела продаж и маркетинга, Турция, Анталья — Манавгат",
  //       },
  //     ],
  //     id: 167021,
  //     type: "webinar",
  //     title:
  //       "Здоровый безопасный туризм и новинки лета-2021. Розыгрыш отдыха для двоих на 7 ночей по системе «ультра все включено»!",
  //     viewsCount: 53,
  //     participantsCount: 778,
  //     path: "/events/webinars/show/167021",
  //     date: "2021-04-16T14:00:00+03:00",
  //     dateEnd: "2021-04-16T15:00:00+03:00",
  //     status: 1,
  //     subscribed: false,
  //   },
  //   {
  //     label: null,
  //     companyTitle: "Отель Regnum Carya, Турция",
  //     description:
  //       "<ul>\r\n\t<li>Знакомство c&nbsp;Regnum Carya: новинки 2021&nbsp;года, концепция, особенности, детский концепт, гольф днем и&nbsp;ночью.</li>\r\n\t<li>&laquo;Фишки&raquo; отеля:\r\n\t<ul>\r\n\t\t<li>концепт Luxury All Inclusive и&nbsp;трансфер на&nbsp;вертолете;</li>\r\n\t\t<li>пляж с&nbsp;белоснежным песком, пирс с&nbsp;павильонами и&nbsp;джакузи и&nbsp;плавательный бассейн без химии;</li>\r\n\t\t<li>первое и&nbsp;единственное в&nbsp;Европе гольф-поле, освещаемое ночью;</li>\r\n\t\t<li>бесплатные услуги Fast Track и&nbsp;CIP Lounge;</li>\r\n\t\t<li>посещение Land of&nbsp;Legends;</li>\r\n\t\t<li>тайский и&nbsp;японский рестораны а-ля карт;</li>\r\n\t\t<li>реновации в проживании: перепланировка в вилле Crown, обогащение концепции номеров Pearl Pool Suite и Pearl Pool Family, переименование номеров и вилл, пещера Cave виллы Crown;</li>\r\n\t\t<li>летние концерты с&nbsp;участием мировых звезд: Дженнифер Лопез, Тома Джонса, Энн-Мари, Джейсона Деруло, Дуа Липа и&nbsp;не&nbsp;только.</li>\r\n\t</ul>\r\n\t</li>\r\n\t<li>Большой шаг в&nbsp;клеточной регенерации: применение технологии Indiba Deep Care.</li>\r\n\t<li>Уроки футбола у&nbsp;тренеров всемирно известного футбольного клуба Real Madrid Foundation для детей от&nbsp;6&nbsp;до&nbsp;16&nbsp;лет.</li>\r\n\t<li>Обновленный пляж и новый ресторан ALIA.</li>\r\n</ul>",
  //     scheduleDescription: null,
  //     experts: [
  //       {
  //         id: 7751,
  //         sorting: 0,
  //         image:
  //           "https://cdn.profi.travel/local-storage/profi-travel/uploads/expert/photo/5e26e8db94328167022421.jpg",
  //         fullName: "Екатерина Штерн",
  //         position: "Руководитель продаж по странам СНГ и России, отель Regnum Carya",
  //       },
  //     ],
  //     id: 167044,
  //     type: "webinar",
  //     title:
  //       "Отдых класса люкс в Белеке: уникальное поле для гольфа, концерты мировых звезд и клеточное омоложение в спа-центре!",
  //     viewsCount: 70,
  //     participantsCount: 715,
  //     path: "/events/webinars/show/167044",
  //     date: "2021-04-16T15:00:00+03:00",
  //     dateEnd: "2021-04-16T16:00:00+03:00",
  //     status: 1,
  //     subscribed: false,
  //   },
  //   {
  //     label: "Деловая программа",
  //     companyTitle: null,
  //     description:
  //       "<p><strong>16:00 &mdash; 16:05<br />\r\nДенис Юлин, редактор Profi.Travel</strong></p>\r\n\r\n<ul>\r\n\t<li>В одночасье рынок лишился главного и самого массового направления. Обязаны ли туроператоры возвращать туристам деньги? На что заменить Турцию и как удержать разъяренного клиента?</li>\r\n</ul>\r\n\r\n<p><strong>16:05 &mdash; 16:30<br />\r\nАдем Суверен, руководитель отдела продаж направления Россия и страны СНГ сети Barut Hotels</strong></p>\r\n\r\n<ul>\r\n\t<li>Как Турция будет улучшать эпид-ситуацию, чтобы открыться 1 июня: новые ограничения в стране. Как кризис повлияет на цены и каким образом турецкие отели будут конкурировать за российских туристов этим летом.</li>\r\n</ul>\r\n\r\n<p><strong>16:30 &mdash; 16:55<br />\r\nЯна Муромова, заместитель генерального директора ANEX Tour</strong></p>\r\n\r\n<ul>\r\n\t<li>С какими сложностями сталкиваются туроператоры при переносе туров. Оптимистичные/пессимистичные прогнозы по открытию направления и стратегическое планирование. Почему туроператор отказался от переносов на российские регионы?</li>\r\n</ul>\r\n\r\n<p><strong>16:55 &mdash; 17:20<br />\r\nВоскан Арзуманов, генеральный директор TEZ Tour</strong></p>\r\n\r\n<ul>\r\n\t<li>Как повлияло закрытие Турции на другие направления? Куда переориентировать туриста ... если некуда? Почему выросли цены на Россию и как поведут себя туристы, узнав о доплатах?</li>\r\n</ul>\r\n\r\n<p><strong>17:20 &mdash; 17:45<br />\r\nДмитрий Арутюнов,&nbsp;генеральный директор &laquo;АРТ-ТУР&raquo;</strong></p>\r\n\r\n<ul>\r\n\t<li>Много ли туристов-транзитников пострадало от временной приостановки авиасообщения с Турцией? А также, могут ли они претендовать на возврат средств и как туроператоры решают эти проблемы.</li>\r\n</ul>",
  //     scheduleDescription:
  //       "Какие шаги предпринимают турецкие власти, отельеры и российские туроператоры после приостановки авиасообщения между Россией и Турцией? Также из эфира вы узнаете, чем заменить самое массовое направление сезона и как турагенту не потерять клиента в текущей ситуации.",
  //     experts: [
  //       {
  //         id: 7774,
  //         sorting: 1,
  //         image:
  //           "https://cdn.profi.travel/local-storage/profi-travel/uploads/expert/photo/607979a24d77a977749670.jpg",
  //         fullName: "Адем Суверен",
  //         position: "Руководитель отдела продаж направления Россия и страны СНГ сети Barut Hotels",
  //       },
  //       {
  //         id: 7787,
  //         sorting: 2,
  //         image:
  //           "https://cdn.profi.travel/local-storage/profi-travel/uploads/expert/photo/5e837cc5e7180235548179.jpg",
  //         fullName: "Яна Муромова",
  //         position: "Заместитель гендиректора ANEX Tour Россия",
  //       },
  //       {
  //         id: 7804,
  //         sorting: 3,
  //         image:
  //           "https://cdn.profi.travel/local-storage/profi-travel/uploads/expert/photo/60784699be4d7171795117.png",
  //         fullName: "Воскан Арзуманов",
  //         position: "Генеральный директор TEZ Tour",
  //       },
  //       {
  //         id: 7788,
  //         sorting: 4,
  //         image:
  //           "https://cdn.profi.travel/local-storage/profi-travel/uploads/expert/photo/5f8d93f925d66219232809.jpg",
  //         fullName: "Дмитрий Арутюнов",
  //         position: "Генеральный директор «АРТ-ТУР»",
  //       },
  //       {
  //         id: 7758,
  //         sorting: 5,
  //         image:
  //           "https://cdn.profi.travel/local-storage/profi-travel/uploads/expert/photo/5f786673f3694028595410.jpg",
  //         fullName: "Денис Юлин",
  //         position: "Журналист Profi.Travel",
  //       },
  //     ],
  //     id: 24,
  //     type: "broadcast",
  //     title: "Турция 2021: как спасать сезон?",
  //     viewsCount: 4409,
  //     participantsCount: 1040,
  //     path: "/broadcast/24",
  //     date: "2021-04-16T16:00:00+03:00",
  //     dateEnd: "2021-04-16T18:00:00+03:00",
  //     status: 1,
  //     subscribed: true,
  //   },
  //   {
  //     label: null,
  //     companyTitle: "ГУ «Национальное агентство по туризму» Республики Беларусь",
  //     description:
  //       "<ol>\r\n\t<li>Туристические возможности&nbsp;г. Минска.</li>\r\n\t<li>Особенности организации экскурсионных туров в&nbsp;Беларусь.</li>\r\n\t<li>Все о&nbsp;медицинском туризме.</li>\r\n\t<li>MICE-туризм в&nbsp;г. Минске.</li>\r\n\t<li>Готовые туры в&nbsp;столицу Беларуси!</li>\r\n\t<li>&laquo;Минотель&raquo;&nbsp;&mdash; первая сеть гостиниц и&nbsp;ресторанов в&nbsp;Республике Беларусь.</li>\r\n\t<li>Активный отдых и&nbsp;промышленный туризм в&nbsp;г. Минске.</li>\r\n</ol>",
  //     scheduleDescription: null,
  //     experts: [
  //       {
  //         id: 7790,
  //         sorting: 0,
  //         image:
  //           "https://cdn.profi.travel/local-storage/profi-travel/uploads/expert/photo/5ef19f6d99e18973361873.jpg",
  //         fullName: "Елена Лихимович",
  //         position:
  //           "Заместитель директора — начальник отдела маркетинга Национального агентства по туризму Республики Беларусь",
  //       },
  //       {
  //         id: 7791,
  //         sorting: 0,
  //         image:
  //           "https://cdn.profi.travel/local-storage/profi-travel/uploads/expert/photo/5eecc606775c2816068481.jpg",
  //         fullName: "Алексей Русакевич",
  //         position: "Директор учреждения «Информационно-туристский центр «Минск»",
  //       },
  //     ],
  //     id: 167074,
  //     type: "webinar",
  //     title: "Минск: город бизнеса и развлечений! Все об отдыхе в столице и области",
  //     viewsCount: 43,
  //     participantsCount: 440,
  //     path: "/events/webinars/show/167074",
  //     date: "2021-04-19T09:00:00+03:00",
  //     dateEnd: "2021-04-19T11:00:00+03:00",
  //     status: 1,
  //     subscribed: true,
  //   },
  //   {
  //     label: null,
  //     companyTitle: "ГУ «Национальное агентство по туризму» Республики Беларусь",
  //     description:
  //       "<ol>\r\n\t<li>Программа &laquo;Активный отдых здесь и&nbsp;сейчас&raquo;.</li>\r\n\t<li>Знакомство с&nbsp;Robinson Club Resort &amp;&nbsp;SPA&nbsp;&mdash; уникальным загородным клубом под Минском.</li>\r\n\t<li>&laquo;Чистый воздух и&nbsp;вода вас излечат навсегда&raquo;&nbsp;&mdash; презентация санатория &laquo;Ислочь&raquo;.</li>\r\n</ol>",
  //     scheduleDescription: null,
  //     experts: [
  //       {
  //         id: 7794,
  //         sorting: 0,
  //         image: null,
  //         fullName: "Юлия Ламека",
  //         position: "Начальник гостиничного комплекса Robinson Club Resort & SPA",
  //       },
  //       {
  //         id: 7795,
  //         sorting: 0,
  //         image: null,
  //         fullName: "Анна Зяблова",
  //         position: "Начальник отдела маркетинга",
  //       },
  //     ],
  //     id: 167075,
  //     type: "webinar",
  //     title: "Оздоровление и активный отдых в Минской области, всего в 7 км от столицы",
  //     viewsCount: 37,
  //     participantsCount: 432,
  //     path: "/events/webinars/show/167075",
  //     date: "2021-04-19T11:00:00+03:00",
  //     dateEnd: "2021-04-19T12:00:00+03:00",
  //     status: 1,
  //     subscribed: true,
  //   },
  //   {
  //     label: null,
  //     companyTitle: "ГУ «Национальное агентство по туризму» Республики Беларусь",
  //     description:
  //       "<ol>\r\n\t<li>Беловежская Пуща&nbsp;&mdash; легкие Европы: варианты для отдыха.</li>\r\n\t<li>Мемориальный комплекс &laquo;Брестская крепость-герой&raquo;. Сохраняем историю.</li>\r\n\t<li>Солнечный отдых в&nbsp;санатории &laquo;Солнечный&raquo;.</li>\r\n</ol>",
  //     scheduleDescription: null,
  //     experts: [
  //       {
  //         id: 7792,
  //         sorting: 0,
  //         image:
  //           "https://cdn.profi.travel/local-storage/profi-travel/uploads/expert/photo/5ef1e07ca0914958841482.jpg",
  //         fullName: "Нина Богуш",
  //         position: "Заместитель генерального директора ГПУ НП «Беловежская Пуща»",
  //       },
  //       {
  //         id: 7808,
  //         sorting: 0,
  //         image: null,
  //         fullName: "Елена Митюкова",
  //         position:
  //           "Начальник научно-исторического отдела ГУ «Мемориальный комплекс „Брестская крепость-герой“»",
  //       },
  //       {
  //         id: 7809,
  //         sorting: 0,
  //         image: null,
  //         fullName: "Евгений Басалай",
  //         position: "Маркетолог санатория «Солнечный»",
  //       },
  //     ],
  //     id: 167076,
  //     type: "webinar",
  //     title:
  //       "Лето-2021 в Беларуси: Беловежская Пуща, «Брестская крепость-герой» и солнечный отдых в санатории!",
  //     viewsCount: 32,
  //     participantsCount: 435,
  //     path: "/events/webinars/show/167076",
  //     date: "2021-04-19T12:00:00+03:00",
  //     dateEnd: "2021-04-19T13:00:00+03:00",
  //     status: 1,
  //     subscribed: true,
  //   },
  //   {
  //     label: null,
  //     companyTitle: "ГУ «Национальное агентство по туризму» Республики Беларусь",
  //     description:
  //       "<ol>\r\n\t<li>Лучшие музеи Гомеля представляют новинки и&nbsp;самые популярные среди туристов программы.</li>\r\n\t<li>&laquo;Конный двор&raquo;: организация туров в&nbsp;конноспортивный комплекс.</li>\r\n\t<li>Прикоснитесь к&nbsp;прекрасному! Картинная галерея имени Александра Исачева.</li>\r\n\t<li>Незабываемый отдых на&nbsp;природе в&nbsp;усадьбе &laquo;Лошадиный остров&raquo;.</li>\r\n\t<li>&laquo;Серебряные ключи&raquo; &mdash; санаторий со &laquo;светлой душой&raquo;.</li>\r\n</ol>",
  //     scheduleDescription: null,
  //     experts: [
  //       {
  //         id: 7799,
  //         sorting: 0,
  //         image: null,
  //         fullName: "Александр Светилов",
  //         position: "Главный врач санатория «Серебряные ключи»",
  //       },
  //       {
  //         id: 7800,
  //         sorting: 0,
  //         image: null,
  //         fullName: "Александр Овсянкин",
  //         position: "И.о. директора ФСК «Урожай»",
  //       },
  //       {
  //         id: 7810,
  //         sorting: 0,
  //         image: null,
  //         fullName: "Юлия Купреева",
  //         position: "Директор ГУ «Музей истории г. Гомеля»",
  //       },
  //     ],
  //     id: 167077,
  //     type: "webinar",
  //     title:
  //       "Лучшие музеи Гомеля, туры на «Конный двор», отдых в усадьбах и прикосновение к искусству в картинной галерее",
  //     viewsCount: 22,
  //     participantsCount: 428,
  //     path: "/events/webinars/show/167077",
  //     date: "2021-04-19T13:00:00+03:00",
  //     dateEnd: "2021-04-19T14:00:00+03:00",
  //     status: 1,
  //     subscribed: true,
  //   },
  //   {
  //     label: null,
  //     companyTitle: "ГУ «Национальное агентство по туризму» Республики Беларусь",
  //     description:
  //       "<ol>\r\n\t<li>Хруцкий в&nbsp;Полоцке: лента времени. Брендовый художник и&nbsp;его драма жизни, скрытая за&nbsp;чередой натюрмортов и&nbsp;успехом.</li>\r\n\t<li>Знакомство с&nbsp;программами оздоровительных туров &laquo;Пост-COVID&raquo; и&nbsp;&laquo;Коррекция веса&raquo;.</li>\r\n</ol>",
  //     scheduleDescription: null,
  //     experts: [
  //       {
  //         id: 7801,
  //         sorting: 0,
  //         image: null,
  //         fullName: "Виолетта Грудская",
  //         position: "Директор ОДО «РайдоТур»",
  //       },
  //     ],
  //     id: 167078,
  //     type: "webinar",
  //     title:
  //       "Неожиданная Витебщина: успех и драма брендового художника и оздоровительные туры «Пост-COVID» и «Коррекция веса»",
  //     viewsCount: 25,
  //     participantsCount: 428,
  //     path: "/events/webinars/show/167078",
  //     date: "2021-04-19T14:00:00+03:00",
  //     dateEnd: "2021-04-19T15:00:00+03:00",
  //     status: 1,
  //     subscribed: true,
  //   },
  //   {
  //     label: null,
  //     companyTitle: "ГУ «Национальное агентство по туризму» Республики Беларусь",
  //     description:
  //       "<ol>\r\n\t<li>Музей-усадьба М. К. Огинского: возвращение &laquo;Северных Афин&raquo;.</li>\r\n\t<li>Лидский триптих: музей В. П. Тавлая, Лидский замок, историко-художественный музей.</li>\r\n\t<li>Отдых и оздоровление в санатории &laquo;Радуга&raquo;.</li>\r\n</ol>",
  //     scheduleDescription: null,
  //     experts: [
  //       {
  //         id: 7796,
  //         sorting: 0,
  //         image: null,
  //         fullName: "Людмила Гродинская",
  //         position: "Директор Музея-усадьбы М.К. Огинского",
  //       },
  //       {
  //         id: 7797,
  //         sorting: 0,
  //         image: null,
  //         fullName: "Ольга Пилипчук",
  //         position: "Директор ГУ «Лидский историко-художественный музей»",
  //       },
  //       {
  //         id: 7798,
  //         sorting: 0,
  //         image: null,
  //         fullName: "Дарья Чигирь",
  //         position: "Менеджер санатория «Радуга»",
  //       },
  //     ],
  //     id: 167079,
  //     type: "webinar",
  //     title:
  //       "Туристическая Гродненщина: возвращение «Северных Афин», Лидский замок и отдых в санатории «Радуга»",
  //     viewsCount: 36,
  //     participantsCount: 425,
  //     path: "/events/webinars/show/167079",
  //     date: "2021-04-19T15:00:00+03:00",
  //     dateEnd: "2021-04-19T16:00:00+03:00",
  //     status: 1,
  //     subscribed: true,
  //   },
  //   {
  //     label: null,
  //     companyTitle: "ГУ «Национальное агентство по туризму» Республики Беларусь",
  //     description:
  //       "<ol>\r\n\t<li>Откройте Беларусь с&nbsp;туристической компанией &laquo;Могилевоблтурист&raquo;.</li>\r\n\t<li>Тайны дворца Потемкина в&nbsp;г. Кричеве.</li>\r\n\t<li>Уникальные программы в&nbsp;старейшем санатории Беларуси.</li>\r\n\t<li>Уют санатория имени К.&nbsp;П.&nbsp;Орловского.</li>\r\n</ol>",
  //     scheduleDescription: null,
  //     experts: [
  //       {
  //         id: 7811,
  //         sorting: 0,
  //         image: null,
  //         fullName: "Анастасия Радовская",
  //         position: "Научный сотрудник музея ГУК «Исторический музей г. Кричева»",
  //       },
  //       {
  //         id: 7812,
  //         sorting: 0,
  //         image: null,
  //         fullName: "Татьяна Карпова",
  //         position: "Начальник отдела маркетинга «Санаторий имени В. И. Ленина»",
  //       },
  //       {
  //         id: 7813,
  //         sorting: 0,
  //         image: null,
  //         fullName: "Ольга Горшкова",
  //         position: "Директор «Санаторий имени К. П. Орловского»",
  //       },
  //     ],
  //     id: 167080,
  //     type: "webinar",
  //     title:
  //       "Гостеприимная Могилевщина: тайны дворца Потемкина и уникальные программы оздоровления в санаториях",
  //     viewsCount: 38,
  //     participantsCount: 416,
  //     path: "/events/webinars/show/167080",
  //     date: "2021-04-19T16:00:00+03:00",
  //     dateEnd: "2021-04-19T17:00:00+03:00",
  //     status: 1,
  //     subscribed: true,
  //   },
  //   {
  //     label: null,
  //     companyTitle: "Национальная организация туризма Кореи",
  //     description:
  //       '<p><strong>Московский офис Национальной организации туризма Кореи:</strong></p>\r\n\r\n<ul>\r\n\t<li>знакомство со&nbsp;Страной утренней свежести: туристические особенности;</li>\r\n\t<li>топ причин поехать в&nbsp;Корею.</li>\r\n</ul>\r\n\r\n<p><strong>Gwangju Tourism Foundation:</strong></p>\r\n\r\n<ul>\r\n\t<li>туристические возможности города Кванджу;</li>\r\n\t<li>достопримечательности, виды туризма, которые понравятся гостям города;</li>\r\n\t<li>особенный 2021 год&nbsp;&mdash; в&nbsp;Кванджу пройдут&nbsp;&laquo;13-я&nbsp;биеннале в&nbsp;Кванджу&raquo; и&nbsp;&laquo;9-я&nbsp;биеннале дизайна&raquo;, одна из&nbsp;пяти мировых биеннале. Организация туризма Кванджу станет деловым партнером для туристических компаний при формировании туристического продукта, предоставляя планы туристических маршрутов, поддержку программ мастер-классов и&nbsp;поддержку инсентив-туров.</li>\r\n</ul>\r\n\r\n<p><img alt="" src="https://cdn.profi.travel/storage/profi-travel/uploads/CKEditor/6075bf1f15cc7418894459.png" style="width: 135px; height: 78px;" />&nbsp;</p>',
  //     scheduleDescription: null,
  //     experts: [
  //       {
  //         id: 7766,
  //         sorting: 0,
  //         image:
  //           "https://cdn.profi.travel/local-storage/profi-travel/uploads/expert/photo/5ece2a2d5e18e423954741.jpg",
  //         fullName: "Захар Конкин",
  //         position: "B2B-менеджер, Национальная организация туризма Кореи",
  //       },
  //       {
  //         id: 7767,
  //         sorting: 0,
  //         image: null,
  //         fullName: "Ким Хивон",
  //         position: "Представитель Gwangju Tourism Foundation",
  //       },
  //     ],
  //     id: 167056,
  //     type: "webinar",
  //     title: "Топ причин для поездки в Южную Корею и виртуальное знакомство с городом Кванджу",
  //     viewsCount: 28,
  //     participantsCount: 483,
  //     path: "/events/webinars/show/167056",
  //     date: "2021-04-20T10:00:00+03:00",
  //     dateEnd: "2021-04-20T11:00:00+03:00",
  //     status: 1,
  //     subscribed: true,
  //   },
  //   {
  //     label: null,
  //     companyTitle: "Туроператор Good Time Travel",
  //     description:
  //       "<ol>\r\n\t<li>Почему Южная Корея? 10&nbsp;необычных фактов о&nbsp;стране.</li>\r\n\t<li>Перелеты. Как добраться выгоднее всего? Логистика маршрута.</li>\r\n\t<li>Начало маршрута&nbsp;&mdash; Сеул:\r\n\t<ul>\r\n\t\t<li>обзор экскурсий, отели, шоу &laquo;Нанта&raquo;, гастрономия;</li>\r\n\t\t<li>посещение королевского дворца Чхандоккун, торговая улица Инсадонг;</li>\r\n\t\t<li>смотровая площадка Сеульской башни N.</li>\r\n\t</ul>\r\n\t</li>\r\n\t<li>Пусан:\r\n\t<ul>\r\n\t\t<li>обзор экскурсий и&nbsp;возможностей;</li>\r\n\t\t<li>буддийский храм Хэдон Йонгунса;</li>\r\n\t\t<li>рыбный рынок, SPA LAND.</li>\r\n\t</ul>\r\n\t</li>\r\n\t<li>Кёнджу: экскурсионная программа.</li>\r\n\t<li>Национальный природный парк &laquo;Сораксан&raquo;.</li>\r\n\t<li>Остановка в&nbsp;Сокчхо, аквапарк &laquo;Сорак Вотопиа&raquo;.</li>\r\n\t<li>Развлекательный парк Everland.</li>\r\n\t<li>Другие возможности Сеула: шопинг, ТРК &laquo;Лотте Уорлд&raquo;, небоскреб &laquo;Лотте Тауэр&raquo;.</li>\r\n</ol>",
  //     scheduleDescription: null,
  //     experts: [
  //       {
  //         id: 7780,
  //         sorting: 0,
  //         image: null,
  //         fullName: "Николай Букреев",
  //         position: "Коммерческий директор Good Time Travel",
  //       },
  //     ],
  //     id: 167067,
  //     type: "webinar",
  //     title:
  //       "Маршруты по Южной Корее от ТО Good Time Travel: развлечения в Сеуле, экскурсии в Кёнджу и Сокчхо, парк Everland и другие",
  //     viewsCount: 30,
  //     participantsCount: 482,
  //     path: "/events/webinars/show/167067",
  //     date: "2021-04-20T11:00:00+03:00",
  //     dateEnd: "2021-04-20T12:00:00+03:00",
  //     status: 1,
  //     subscribed: true,
  //   },
  //   {
  //     label: null,
  //     companyTitle:
  //       "Национальное туристическое управление Чешской Республики — ЧехТуризм (CzechTourism)",
  //     description:
  //       "<ol>\r\n\t<li>Основная информация по&nbsp;Чехии: транспорт, валюта, телекоммуникации.</li>\r\n\t<li>Актуальная информация по&nbsp;мерам безопасности и&nbsp;условиям для посещения Чехии.</li>\r\n\t<li>Предложения чешских курортов по&nbsp;лечению пост-COVID&nbsp;синдрома.</li>\r\n\t<li>Маркетинг &laquo;ЧехТуризма&raquo; после пандемии.</li>\r\n</ol>",
  //     scheduleDescription: null,
  //     experts: [
  //       {
  //         id: 7720,
  //         sorting: 0,
  //         image:
  //           "https://cdn.profi.travel/local-storage/profi-travel/uploads/expert/photo/5af19ee0b7710250268179.jpeg",
  //         fullName: "Алена Кудилкова",
  //         position: "Директор национального туристического управления Чешской Республики в Москве",
  //       },
  //     ],
  //     id: 167026,
  //     type: "webinar",
  //     title:
  //       "Чехия после пандемии: безопасность населения и туристов и лечение постковидного синдрома на курортах страны",
  //     viewsCount: 43,
  //     participantsCount: 663,
  //     path: "/events/webinars/show/167026",
  //     date: "2021-04-20T12:00:00+03:00",
  //     dateEnd: "2021-04-20T13:00:00+03:00",
  //     status: 1,
  //     subscribed: false,
  //   },
  //   {
  //     label: null,
  //     companyTitle: "SPA HOTEL THERMAL KARLOVY VARY",
  //     description:
  //       "<ol>\r\n\t<li>История и&nbsp;архитектура отеля &laquo;Термал&raquo; в&nbsp;Карловых Варах.</li>\r\n\t<li>Номерной фонд.</li>\r\n\t<li>Лечение и&nbsp;постановка диагнозов, обследования и&nbsp;процедуры.</li>\r\n\t<li>О&nbsp;работе конгресс-центра.</li>\r\n\t<li>Информация о&nbsp;ежегодном кинофестивале.</li>\r\n\t<li>Новости о&nbsp;реконструкции.</li>\r\n\t<li><strong>Розыгрыш ваучера на&nbsp;проживание в&nbsp;отеле &laquo;Термал&raquo;, Карловы Вары: две ночи на&nbsp;двоих с&nbsp;завтраком.</strong></li>\r\n</ol>",
  //     scheduleDescription: null,
  //     experts: [
  //       {
  //         id: 7707,
  //         sorting: 0,
  //         image:
  //           "https://cdn.profi.travel/local-storage/profi-travel/uploads/expert/photo/5f71c7a7f26ea150682546.jpg",
  //         fullName: "Radka Ševcová",
  //         position: "Директор по маркетингу и продажам, Director of Sales & Marketing",
  //       },
  //     ],
  //     id: 167023,
  //     type: "webinar",
  //     title:
  //       "Виртуальное путешествие по «Эйфелевой башне» Карловых Вар. MICE, бассейн, лечение. Розыгрыш проживания!",
  //     viewsCount: 31,
  //     participantsCount: 684,
  //     path: "/events/webinars/show/167023",
  //     date: "2021-04-20T13:00:00+03:00",
  //     dateEnd: "2021-04-20T14:00:00+03:00",
  //     status: 1,
  //     subscribed: false,
  //   },
  //   {
  //     label: null,
  //     companyTitle: "Чешский лечебный курорт Яхимов",
  //     description: "<p><strong>Программа вебинара&nbsp;уточняется.</strong></p>",
  //     scheduleDescription: null,
  //     experts: [
  //       {
  //         id: 7734,
  //         sorting: 0,
  //         image:
  //           "https://cdn.profi.travel/local-storage/profi-travel/uploads/expert/photo/605d9df8c6af1202238351.JPG",
  //         fullName: "Барбора Вольфова",
  //         position: "Директор по продажам",
  //       },
  //     ],
  //     id: 167032,
  //     type: "webinar",
  //     title:
  //       "Лечение и отдых на первом мире радоновом курорте: все о главном богатстве старинной чешской здравницы",
  //     viewsCount: 34,
  //     participantsCount: 653,
  //     path: "/events/webinars/show/167032",
  //     date: "2021-04-20T14:00:00+03:00",
  //     dateEnd: "2021-04-20T15:00:00+03:00",
  //     status: 1,
  //     subscribed: true,
  //   },
  //   {
  //     label: null,
  //     companyTitle: "Vienna Tourist Board (Венское туристическое агентство)",
  //     description:
  //       "<ol>\r\n\t<li>Город после пандемии. Что сейчас происходит в&nbsp;Вене. Безопасный проезд по&nbsp;городу.</li>\r\n\t<li>Все о&nbsp;Вене: &laquo;Место встречи&nbsp;&mdash; Вена&raquo;, &laquo;Венские особенности&raquo;, &laquo;Чувственная Вена&raquo;.</li>\r\n\t<li>Зеленая Вена.</li>\r\n</ol>",
  //     scheduleDescription: null,
  //     experts: [
  //       {
  //         id: 7738,
  //         sorting: 0,
  //         image:
  //           "https://cdn.profi.travel/local-storage/profi-travel/uploads/expert/photo/60659f081c4ee932110057.jpg",
  //         fullName: "Наталья Генералова",
  //         position: "Лицензированный гид по Австрии",
  //       },
  //     ],
  //     id: 167036,
  //     type: "webinar",
  //     title:
  //       "Столица Австрии с новых сторон: атмосфера старой Европы, яркие объекты, интересные маршруты и безопасность после пандемии",
  //     viewsCount: 43,
  //     participantsCount: 650,
  //     path: "/events/webinars/show/167036",
  //     date: "2021-04-20T15:00:00+03:00",
  //     dateEnd: "2021-04-20T17:00:00+03:00",
  //     status: 1,
  //     subscribed: false,
  //   },
  //   {
  //     label: null,
  //     companyTitle: "Туроператор «Квинта-тур»",
  //     description:
  //       '<p><strong>Quinta Tour</strong></p>\r\n\r\n<ol>\r\n\t<li>Нетривиальные маршруты для путешествий в&nbsp;Корее.</li>\r\n\t<li>В&nbsp;каких отелях стоит остановиться?</li>\r\n\t<li>Чем занять туристов и&nbsp;как развлечь, чтобы о&nbsp;поездке остались самые незабываемые впечатления?</li>\r\n</ol>\r\n\r\n<p><br />\r\n<strong>Gwangju Tourism Foundation</strong></p>\r\n\r\n<ol>\r\n\t<li>&laquo;13-я&nbsp;биеннале в&nbsp;Кванджу&raquo;.</li>\r\n\t<li>&laquo;9-я&nbsp;биеннале дизайна&raquo;&nbsp;&mdash; одна из&nbsp;пяти мировых биеннале.</li>\r\n\t<li>Планы туристических маршрутов, программы мастер-классов и&nbsp;инсентив-туров.</li>\r\n</ol>\r\n\r\n<p><br />\r\n<strong>Центр медицинского и оздоровительного туризма MEDIWELL в Кванджу</strong></p>\r\n\r\n<p><img alt="" src="https://cdn.profi.travel/storage/profi-travel/uploads/CKEditor/607526a38afde416459066.png" style="width: 135px; height: 65px;" /></p>\r\n\r\n<ol>\r\n\t<li>Краткий рассказ о компании:&nbsp;поддержка всех&nbsp;видов деятельности и услуг медицинского туризма в Кванджу.</li>\r\n\t<li>Услуги организации:\r\n\t<ul>\r\n\t\t<li>ознакомительные туры и зарубежные маркетинговые мероприятия;</li>\r\n\t\t<li>медицинские туры для иностранных пациентов;</li>\r\n\t\t<li>One-stop service&nbsp;&mdash; непрерывная поддержка иностранных пациентов&nbsp;от прибытия в страну до отъезда.</li>\r\n\t</ul>\r\n\t</li>\r\n</ol>',
  //     scheduleDescription: null,
  //     experts: [
  //       {
  //         id: 7781,
  //         sorting: 0,
  //         image: null,
  //         fullName: "Юлия Фрундина",
  //         position: "Начальник отдела, специалист по Китаю, Южной Корее и Японии, Quinta Tour",
  //       },
  //       {
  //         id: 7805,
  //         sorting: 0,
  //         image: null,
  //         fullName: "Чхве Сану",
  //         position:
  //           "Руководитель Центра медицинского и оздоровительного туризма MEDIWELL в Кванджу",
  //       },
  //     ],
  //     id: 167068,
  //     type: "webinar",
  //     title:
  //       "Маршруты, отели, развлечения в Корее от Quinta Tour, а также биеннале и медицинский туризм в Кванджу",
  //     viewsCount: 10,
  //     participantsCount: 489,
  //     path: "/events/webinars/show/167068",
  //     date: "2021-04-21T10:00:00+03:00",
  //     dateEnd: "2021-04-21T11:00:00+03:00",
  //     status: 1,
  //     subscribed: true,
  //   },
  //   {
  //     label: null,
  //     companyTitle: "Туроператор China Travel",
  //     description:
  //       "<ol>\r\n\t<li>Южная Корея&nbsp;&mdash; один из&nbsp;главных хабов в&nbsp;комбинации с&nbsp;другими странами: экскурсии, бизнес, шопинг, пляжный отдых.</li>\r\n\t<li>Перезагрузка осеннего сезона&nbsp;&mdash; 2020: обзор программ и&nbsp;фестивалей.</li>\r\n\t<li>Плановый разбор самой рекомендованной программы.</li>\r\n\t<li>Обзор важных моментов: объекты, еда, достопримечательности в&nbsp;турах.</li>\r\n</ol>",
  //     scheduleDescription: null,
  //     experts: [
  //       {
  //         id: 7782,
  //         sorting: 0,
  //         image:
  //           "https://cdn.profi.travel/local-storage/profi-travel/uploads/expert/photo/607fd1ffcc3c3613948153.jpeg",
  //         fullName: "Елена Волкова",
  //         position: "Эксперт China Travel",
  //       },
  //     ],
  //     id: 167070,
  //     type: "webinar",
  //     title:
  //       "Пляжный отдых, экскурсионные туры и обзор ключевых объектов в Южной Корее от China Travel",
  //     viewsCount: 12,
  //     participantsCount: 491,
  //     path: "/events/webinars/show/167070",
  //     date: "2021-04-21T11:00:00+03:00",
  //     dateEnd: "2021-04-21T12:00:00+03:00",
  //     status: 1,
  //     subscribed: true,
  //   },
  //   {
  //     label: null,
  //     companyTitle: "Карловарский край",
  //     description:
  //       "<ol>\r\n\t<li><strong>Карловы Вары</strong>&nbsp;&mdash; курорт, доказавший свою эффективность. Вода из&nbsp;недр земли помогает справиться с&nbsp;проблемами ЖКТ, активирует иммунную систему человека, защищает его от&nbsp;вирусов и&nbsp;иных внешних воздействий, в&nbsp;том числе и&nbsp;от&nbsp;онкологии.</li>\r\n\t<li><strong>Марианские Лазни</strong>&nbsp;&mdash; королевский курорт. Первый в&nbsp;мире anti-age, источник долгой жизни. После открытия границ именно он&nbsp;станет главным местом реабилитации людей с&nbsp;поражением легких после COVID-19. А&nbsp;также курортом, который поможет укрепить дыхательную систему взрослых и&nbsp;детей.</li>\r\n\t<li><strong>Франтишковы Лазни</strong>&nbsp;&mdash; курорт, созданный специально для женщин. Как для тех, кто не&nbsp;может забеременеть, так и&nbsp;для тех, кто подходит к&nbsp;периоду менопаузы.</li>\r\n\t<li><strong>Яхимов&nbsp;</strong>&mdash; первый в&nbsp;мире радоновый курорт. Радоновая вода&nbsp;&mdash; одно из&nbsp;самых мощных природных противовоспалительных средств.</li>\r\n</ol>",
  //     scheduleDescription: null,
  //     experts: [
  //       {
  //         id: 7719,
  //         sorting: 0,
  //         image:
  //           "https://cdn.profi.travel/local-storage/profi-travel/uploads/expert/photo/5ece456acb391611066832.jpg",
  //         fullName: "Максим Приймак",
  //         position:
  //           "Медицинский Амбассадор в России и странах СНГ Государственного агентства по развитию туризма в Карловарском крае «Живой Край»",
  //       },
  //     ],
  //     id: 167025,
  //     type: "webinar",
  //     title:
  //       "Санаторно-курортное лечение, оздоровление, программы реабилитации после COVID-19 и превентивная медицина",
  //     viewsCount: 8,
  //     participantsCount: 639,
  //     path: "/events/webinars/show/167025",
  //     date: "2021-04-21T12:00:00+03:00",
  //     dateEnd: "2021-04-21T13:00:00+03:00",
  //     status: 1,
  //     subscribed: false,
  //   },
  //   {
  //     label: null,
  //     companyTitle: "Отель Savoy Westend Hotel 5*, Чехия",
  //     description: "<p><strong>Программа вебинара&nbsp;уточняется.</strong></p>",
  //     scheduleDescription: null,
  //     experts: [
  //       {
  //         id: 7732,
  //         sorting: 0,
  //         image:
  //           "https://cdn.profi.travel/local-storage/profi-travel/uploads/expert/photo/5af19ca8c3111299497177.jpeg",
  //         fullName: "Ада Карпова",
  //         position: "Директор по продажам/заместитель генерального менеджера Savoy Westend Hotel",
  //       },
  //     ],
  //     id: 167031,
  //     type: "webinar",
  //     title:
  //       "Новости сезона-2021, услуги и презентация лечебных программ по профилактике и восстановлению после COVID-19",
  //     viewsCount: 13,
  //     participantsCount: 623,
  //     path: "/events/webinars/show/167031",
  //     date: "2021-04-21T13:00:00+03:00",
  //     dateEnd: "2021-04-21T14:00:00+03:00",
  //     status: 1,
  //     subscribed: false,
  //   },
  //   {
  //     label: null,
  //     companyTitle: "Barceló Hotel Group. Occidental Hotels & Resorts",
  //     description:
  //       "<ol>\r\n\t<li>Презентация компании.</li>\r\n\t<li>Презентация отелей в&nbsp;Чешской Республике.</li>\r\n\t<li>Возможность проведения конференций в&nbsp;Праге и&nbsp;в&nbsp;Брно.</li>\r\n\t<li>Презентация всех отелей сети в&nbsp;Праге.</li>\r\n\t<li>Презентация отеля в&nbsp;Брно.</li>\r\n</ol>",
  //     scheduleDescription: null,
  //     experts: [
  //       {
  //         id: 7737,
  //         sorting: 0,
  //         image:
  //           "https://cdn.profi.travel/local-storage/profi-travel/uploads/expert/photo/60633e5c26323627348643.JPG",
  //         fullName: "Маркета Янатова",
  //         position:
  //           "Директор по маркетингу и продажам Чешской Республики сети отелей Barceló Hotel Group",
  //       },
  //     ],
  //     id: 167035,
  //     type: "webinar",
  //     title:
  //       "Одна из ведущих туристических компаний Европы — презентация отелей в Чешской Республике",
  //     viewsCount: 12,
  //     participantsCount: 634,
  //     path: "/events/webinars/show/167035",
  //     date: "2021-04-21T14:00:00+03:00",
  //     dateEnd: "2021-04-21T15:00:00+03:00",
  //     status: 1,
  //     subscribed: false,
  //   },
  //   {
  //     label: null,
  //     companyTitle: "Malaysia Tourism Promotion Board",
  //     description:
  //       "<ul>\r\n\t<li>Что привлекает туристов в&nbsp;Малайзии?</li>\r\n\t<li>Общая информация: обзор достопримечательностей и&nbsp;мест для отдыха, способы добраться.</li>\r\n\t<li>Когда страна откроет границы?</li>\r\n\t<li><strong>Розыгрыш памятных сувениров!</strong></li>\r\n</ul>",
  //     scheduleDescription: null,
  //     experts: [
  //       {
  //         id: 7746,
  //         sorting: 0,
  //         image:
  //           "https://cdn.profi.travel/local-storage/profi-travel/uploads/expert/photo/5d4d70255d9fe494816317.jpg",
  //         fullName: "Александр Доля",
  //         position: "Специалист по маркетингу, Malaysia Tourism Promotion Board",
  //       },
  //     ],
  //     id: 167041,
  //     type: "webinar",
  //     title:
  //       "Когда Малайзия откроет границы и чем она привлекает туристов? Обзор от турофиса страны и розыгрыш призов!",
  //     viewsCount: 10,
  //     participantsCount: 519,
  //     path: "/events/webinars/show/167041",
  //     date: "2021-04-21T15:00:00+03:00",
  //     dateEnd: "2021-04-21T16:00:00+03:00",
  //     status: 1,
  //     subscribed: true,
  //   },
  //   {
  //     label: null,
  //     companyTitle: "Malaysia Tourism Promotion Board",
  //     description:
  //       "<p><strong>Отель One&amp;Only Desaru Coast на&nbsp;побережье Южно-Китайского моря:</strong></p>\r\n\r\n<ul>\r\n\t<li><strong>трансфер:</strong>&nbsp;4&nbsp;часа от&nbsp;аэропорта Куала-Лумпур и&nbsp;2,5 часа от&nbsp;аэропорта Чанги;</li>\r\n\t<li><strong>номерной фонд:</strong>&nbsp;44&nbsp;сьюта, 50&nbsp;частных домов и&nbsp;вилла Villa One с&nbsp;4&nbsp;спальнями;</li>\r\n\t<li><strong>отдых:</strong>&nbsp;спа, частный пляж, водные активити, клубы, поддел-теннис, гольф, фитнес, пилатес, йога и&nbsp;развлечения для детей&nbsp;&mdash; клубы, верховая езда, лаборатории, кружки, клуб для рейнджеров и&nbsp;др.;</li>\r\n\t<li><strong>MICE:</strong>&nbsp;большой зал Grand Ballroom и&nbsp;3&nbsp;конференц-зала;</li>\r\n\t<li><strong>экскурсии</strong>&nbsp;и&nbsp;развлечения на&nbsp;побережье Десару;</li>\r\n\t<li><strong>питание:</strong>&nbsp;бренд-шеф Дэвид Дальхаус и&nbsp;кухня Малайзии в&nbsp;трех фирменных ресторанах, динамичном баре и&nbsp;пляжном клубе Ember Beach Club.</li>\r\n</ul>",
  //     scheduleDescription: null,
  //     experts: [
  //       {
  //         id: 7750,
  //         sorting: 0,
  //         image:
  //           "https://cdn.profi.travel/local-storage/profi-travel/uploads/expert/photo/60671b3c2269c230951309.png",
  //         fullName: "Виктория Кузнецова",
  //         position:
  //           "Менеджер по работе с ключевыми клиентами представительства Kerzner International",
  //       },
  //     ],
  //     id: 167043,
  //     type: "webinar",
  //     title:
  //       "Обзор отеля One&Only Desaru Coast: идеальный отдых класса «люкс» на побережье Десару в Малайзии",
  //     viewsCount: 13,
  //     participantsCount: 487,
  //     path: "/events/webinars/show/167043",
  //     date: "2021-04-21T16:00:00+03:00",
  //     dateEnd: "2021-04-21T17:00:00+03:00",
  //     status: 1,
  //     subscribed: true,
  //   },
  //   {
  //     label: null,
  //     companyTitle: "ВАНД ТРЕВЕЛ",
  //     description:
  //       '<ol>\r\n\t<li>В&nbsp;ожидании восстановления турпотока с&nbsp;Южной Кореей: что происходит в&nbsp;стране?</li>\r\n\t<li>Освежаем знания и&nbsp;получаем новые: какие экскурсии привлекают туристов в&nbsp;Корее?</li>\r\n\t<li>Успешная реализация экскурсионного продукта: советы опытного туроператора.</li>\r\n\t<li>Организация туризма провинции Чолла-Намдо.\r\n\t<ul>\r\n\t\t<li>\r\n\t\t<p>Одно из&nbsp;самых популярных туристических направлений в&nbsp;Корее: красивые природные пейзажи, богатая гастрономия и&nbsp;различные культурные программы.</p>\r\n\t\t</li>\r\n\t\t<li>\r\n\t\t<p>Основные медицинские учреждения:</p>\r\n\r\n\t\t<ul>\r\n\t\t\t<li>\r\n\t\t\t<p>клиника университета Хвасун-Чоннам, которая специализируется на&nbsp;лечении раковых заболеваний, в&nbsp;том числе тяжелых стадий;</p>\r\n\t\t\t</li>\r\n\t\t\t<li>\r\n\t\t\t<p>клиника восточной медицины Мокпхо при университете Донсин, которая предлагает процедуры эстетической медицины, такие как подтяжка кожи и&nbsp;улучшение тонуса кожи. Это лучшее место для оздоровительного туризма, где гости смогут совместить отдых и&nbsp;посещение достопримечательностей с&nbsp;оздоровлением.</p>\r\n\t\t\t</li>\r\n\t\t</ul>\r\n\t\t</li>\r\n\t</ul>\r\n\t</li>\r\n</ol>\r\n\r\n<p><img alt="" src="https://cdn.profi.travel/storage/profi-travel/uploads/CKEditor/607988ce16d5b074797980.jpg" style="width: 659px; height: 70px;" /></p>',
  //     scheduleDescription: null,
  //     experts: [
  //       {
  //         id: 7765,
  //         sorting: 0,
  //         image:
  //           "https://cdn.profi.travel/local-storage/profi-travel/uploads/expert/photo/606f5088dd434906785639.jpg",
  //         fullName: "Людмила Озик",
  //         position: "Заместитель директора по туризму компании VAND",
  //       },
  //       {
  //         id: 7789,
  //         sorting: 0,
  //         image:
  //           "https://cdn.profi.travel/local-storage/profi-travel/uploads/expert/photo/6076b2dcb0180912694713.png",
  //         fullName: "Ли Кырин",
  //         position: "Заместитель директора департамента",
  //       },
  //     ],
  //     id: 167055,
  //     type: "webinar",
  //     title:
  //       "Южная Корея: познаем особенности экскурсионного туризма — мастер-класс от туроператора VAND",
  //     viewsCount: 0,
  //     participantsCount: 452,
  //     path: "/events/webinars/show/167055",
  //     date: "2021-04-22T10:00:00+03:00",
  //     dateEnd: "2021-04-22T11:00:00+03:00",
  //     status: 0,
  //     subscribed: true,
  //   },
  //   {
  //     label: null,
  //     companyTitle: "KMP Group",
  //     description:
  //       "<ol>\r\n\t<li>О&nbsp;туроператоре KMP Group.</li>\r\n\t<li>Когда лучше ехать в&nbsp;Корею?</li>\r\n\t<li>Транспортное сообщение.</li>\r\n\t<li>Остров Чеджу&nbsp;&mdash; лучшее летнее направление в&nbsp;Корее: топ-3&nbsp;пляжей, особенности отдыха, достопримечательности и&nbsp;отели.</li>\r\n\t<li>Туры на&nbsp;лето-2021&nbsp;в Корею от&nbsp;KMP Group.</li>\r\n</ol>",
  //     scheduleDescription: null,
  //     experts: [
  //       {
  //         id: 7764,
  //         sorting: 0,
  //         image:
  //           "https://cdn.profi.travel/local-storage/profi-travel/uploads/expert/photo/5f6e19cfcaec8879846092.jpg",
  //         fullName: "Елена Милованова",
  //         position: "Ведущий менеджер отдела экзотики и стран Юго-Восточной Азии, KMP Group",
  //       },
  //     ],
  //     id: 167054,
  //     type: "webinar",
  //     title:
  //       "Летний отдых в Южной Корее с ТО KMP Group: лучшее направление на жаркий сезон, топ пляжей, советы турагентам и туры на лето-2021",
  //     viewsCount: 0,
  //     participantsCount: 446,
  //     path: "/events/webinars/show/167054",
  //     date: "2021-04-22T11:00:00+03:00",
  //     dateEnd: "2021-04-22T12:00:00+03:00",
  //     status: 0,
  //     subscribed: true,
  //   },
  //   {
  //     label: null,
  //     companyTitle: "Сеть отелей Barceló Hotel Group",
  //     description:
  //       "<p>Актуальные новости от&nbsp;Barcel&oacute; Hotel Group. Новинки, обновления, излюбленные отели и&nbsp;СПО на&nbsp;летний период.</p>\r\n\r\n<ol>\r\n\t<li>Три отеля в&nbsp;Тунисе. Каникулы в&nbsp;Суссе и&nbsp;Хаммамете.</li>\r\n\t<li>Лучшие виды на&nbsp;остров Идра&nbsp;&mdash; греческий Barcel&oacute; Hydra Beach Resort.</li>\r\n\t<li>Barcel&oacute; Royal Beach на&nbsp;Солнечном Берегу (Болгария).</li>\r\n\t<li>Новые отели в&nbsp;Испании: Коста-Бланка и&nbsp;Коста-дель-Соль.</li>\r\n\t<li>Программа лояльности Barcel&oacute; Partner Club: все преимущества бронирования отелей сети Barcel&oacute;.</li>\r\n\t<li><strong>Розыгрыш ваучера на&nbsp;проживание в&nbsp;одном из&nbsp;отелей сети Barcel&oacute;!</strong></li>\r\n</ol>",
  //     scheduleDescription: null,
  //     experts: [
  //       {
  //         id: 7736,
  //         sorting: 0,
  //         image:
  //           "https://cdn.profi.travel/local-storage/profi-travel/uploads/expert/photo/5ecc0d80528f5011769556.jpg",
  //         fullName: "Елена Третьякова",
  //         position: "Представитель сети отелей Barceló Hotel Group, EMEA",
  //       },
  //     ],
  //     id: 167034,
  //     type: "webinar",
  //     title:
  //       "Тунис, Греция, Болгария, Испания — новинки и обновления к 2021 году: самая актуальная информация и СПО. Розыгрыш проживания!",
  //     viewsCount: 0,
  //     participantsCount: 702,
  //     path: "/events/webinars/show/167034",
  //     date: "2021-04-22T12:00:00+03:00",
  //     dateEnd: "2021-04-22T13:00:00+03:00",
  //     status: 0,
  //     subscribed: true,
  //   },
  //   {
  //     label: null,
  //     companyTitle: "Принимающая компания Meeting Tour Travel & SPA Consultants",
  //     description:
  //       "<ol>\r\n\t<li>Вкратце о&nbsp;компании Meeting Tour Travel &amp;&nbsp;SPA Consultants. Преимущества сотрудничества.</li>\r\n\t<li>Новые реалии туризма в&nbsp;Латвии: неторопливые путешествия по&nbsp;регионам, посещение маленьких городов, хозяйств, погружение в&nbsp;культуру и&nbsp;традиции, отдых на&nbsp;природе.</li>\r\n\t<li>Истинное наслаждение жизнью: лечебно-оздоровительные программы в&nbsp;сезоне-2021.</li>\r\n</ol>",
  //     scheduleDescription: null,
  //     experts: [
  //       {
  //         id: 7776,
  //         sorting: 0,
  //         image:
  //           "https://cdn.profi.travel/local-storage/profi-travel/uploads/expert/photo/5f755d36778f8672926481.png",
  //         fullName: "Ивета Кравале",
  //         position:
  //           "Директор принимающей компании MEETING TOUR Travel & SPA Consultants (DMC, Латвия)",
  //       },
  //     ],
  //     id: 167063,
  //     type: "webinar",
  //     title:
  //       "Латвия в сезоне-2021: обзор направления от DMC, отдых в новых реалиях и оздоровительные программы",
  //     viewsCount: 0,
  //     participantsCount: 449,
  //     path: "/events/webinars/show/167063",
  //     date: "2021-04-22T13:00:00+03:00",
  //     dateEnd: "2021-04-22T14:00:00+03:00",
  //     status: 0,
  //     subscribed: true,
  //   },
  //   {
  //     label: null,
  //     companyTitle: "Malaysia Tourism Promotion Board",
  //     description:
  //       "<ol>\r\n\t<li>Общая информация о&nbsp;путешествиях с&nbsp;Singapore Airlines.</li>\r\n\t<li>Новые протоколы безопасности и&nbsp;охраны здоровья пассажиров.</li>\r\n\t<li>Гибкость планирования будущих поездок.</li>\r\n\t<li>Как выглядит сервис премиальной авиакомпании в&nbsp;новой реальности?</li>\r\n</ol>",
  //     scheduleDescription: null,
  //     experts: [
  //       {
  //         id: 7779,
  //         sorting: 0,
  //         image:
  //           "https://cdn.profi.travel/local-storage/profi-travel/uploads/expert/photo/606f29d690475669811686.jpeg",
  //         fullName: "Светлана Краснобородько",
  //         position: "Менеджер по развитию бизнеса, Singapore Airlines",
  //       },
  //     ],
  //     id: 167066,
  //     type: "webinar",
  //     title:
  //       "Премиальная авиакомпания Singapore Airlines — гибкое планирование путешествий летом-2021, безопасность и охрана здоровья пассажиров",
  //     viewsCount: 0,
  //     participantsCount: 440,
  //     path: "/events/webinars/show/167066",
  //     date: "2021-04-22T14:00:00+03:00",
  //     dateEnd: "2021-04-22T16:00:00+03:00",
  //     status: 0,
  //     subscribed: true,
  //   },
  //   {
  //     label: "Деловая программа",
  //     companyTitle: "Profi.Travel",
  //     description:
  //       "<p>В рамках деловой программы ОТМ: Лето 2021 поговорим о самых горячих юридических темах. Георгий Мохов, основатель компании &laquo;Персона Грата&raquo; и ведущий юрист в российской туротрасли, поделится последними новостями о переносах туров, обсудит законодательные новеллы и расскажет о важных нюансах в связи с &laquo;турецкими событиями&raquo;. Эфир ведет Антон Тримайлов, редактор международного отдела Profi.Travel.</p>\r\n\r\n<p>Узнаем:</p>\r\n\r\n<ul>\r\n\t<li>Как действовать с турами в Турцию, которые попадают на период приостановки полетов?</li>\r\n\t<li>Какие проблемы возникают для турбизнеса в судебной практике по &laquo;ковидным турам&raquo;?</li>\r\n\t<li>Как реестр турагентов может повлиять на договорные отношения с туроператорами?</li>\r\n</ul>",
  //     scheduleDescription: null,
  //     experts: [
  //       {
  //         id: 7727,
  //         sorting: 0,
  //         image:
  //           "https://cdn.profi.travel/local-storage/profi-travel/uploads/expert/photo/5e83837982fd1426973026.jpg",
  //         fullName: "Георгий Мохов",
  //         position:
  //           "Бизнес-омбудсмен, директор юридического агентства «Персона грата», руководитель правовой комиссии Российского союза туриндустрии",
  //       },
  //       {
  //         id: 7728,
  //         sorting: 0,
  //         image:
  //           "https://cdn.profi.travel/local-storage/profi-travel/uploads/expert/photo/5f786d895d30a242270617.jpg",
  //         fullName: "Антон Тримайлов",
  //         position: "Редактор международного отдела Profi.Travel, модератор",
  //       },
  //     ],
  //     id: 167029,
  //     type: "webinar",
  //     title: "«Турецкий гамбит»: аннулировать или переносить?",
  //     viewsCount: 0,
  //     participantsCount: 803,
  //     path: "/events/webinars/show/167029",
  //     date: "2021-04-22T16:00:00+03:00",
  //     dateEnd: "2021-04-22T18:00:00+03:00",
  //     status: 0,
  //     subscribed: false,
  //   },
  //   {
  //     label: null,
  //     companyTitle: "Resort Life Travel",
  //     description:
  //       "<ol>\r\n\t<li>Resort Life Travel&nbsp;&mdash; 14&nbsp;лет сервиса на&nbsp;Мальдивах.</li>\r\n\t<li>Новый эксклюзив компании&nbsp;&mdash; Nakai Resorts.</li>\r\n\t<li>Crown and Champa Resorts&nbsp;&mdash; особенности продаж курортов в&nbsp;сезоне:\r\n\t<ul>\r\n\t\t<li>KAGI Maldives SPA Island;</li>\r\n\t\t<li>Kuredu Island Resort;</li>\r\n\t\t<li>Innahura Maldives Resort.</li>\r\n\t</ul>\r\n\t</li>\r\n</ol>",
  //     scheduleDescription: null,
  //     experts: [
  //       {
  //         id: 7752,
  //         sorting: 0,
  //         image:
  //           "https://cdn.profi.travel/local-storage/profi-travel/uploads/expert/photo/60771eb24c4e5412909302.jpeg",
  //         fullName: "Даша Караман",
  //         position: "Представитель Resort Life Travel",
  //       },
  //       {
  //         id: 7753,
  //         sorting: 0,
  //         image:
  //           "https://cdn.profi.travel/local-storage/profi-travel/uploads/expert/photo/606d718b964ff690051524.jpg",
  //         fullName: "Анна Кривогуз",
  //         position: "Sales & Marketing Manager",
  //       },
  //     ],
  //     id: 167045,
  //     type: "webinar",
  //     title:
  //       "Эксклюзив от принимающей компании на Мальдивах: Nakai Resorts и новости сети Crown & Champa Resorts!",
  //     viewsCount: 0,
  //     participantsCount: 665,
  //     path: "/events/webinars/show/167045",
  //     date: "2021-04-23T10:00:00+03:00",
  //     dateEnd: "2021-04-23T11:00:00+03:00",
  //     status: 0,
  //     subscribed: true,
  //   },
  //   {
  //     label: null,
  //     companyTitle: "Minor Hotel Group",
  //     description:
  //       "<ol>\r\n\t<li><strong>Anantara Kihavah Villas:&nbsp;</strong>подводный ресторан SEA, уникальная надводная обсерватория, домашний риф.</li>\r\n\t<li><strong>Anantara Dhigu Resort:</strong>&nbsp;поездка на&nbsp;понтоне на&nbsp;остров Гулифуши, пикник на&nbsp;пустынных пляжах, снорклинг и&nbsp;другие развлечения.</li>\r\n\t<li><strong>Niyama Private Islands:&nbsp;</strong>круглосуточный спа-центр и&nbsp;первый в&nbsp;мире подводный ночной клуб.</li>\r\n\t<li>Все об&nbsp;отдыхе в&nbsp;<strong>Anantara Veli Resort&nbsp;</strong>и<strong>&nbsp;Naladhu Private Island.</strong></li>\r\n\t<li>СПО на&nbsp;лето-2021:\r\n\t<ul>\r\n\t\t<li>бесплатный обед для двоих в&nbsp;подводном ресторане SEA;</li>\r\n\t\t<li>бесплатная экскурсия для двоих в&nbsp;единственную надводную обсерваторию на&nbsp;Мальдивах;</li>\r\n\t\t<li>бесплатный снорклинг или круиз к&nbsp;дельфинам на&nbsp;двоих.</li>\r\n\t</ul>\r\n\t</li>\r\n</ol>",
  //     scheduleDescription: null,
  //     experts: [
  //       {
  //         id: 7763,
  //         sorting: 0,
  //         image:
  //           "https://cdn.profi.travel/local-storage/profi-travel/uploads/expert/photo/606f0798a303d233186840.jpg",
  //         fullName: "Александра Ефремова",
  //         position: "Менеджер по продажам и маркетингу, Minor Hotels",
  //       },
  //     ],
  //     id: 167053,
  //     type: "webinar",
  //     title:
  //       "На Мальдивы за впечатлениями: подводные ресторан и клуб, снорклинг с мантами, круглосуточный спа и СПО на лето-2021",
  //     viewsCount: 0,
  //     participantsCount: 681,
  //     path: "/events/webinars/show/167053",
  //     date: "2021-04-23T11:00:00+03:00",
  //     dateEnd: "2021-04-23T12:00:00+03:00",
  //     status: 0,
  //     subscribed: true,
  //   },
  //   {
  //     label: null,
  //     companyTitle: "Exciting Travel Holidays",
  //     description:
  //       "<ol>\r\n\t<li>Знакомство с&nbsp;принимающей компанией Exciting Travel Holidays. Предоставляемые услуги:\r\n\t<ul>\r\n\t\t<li>встреча и&nbsp;прием гостей в&nbsp;аэропорту;</li>\r\n\t\t<li>полное сопровождение туристов в&nbsp;стране пребывания;</li>\r\n\t\t<li>русский Guest relations 24/7;</li>\r\n\t\t<li>услуги CIP-лаунджа: встреча у&nbsp;трапа + VIP-обслуживание;</li>\r\n\t\t<li>индивидуальный трансфер, экскурсия по&nbsp;Мале и&nbsp;многое другое.</li>\r\n\t</ul>\r\n\t</li>\r\n\t<li>Хиты сезона-2021 и&nbsp;новинки сезона-2022.</li>\r\n\t<li>Отели на&nbsp;Мальдивах: рекомендации, новинки.</li>\r\n\t<li><strong>Розыгрыш 2&nbsp;ночей в&nbsp;Movenpick Maldives и&nbsp;2&nbsp;ночей в&nbsp;Hideaway!</strong></li>\r\n</ol>",
  //     scheduleDescription: null,
  //     experts: [
  //       {
  //         id: 7815,
  //         sorting: 0,
  //         image: null,
  //         fullName: "Елена Овчарук",
  //         position: "Менеджер по продажам в России, Украине и СНГ, Exciting Travel Holidays",
  //       },
  //       {
  //         id: 7816,
  //         sorting: 0,
  //         image: null,
  //         fullName: "Олег Дыбов",
  //         position: "Региональный директор по продажам и маркетингу Lily Hotels Maldives",
  //       },
  //     ],
  //     id: 167086,
  //     type: "webinar",
  //     title:
  //       "Мальдивы — обзор отелей на любой вкус: от гестхаусов до приватных островов-резортов. Розыгрыш проживания!",
  //     viewsCount: 0,
  //     participantsCount: 135,
  //     path: "/events/webinars/show/167086",
  //     date: "2021-04-23T12:00:00+03:00",
  //     dateEnd: "2021-04-23T13:00:00+03:00",
  //     status: 0,
  //     subscribed: false,
  //   },
  //   {
  //     label: null,
  //     companyTitle: "Reollo Travel Maldives",
  //     description:
  //       "<p><strong>1. Reollo Travel Maldives</strong></p>\r\n\r\n<ul>\r\n\t<li>О&nbsp;компании: возможности и&nbsp;преимущества.</li>\r\n\t<li>Услуги и&nbsp;VIP-услуги компании.</li>\r\n\t<li>Рекомендованные курорты.</li>\r\n\t<li>Почему Reollo Travel?</li>\r\n\t<li>Контакты компании.</li>\r\n</ul>\r\n\r\n<p><strong>2. Отель Kandima</strong></p>\r\n\r\n<ul>\r\n\t<li>Обзор отеля.</li>\r\n\t<li>Новости 2021&nbsp;года.</li>\r\n\t<li>Что такое lifestyle resort? Кому и&nbsp;как его продавать?</li>\r\n</ul>\r\n\r\n<p><strong>3. Розыгрыш трех ночей в Sky Studio на базе завтраков для двоих!</strong></p>",
  //     scheduleDescription: null,
  //     experts: [
  //       {
  //         id: 7741,
  //         sorting: 0,
  //         image:
  //           "https://cdn.profi.travel/local-storage/profi-travel/uploads/expert/photo/606aabb50b59d989297884.jpg",
  //         fullName: "Наталья Гребнева",
  //         position: "Менеджер по продажам и маркетингу в России, компания Reollo Travel",
  //       },
  //       {
  //         id: 7742,
  //         sorting: 0,
  //         image:
  //           "https://cdn.profi.travel/local-storage/profi-travel/uploads/expert/photo/606aaa4e5767d748689032.jpg",
  //         fullName: "Марина Мирошникова",
  //         position: "Менеджер отдела продаж отеля Kandima, Россия и СНГ",
  //       },
  //     ],
  //     id: 167037,
  //     type: "webinar",
  //     title:
  //       "Аренда частного острова или встреча со звездой? Организуйте отдых на Мальдивах любого уровня сложности! Розыгрыш проживания!",
  //     viewsCount: 0,
  //     participantsCount: 674,
  //     path: "/events/webinars/show/167037",
  //     date: "2021-04-23T13:00:00+03:00",
  //     dateEnd: "2021-04-23T14:00:00+03:00",
  //     status: 0,
  //     subscribed: false,
  //   },
  //   {
  //     label: null,
  //     companyTitle: "The Lux Collective",
  //     description:
  //       "<ol>\r\n\t<li>Отдых в&nbsp;стиле LUX*&nbsp;на Мальдивах&nbsp;&mdash; открываем с&nbsp;новой стороны! Особенности бренда и&nbsp;новинки летнего сезона.</li>\r\n\t<li>Сюрпризы от&nbsp;LUX*: обжаренный прямо на&nbsp;острове кофе, кинопоказы под звездным небом и&nbsp;волшебное дерево желаний.</li>\r\n\t<li>Жемчужина гостеприимства Мальдив: LUX* South Ari Atoll 5&nbsp;star.</li>\r\n</ol>",
  //     scheduleDescription: null,
  //     experts: [
  //       {
  //         id: 7718,
  //         sorting: 0,
  //         image:
  //           "https://cdn.profi.travel/local-storage/profi-travel/uploads/expert/photo/5af19ed67a0d1229431993.jpeg",
  //         fullName: "Наталья Веббер",
  //         position: "Директор по продажам и маркетингу",
  //       },
  //     ],
  //     id: 167024,
  //     type: "webinar",
  //     title:
  //       "Кинопоказы под звездным небом и волшебное дерево желаний — обзор отеля LUX* South Ari Atoll на Мальдивах с новой стороны!",
  //     viewsCount: 0,
  //     participantsCount: 663,
  //     path: "/events/webinars/show/167024",
  //     date: "2021-04-23T14:00:00+03:00",
  //     dateEnd: "2021-04-23T15:00:00+03:00",
  //     status: 0,
  //     subscribed: false,
  //   },
  //   {
  //     label: null,
  //     companyTitle: "Aitken Spence Travels",
  //     description:
  //       "<ol>\r\n\t<li>Знакомство с&nbsp;группой компаний Aitken Spence.</li>\r\n\t<li>Секреты отдыха на&nbsp;Шри-Ланке с&nbsp;принимающим туроператором Aitken Spence Travels:\r\n\t<ul>\r\n\t\t<li>Почему Шри-Ланка&nbsp;&mdash; идеальное направление для путешествий?</li>\r\n\t\t<li>Основные туристические направления Шри-Ланки и&nbsp;лучшее время для поездки.</li>\r\n\t\t<li>Направления экскурсионных туров.</li>\r\n\t\t<li>Популярные пляжные отели Шри-Ланки.</li>\r\n\t\t<li>Меры по&nbsp;предотвращению распространения COVID-19.</li>\r\n\t\t<li>Визовая и&nbsp;иммиграционная информация.</li>\r\n\t\t<li>Вопросы и&nbsp;ответы.</li>\r\n\t</ul>\r\n\t</li>\r\n</ol>",
  //     scheduleDescription: null,
  //     experts: [
  //       {
  //         id: 7785,
  //         sorting: 0,
  //         image: null,
  //         fullName: "Марина Велиханова",
  //         position: "Специалист направления Россия и СНГ",
  //       },
  //     ],
  //     id: 167073,
  //     type: "webinar",
  //     title:
  //       "Шри-Ланка — направление, идеальное в любой сезон: обзор экскурсионных маршрутов и популярных отелей для пляжного отдыха",
  //     viewsCount: 0,
  //     participantsCount: 467,
  //     path: "/events/webinars/show/167073",
  //     date: "2021-04-23T15:00:00+03:00",
  //     dateEnd: "2021-04-23T16:00:00+03:00",
  //     status: 0,
  //     subscribed: true,
  //   },
  //   {
  //     label: null,
  //     companyTitle: "Centara Hotels & Resorts",
  //     description:
  //       "<ol>\r\n\t<li><strong>Centara Grand Island Resort &amp;&nbsp;Spa Maldives 5*</strong> ― изменения концепта питания, сюрпризы для гостей с&nbsp;детьми, новое о&nbsp;дайвинге и&nbsp;организации свадеб.</li>\r\n\t<li><strong>Centara Ras Fushi Resort &amp;&nbsp;Spa Maldives 4*</strong> ― изменения концепта питания, новости активного отдыха для молодоженов и&nbsp;организация свадеб.</li>\r\n\t<li><strong>Centara Ceysands Resort &amp;&nbsp;Spa Sri Lanka 4*</strong> ― как отель встречает гостей в&nbsp;условиях новой эры путешествий и&nbsp;какие услуги доступны для нескучного отдыха на&nbsp;территории курорта с&nbsp;детьми и&nbsp;без детей.</li>\r\n\t<li><strong>Centara Reserve Samui </strong>&mdash; открытие нового отеля в сегменте luxury в преддверии открытия границ Таиланда.</li>\r\n\t<li><strong>Викторина с&nbsp;розыгрышем ваучера на&nbsp;проживание&nbsp;&mdash; две ночи на&nbsp;двоих на&nbsp;Мальдивах на&nbsp;питании all inclusive.</strong></li>\r\n</ol>",
  //     scheduleDescription: null,
  //     experts: [
  //       {
  //         id: 7706,
  //         sorting: 0,
  //         image:
  //           "https://cdn.profi.travel/local-storage/profi-travel/uploads/expert/photo/605e12caaf06a469924242.jpg",
  //         fullName: "Светлана Рос",
  //         position: "Директор по продажам сети Centara Hotels & Resorts, Таиланд, Бангкок",
  //       },
  //     ],
  //     id: 167022,
  //     type: "webinar",
  //     title:
  //       "Нескучный отдых на Мальдивах, Шри-Ланке и Таиланде: спецпредложения на 2021-й и виды услуг. Розыгрыш ваучера на проживание!",
  //     viewsCount: 0,
  //     participantsCount: 706,
  //     path: "/events/webinars/show/167022",
  //     date: "2021-04-26T10:00:00+03:00",
  //     dateEnd: "2021-04-26T11:00:00+03:00",
  //     status: 0,
  //     subscribed: false,
  //   },
  //   {
  //     label: null,
  //     companyTitle: "Adaaran Resorts, Heritance Aarah, Heritance Ayurveda",
  //     description:
  //       "<ol>\r\n\t<li>Знакомство с&nbsp;брендами Adaaran Club, Adaaran Select и&nbsp;Adaaran Prestige.</li>\r\n\t<li>История появления бренда Adaaran на&nbsp;Мальдивах и&nbsp;обзор отелей для семейного отдыха и других развлечений:\r\n\t<ul>\r\n\t\t<li>Adaaran Select Meedhupparu&nbsp;&mdash; концепция Premium All Inclusive Concept;</li>\r\n\t\t<li>Adaaran Select Hudhuranfushi&nbsp;&mdash; рай для серферов;</li>\r\n\t\t<li>Adaaran Club Rannalhi&nbsp;&mdash; клубная концепция;</li>\r\n\t\t<li>Adaaran Prestige Vadoo&nbsp;&mdash; идеальный курорт для пар и&nbsp;романтического отдыха.</li>\r\n\t</ul>\r\n\t</li>\r\n\t<li>Презентация нового отеля Heritance Aarah и&nbsp;его концепции Premium All Inclusive.</li>\r\n\t<li>Ответы на&nbsp;вопросы.</li>\r\n</ol>",
  //     scheduleDescription: null,
  //     experts: [
  //       {
  //         id: 7783,
  //         sorting: 0,
  //         image:
  //           "https://cdn.profi.travel/local-storage/profi-travel/uploads/expert/photo/6075592b71609231491369.jpg",
  //         fullName: "Шриниваса Редди",
  //         position:
  //           "Менеджер по развитию бизнеса, Adaaran Resorts, Heritance Aarah, Heritance Ayurveda Premium All Inclusive",
  //       },
  //       {
  //         id: 7786,
  //         sorting: 0,
  //         image:
  //           "https://cdn.profi.travel/local-storage/profi-travel/uploads/expert/photo/607697ea9d82a100859200.JPG",
  //         fullName: "Марина Смирнова",
  //         position: "Менеджер по развитию бизнеса в России и СНГ, Heritance Aarah",
  //       },
  //     ],
  //     id: 167071,
  //     type: "webinar",
  //     title:
  //       "Отели на Мальдивах: рай для семейного отдыха, презентация нового отеля и концепция Premium All Inclusive",
  //     viewsCount: 0,
  //     participantsCount: 408,
  //     path: "/events/webinars/show/167071",
  //     date: "2021-04-26T11:00:00+03:00",
  //     dateEnd: "2021-04-26T12:00:00+03:00",
  //     status: 0,
  //     subscribed: true,
  //   },
  //   {
  //     label: null,
  //     companyTitle: "Anantara на Шри-Ланке",
  //     description:
  //       "<ol>\r\n\t<li>Особенности оформления виз и&nbsp;правила въезда на&nbsp;Шри-Ланку.</li>\r\n\t<li>Правила нахождения в&nbsp;стране, возможности для отдыха и&nbsp;развлечений.</li>\r\n\t<li>Рассказ об&nbsp;отелях, их&nbsp;расположении и&nbsp;услугах:\r\n\t<ul>\r\n\t\t<li>Anantara Peace Haven Tangalle Resort;</li>\r\n\t\t<li>Anantara Kalutara;</li>\r\n\t\t<li>AVANI&nbsp;Kalutara.</li>\r\n\t</ul>\r\n\t</li>\r\n</ol>",
  //     scheduleDescription: null,
  //     experts: [
  //       {
  //         id: 7756,
  //         sorting: 0,
  //         image:
  //           "https://cdn.profi.travel/local-storage/profi-travel/uploads/expert/photo/5f58c86030473561173190.png",
  //         fullName: "Виктория Коликова",
  //         position: "Директор по продажам в России, СНГ и Восточной Европе, Minor Hotels",
  //       },
  //     ],
  //     id: 167049,
  //     type: "webinar",
  //     title:
  //       "Отели бренда на Шри-Ланке: особенности въезда, правила нахождения в стране и обзор трех объектов",
  //     viewsCount: 0,
  //     participantsCount: 585,
  //     path: "/events/webinars/show/167049",
  //     date: "2021-04-26T13:00:00+03:00",
  //     dateEnd: "2021-04-26T14:00:00+03:00",
  //     status: 0,
  //     subscribed: true,
  //   },
  //   {
  //     label: "Деловая программа",
  //     companyTitle: "Profi.Travel",
  //     description:
  //       "<p>С&nbsp;1&nbsp;июля 2021 года онлайн-касса становится обязательной для всех турагентств, включая&nbsp;ИП без наемных сотрудников. О&nbsp;том, что необходимо знать турагенту накануне важной даты, чтобы не&nbsp;столкнуться с&nbsp;проблемами в&nbsp;налоговой отчетности расскажет генеральный директор аудиторской компании &laquo;Аудит-Контур&raquo; Елена Иванова.</p>\r\n\r\n<p>В&nbsp;рамках эфира узнаем:</p>\r\n\r\n<ul>\r\n\t<li>Нужна&nbsp;ли касса при продаже онлайн?</li>\r\n\t<li>Какая информация должна быть в&nbsp;чеке?</li>\r\n\t<li>Как оформить оплату тура двумя платежами в&nbsp;разные даты?</li>\r\n\t<li>Чем грозит &laquo;пробитие&raquo; чека без внесенных данных о&nbsp;турпродукте?</li>\r\n</ul>",
  //     scheduleDescription: null,
  //     experts: [
  //       {
  //         id: 7730,
  //         sorting: 0,
  //         image:
  //           "https://cdn.profi.travel/local-storage/profi-travel/uploads/expert/photo/606c0fd846bbc818692855.png",
  //         fullName: "Елена Иванова",
  //         position: "Генеральный директор аудиторской компании «Аудит-Контур»",
  //       },
  //       {
  //         id: 7731,
  //         sorting: 0,
  //         image:
  //           "https://cdn.profi.travel/local-storage/profi-travel/uploads/expert/photo/606466c0254de907984308.png",
  //         fullName: "Ольга Осадчих",
  //         position: "Ведущая международной онлайн-выставки ОТМ. Лето",
  //       },
  //     ],
  //     id: 167030,
  //     type: "webinar",
  //     title: "Кассы в массы: комментарии эксперта по нововведениям в работе с онлайн-кассами",
  //     viewsCount: 0,
  //     participantsCount: 669,
  //     path: "/events/webinars/show/167030",
  //     date: "2021-04-26T16:00:00+03:00",
  //     dateEnd: "2021-04-26T17:00:00+03:00",
  //     status: 0,
  //     subscribed: false,
  //   },
  //   {
  //     label: null,
  //     companyTitle: "Принимающая компания CARPE-DIEM Travel",
  //     description:
  //       "<ul>\r\n\t<li>Обзор авторских туров в&nbsp;Армении, Грузии и&nbsp;Украине.</li>\r\n\t<li>Новинка: Армения&nbsp;&mdash; тур Всемирного наследия ЮНЕСКО.</li>\r\n\t<li>Комбинированные туры Беларусь&nbsp;&mdash; Украина.</li>\r\n\t<li>Экотуры в&nbsp;Украине и речной круиз по маршруту Мозырь &mdash; Киев &mdash; Мозырь.</li>\r\n\t<li><strong>Розыгрыш призов!</strong></li>\r\n</ul>",
  //     scheduleDescription: null,
  //     experts: [
  //       {
  //         id: 7778,
  //         sorting: 0,
  //         image: null,
  //         fullName: "Сергей Червяк",
  //         position: "Генеральный директор",
  //       },
  //     ],
  //     id: 167065,
  //     type: "webinar",
  //     title:
  //       "Предложения лета-2021: трипы по Армении и Грузии, тур Всемирного наследия ЮНЕСКО, речные круизы и комби-туры. Розыгрыш!",
  //     viewsCount: 0,
  //     participantsCount: 377,
  //     path: "/events/webinars/show/167065",
  //     date: "2021-04-27T14:00:00+03:00",
  //     dateEnd: "2021-04-27T15:00:00+03:00",
  //     status: 0,
  //     subscribed: true,
  //   },
  //   {
  //     label: null,
  //     companyTitle: "Туроператор «Спектрум»",
  //     description:
  //       "<ol>\r\n\t<li>Куда едем, как отдыхаем?\r\n\t<ul>\r\n\t\t<li>ОАЭ, Мальдивы, Сейшелы, Кипр, Армения, Абхазия&nbsp;&mdash; правила въезда и&nbsp;пребывания, ПЦР-тесты.</li>\r\n\t\t<li>Полетная программа из&nbsp;Москвы и&nbsp;регионов.</li>\r\n\t</ul>\r\n\t</li>\r\n\t<li>Пляжный отдых.\r\n\t<ul>\r\n\t\t<li>Изучаем ОАЭ: какой курорт выбрать для отдыха самого избирательного туриста.</li>\r\n\t\t<li>Мальдивы и&nbsp;Сейшелы&nbsp;&mdash; райские острова в&nbsp;Индийском океане.</li>\r\n\t\t<li>Кипр&nbsp;&mdash; наслаждаемся Средиземным морем.</li>\r\n\t\t<li>Абхазия&nbsp;&mdash; топ отелей для отдыха с&nbsp;детьми.</li>\r\n\t</ul>\r\n\t</li>\r\n\t<li>Экскурсионные туры.\r\n\t<ul>\r\n\t\t<li>Армения&nbsp;&mdash; гостеприимная страна.</li>\r\n\t\t<li>Винные дни в&nbsp;Ереване.</li>\r\n\t\t<li>Топ-10&nbsp;достопримечательностей, которые надо посмотреть в&nbsp;Армении.</li>\r\n\t\t<li>Экскурсии в&nbsp;Абхазии: что посмотреть во&nbsp;время путешествия.</li>\r\n\t\t<li>Гастрономические туры.</li>\r\n\t</ul>\r\n\t</li>\r\n\t<li>Лечение и&nbsp;SPA-программы.\r\n\t<ul>\r\n\t\t<li>Топ-5 пансионатов и&nbsp;санаториев Абхазии.</li>\r\n\t\t<li>SPA-программы отелей Кипра.</li>\r\n\t</ul>\r\n\t</li>\r\n\t<li>Для всех участников онлайн-презентации специальные условия по&nbsp;сотрудничеству!</li>\r\n</ol>",
  //     scheduleDescription: null,
  //     experts: [
  //       {
  //         id: 7802,
  //         sorting: 0,
  //         image:
  //           "https://cdn.profi.travel/local-storage/profi-travel/uploads/expert/photo/5ebd684d3fa81579712845.png",
  //         fullName: "Анна Додонова",
  //         position: "Начальник отдела маркетинга и развития агентской сети, «Спектрум»",
  //       },
  //       {
  //         id: 7803,
  //         sorting: 0,
  //         image:
  //           "https://cdn.profi.travel/local-storage/profi-travel/uploads/expert/photo/5ebd691121a5c372594363.png",
  //         fullName: "Елена Седова",
  //         position: "Ведущий специалист департамента по туризму, «Спектрум»",
  //       },
  //     ],
  //     id: 167081,
  //     type: "webinar",
  //     title:
  //       "Как отдыхаем, куда едем? Предложения туроператора на летние каникулы: пляжный отдых, экскурсионные туры, лечение и SPA-программы",
  //     viewsCount: 0,
  //     participantsCount: 419,
  //     path: "/events/webinars/show/167081",
  //     date: "2021-04-27T15:00:00+03:00",
  //     dateEnd: "2021-04-27T16:00:00+03:00",
  //     status: 0,
  //     subscribed: true,
  //   },
  //   {
  //     label: null,
  //     companyTitle: "PHĀEA Resorts, Греция",
  //     description:
  //       "<ol>\r\n\t<li>Blue Palace a&nbsp;Luxury Collection Resort &amp;&nbsp;Spa&nbsp;&mdash; роскошный отель с&nbsp;видом на&nbsp;реликтовый остров Спиналонга, спа-центр на&nbsp;пляже, плавание на&nbsp;каяках, экскурсионные пикники.</li>\r\n\t<li>Cretan Malia Park, Member of&nbsp;Design Hotels&nbsp;&mdash; уединенный песчаный пляж, длинный бассейн в&nbsp;форме реки, йога и&nbsp;медитация, органический кухонный сад.</li>\r\n\t<li>Agapi Beach Resort&nbsp;&mdash; курортный поселок с&nbsp;бунгало, уроки танца &laquo;Сиртаки&raquo;, изучение греческого языка, театр Garden.</li>\r\n</ol>",
  //     scheduleDescription: null,
  //     experts: [
  //       {
  //         id: 7814,
  //         sorting: 0,
  //         image:
  //           "https://cdn.profi.travel/local-storage/profi-travel/uploads/expert/photo/5dfb670bbc74e190930500.jpg",
  //         fullName: "Таисия Кутепова",
  //         position: "Менеджер по продажам",
  //       },
  //     ],
  //     id: 167085,
  //     type: "webinar",
  //     title:
  //       "Пикники на островах, органический кухонный сад, театр и спа на побережье Элунда — идеальный отдых в отелях на Крите!",
  //     viewsCount: 0,
  //     participantsCount: 95,
  //     path: "/events/webinars/show/167085",
  //     date: "2021-04-28T10:00:00+03:00",
  //     dateEnd: "2021-04-28T11:00:00+03:00",
  //     status: 0,
  //     subscribed: false,
  //   },
  //   {
  //     label: null,
  //     companyTitle: "Авиакомпания Turkish Airlines",
  //     description:
  //       "<ol>\r\n\t<li>География полетов авиакомпании Turkish Airlines в&nbsp;России и&nbsp;мире.</li>\r\n\t<li>Меры безопасности на&nbsp;борту.</li>\r\n\t<li>Обслуживание во&nbsp;время полета.</li>\r\n\t<li>Программа для часто летающих пассажиров Miles &amp;&nbsp;Smiles.</li>\r\n\t<li>Новые рейсы в&nbsp;Бодрум и&nbsp;Даламан из&nbsp;Москвы.</li>\r\n</ol>",
  //     scheduleDescription: null,
  //     experts: [
  //       {
  //         id: 7760,
  //         sorting: 0,
  //         image:
  //           "https://cdn.profi.travel/local-storage/profi-travel/uploads/expert/photo/606ed6f8869ef796847285.JPG",
  //         fullName: "Евгения Муслу",
  //         position: "Специалист отдела маркетинга, Turkish Airlines",
  //       },
  //     ],
  //     id: 167051,
  //     type: "webinar",
  //     title:
  //       "Безопасные и комфортные полеты в сезоне-2021: правила компании, новые рейсы в Бодрум и Даламан и программа для постоянных клиентов",
  //     viewsCount: 0,
  //     participantsCount: 678,
  //     path: "/events/webinars/show/167051",
  //     date: "2021-04-28T11:00:00+03:00",
  //     dateEnd: "2021-04-28T12:00:00+03:00",
  //     status: 0,
  //     subscribed: false,
  //   },
  //   {
  //     label: null,
  //     companyTitle: "Туроператор по морским круизам CruClub",
  //     description:
  //       "<ol>\r\n\t<li>Как круизные компании и&nbsp;операторы переживают пандемию?</li>\r\n\t<li>Какие круизы и&nbsp;направления доступны для россиян летом-2021?</li>\r\n\t<li>Royal Caribbean выбирает CruClub! В&nbsp;гостях представитель компании Александр Самунджян.</li>\r\n\t<li>Royal Caribbean&nbsp;&mdash; старт продаж для граждан России и&nbsp;не&nbsp;только.</li>\r\n\t<li>Протоколы безопасности: что ждет пассажиров на&nbsp;борту?</li>\r\n\t<li>Что надо брать, чтобы потом не&nbsp;пожалеть?</li>\r\n\t<li>&laquo;Что делать, если...&raquo;&nbsp;&mdash; ответы на&nbsp;вопросы.</li>\r\n\t<li>CruClub рядом&nbsp;&mdash; поддержка от&nbsp;компании.</li>\r\n</ol>",
  //     scheduleDescription: null,
  //     experts: [
  //       {
  //         id: 7784,
  //         sorting: 0,
  //         image:
  //           "https://cdn.profi.travel/local-storage/profi-travel/uploads/expert/photo/5b7c067cc2ff4832405404.jpg",
  //         fullName: "Ирина Старкова",
  //         position: "Руководитель агентского отдела туроператора по морским круизам CruClub",
  //       },
  //     ],
  //     id: 167072,
  //     type: "webinar",
  //     title:
  //       "Какие круизы будут доступны россиянам летом-2021? Новости компании: перезапуск круизов с Royal Caribbean!",
  //     viewsCount: 0,
  //     participantsCount: 436,
  //     path: "/events/webinars/show/167072",
  //     date: "2021-04-28T12:00:00+03:00",
  //     dateEnd: "2021-04-28T13:00:00+03:00",
  //     status: 0,
  //     subscribed: true,
  //   },
  //   {
  //     label: null,
  //     companyTitle: "Profi.Travel",
  //     description: "Программа уточняется",
  //     scheduleDescription: null,
  //     experts: [
  //       {
  //         id: 7793,
  //         sorting: 0,
  //         image:
  //           "https://cdn.profi.travel/local-storage/profi-travel/uploads/expert/photo/606466c0254de907984308.png",
  //         fullName: "Ольга Осадчих",
  //         position: "Ведущая международной онлайн-выставки ОТМ. Лето",
  //       },
  //     ],
  //     id: 167069,
  //     type: "webinar",
  //     title: "Эфир закрытия онлайн-выставки «ОТМ: Лето 2021». Подводим итоги и дарим главные призы",
  //     viewsCount: 0,
  //     participantsCount: 369,
  //     path: "/events/webinars/show/167069",
  //     date: "2021-04-28T14:00:00+03:00",
  //     dateEnd: "2021-04-28T16:00:00+03:00",
  //     status: 0,
  //     subscribed: true,
  //   },
  //   {
  //     label: null,
  //     companyTitle: "NKAR Travels & Tours",
  //     description: null,
  //     scheduleDescription: null,
  //     experts: [],
  //     id: 167088,
  //     type: "webinar",
  //     title: "Шри-Ланка — особенности продаж",
  //     viewsCount: 0,
  //     participantsCount: 39,
  //     path: "/events/webinars/show/167088",
  //     date: "2021-06-10T11:00:00+03:00",
  //     dateEnd: "2021-06-10T13:00:00+03:00",
  //     status: 0,
  //     subscribed: false,
  //   },
  // ],
  // data: {
  //   "Mon Apr 12 2021 12:00:00 GMT+0300": [
  //     {
  //       label: "ОТКРЫТИЕ",
  //       companyTitle: null,
  //       description:
  //         "<p><strong>12:00 &mdash; 12:05</strong><br />\r\n<strong>СЕО Profi.Travel Алексей&nbsp;Венгин</strong></p>\r\n\r\n<ul>\r\n\t<li>Приветственное слово для участников ОТМ: Лето 2021</li>\r\n</ul>\r\n\r\n<p><strong>12:05 &mdash; 12:20<br />\r\nАртем Чумак, главный редактор Profi.Travel</strong></p>\r\n\r\n<ul>\r\n\t<li>Поехали! Или каким будет сезон-2021.</li>\r\n</ul>\r\n\r\n<p><strong>12:20 &mdash; 12:45<br />\r\nТом Дженкинс, генеральный директор Европейской туристической ассоциации (ETOA)</strong></p>\r\n\r\n<ul>\r\n\t<li>Похищение Европы: как будет восстанавливаться туризм, перспективы открытия стран.</li>\r\n</ul>\r\n\r\n<p><strong>12:45 &mdash; 13:10<br />\r\nОливер Мартин, член Исполнительного совета Туристической ассоциации стран Азии и Тихого океана (PATA), партнер в Twenty31 Consulting</strong></p>\r\n\r\n<ul>\r\n\t<li>Путь Азии &mdash; 2021: прогнозы по восстановлению турпотоков, новые возможности дестинаций и туроператоров.</li>\r\n</ul>\r\n\r\n<p><strong>13:10 &mdash; 13:35</strong><br />\r\n<strong>Андрей Игнатьев, президент Российского союза туриндустрии</strong></p>\r\n\r\n<ul>\r\n\t<li>Россия &mdash; перезагрузка: как поменялась ситуация на туристическом рынке за время пандемии.</li>\r\n</ul>\r\n\r\n<p><strong>13:35 &mdash; 14:00<br />\r\nЕгор Плахов, региональный директор Emirates по коммерческим операциям в Европе и Российской Федерации</strong></p>\r\n\r\n<ul>\r\n\t<li>Первым делом самолеты: серьезный разговор с&nbsp;Emirates о&nbsp;том, когда, куда и&nbsp;за&nbsp;сколько мы&nbsp;будем летать после коронакризиса.</li>\r\n</ul>\r\n\r\n<p><strong>14:00 &mdash; 14:40<br />\r\nОлеся Олейникова, директор по развитию Profi.Travel</strong></p>\r\n\r\n<ul>\r\n\t<li>Бизнес без границ: как в пандемию укрепить сотрудничество с зарубежными партнерами и найти новых? Уникальная система нетворкинга от Profi.Travel.</li>\r\n</ul>\r\n\r\n<p><strong>Сергей Перемутов, куратор программы лояльности для турбизнеса Profi.Travel Loyalty</strong></p>\r\n\r\n<ul>\r\n\t<li>Как укрепить сотрудничество с зарубежными партнерами и найти новых, когда границы закрыты: уникальность и преимущества новой системы нетворкинга от Profi.Travel.</li>\r\n</ul>",
  //       scheduleDescription:
  //         "Какие страны откроются для российских туристов быстрее других, какими будут ключевые тренды в сезоне-2021 и как новая система нетворкинга от Profi.Travel помогает не растерять бизнес-связи и приобрести новых партнеров в эпоху закрытых границ.",
  //       experts: [
  //         {
  //           id: 7721,
  //           sorting: 1,
  //           image:
  //             "https://cdn.profi.travel/local-storage/profi-travel/uploads/expert/photo/5f742f4db6685741719718.png",
  //           fullName: "Алексей Венгин",
  //           position: "CEO Profi.Travel",
  //         },
  //         {
  //           id: 7722,
  //           sorting: 2,
  //           image:
  //             "https://cdn.profi.travel/local-storage/profi-travel/uploads/expert/photo/606434101376f248077593.png",
  //           fullName: "Артем Чумак",
  //           position: "Главный редактор портала Profi.Travel",
  //         },
  //         {
  //           id: 7723,
  //           sorting: 3,
  //           image:
  //             "https://cdn.profi.travel/local-storage/profi-travel/uploads/expert/photo/606434b56fafc286910854.png",
  //           fullName: "Том Дженкинс",
  //           position: "Генеральный директор Европейской туристической ассоциации (ETOA)",
  //         },
  //         {
  //           id: 7724,
  //           sorting: 4,
  //           image:
  //             "https://cdn.profi.travel/local-storage/profi-travel/uploads/expert/photo/60643514d9629319568286.png",
  //           fullName: "Оливер Мартин",
  //           position:
  //             "Член Исполнительного совета Туристической ассоциации стран Азии и Тихого океана (PATA), партнер Twenty31 в Consulting",
  //         },
  //         {
  //           id: 7762,
  //           sorting: 5,
  //           image:
  //             "https://cdn.profi.travel/local-storage/profi-travel/uploads/expert/photo/606ef75e2e6ec037813810.png",
  //           fullName: "Андрей Игнатьев",
  //           position: "Президент Российского союза туриндустрии",
  //         },
  //         {
  //           id: 7725,
  //           sorting: 6,
  //           image:
  //             "https://cdn.profi.travel/local-storage/profi-travel/uploads/expert/photo/60645d0376029545769826.jpg",
  //           fullName: "Олеся Олейникова",
  //           position: "Директор по развитию Profi.Travel",
  //         },
  //         {
  //           id: 7726,
  //           sorting: 7,
  //           image:
  //             "https://cdn.profi.travel/local-storage/profi-travel/uploads/expert/photo/6064614641bb8508286528.png",
  //           fullName: "Сергей Перемутов",
  //           position: "Куратор программы лояльности для турбизнеса Profi.Travel Loyalty",
  //         },
  //       ],
  //       id: 23,
  //       type: "broadcast",
  //       title: "Торжественное открытие ОТМ: Лето 2021",
  //       viewsCount: 4449,
  //       participantsCount: 644,
  //       path: "/broadcast/23",
  //       date: "2021-04-12T12:00:00+03:00",
  //       dateEnd: "2021-04-12T15:00:00+03:00",
  //       status: 1,
  //       subscribed: true,
  //     },
  //   ],
  //   "Mon Apr 12 2021 15:00:00 GMT+0300": [
  //     {
  //       label: null,
  //       companyTitle: "Гостиничная сеть Falkensteiner Hotels & Residences",
  //       description:
  //         "<ol>\r\n\t<li>Общая информация о&nbsp;Falkensteiner Hotels &amp;&nbsp;Residences&nbsp;&mdash; история бренда, девиз, география.</li>\r\n\t<li>Презентации отелей:\r\n\t<ul>\r\n\t\t<li><strong>Италия, Сардиния&nbsp;&mdash; Capo Boi&nbsp;5*:</strong>&nbsp;песчаный пляж, виллы до&nbsp;4&nbsp;спален, детский клуб и&nbsp;мини<strong>-</strong>зоопарк.</li>\r\n\t\t<li><strong>Италия, Венето&nbsp;&mdash; Hotel &amp;&nbsp;Spa Jesolo&nbsp;5*:</strong>&nbsp;один из&nbsp;двух отелей 5*&nbsp;в регионе с&nbsp;детским центром, пляжем и&nbsp;спа.</li>\r\n\t\t<li><strong>Австрия&nbsp;&mdash; Schlosshotel Velden&nbsp;5*:</strong>&nbsp;отель-замок на&nbsp;берегу озера, свой пляж, спа-центр.</li>\r\n\t\t<li><strong>Черногория, Бечичи&nbsp;&mdash; Hotel Montenegro&nbsp;4*:</strong>&nbsp;обновленные номера, песчано-галечный пляж, активности на&nbsp;территории отеля.</li>\r\n\t\t<li><strong>Хорватия, Пунта Скала&nbsp;&mdash; Hotel &amp;&nbsp;SPA Iadera&nbsp;5*, Family&nbsp;</strong><strong>H</strong><strong>otel Diaora&nbsp;4*, Premium&nbsp;</strong><strong>A</strong><strong>partments Senia</strong>: комплекс отелей с&nbsp;потрясающими возможностями для отдыха и&nbsp;MICE.</li>\r\n\t\t<li><strong>Хорватия, Задар, Борик&nbsp;&mdash;&nbsp;</strong>отели&nbsp;<strong>Club Funimation Borik&nbsp;4*</strong>,&nbsp;<strong>H</strong><strong>otel Adriana 4*</strong>&nbsp;для отдыха без детей, а&nbsp;также расположенный рядом комплекс&nbsp;<strong>Premium Camping Zadar</strong>&nbsp;со&nbsp;спа-центром Acquapura.</li>\r\n\t\t<li><strong>Чехия, Марианские Лазне&nbsp;&mdash; Spa Resort Marianske Lazne&nbsp;5*</strong>: идеальное место для восстановления и&nbsp;оздоровления.</li>\r\n\t\t<li><strong>Сербия, Белград&nbsp;&mdash; Hotel Belgrade&nbsp;4*</strong>: городской отель с&nbsp;детским клубом, возможностями для MICE и&nbsp;отдыха. Прямой эфир из&nbsp;отеля.</li>\r\n\t</ul>\r\n\t</li>\r\n</ol>",
  //       scheduleDescription: null,
  //       experts: [
  //         {
  //           id: 7729,
  //           sorting: 0,
  //           image:
  //             "https://cdn.profi.travel/local-storage/profi-travel/uploads/expert/photo/606464727de0c053759700.jpg",
  //           fullName: "Евгения Дунаева",
  //           position: "Менеджер по продажам в России",
  //         },
  //         {
  //           id: 7772,
  //           sorting: 0,
  //           image:
  //             "https://cdn.profi.travel/local-storage/profi-travel/uploads/expert/photo/6070047054a82662702476.jpg",
  //           fullName: "Таня Милошевич",
  //           position: "Менеджер по продажам Россия и СНГ",
  //         },
  //       ],
  //       id: 167027,
  //       type: "webinar",
  //       title:
  //         "Летний сезон — 2021 в Европе: отдых на озерах, лечение и восстановление организма. Онлайн-включение из отеля в Белграде!",
  //       viewsCount: 115,
  //       participantsCount: 673,
  //       path: "/events/webinars/show/167027",
  //       date: "2021-04-12T15:00:00+03:00",
  //       dateEnd: "2021-04-12T16:00:00+03:00",
  //       status: 1,
  //       subscribed: false,
  //     },
  //   ],
  //   "Tue Apr 13 2021 11:00:00 GMT+0300": [
  //     {
  //       label: null,
  //       companyTitle: "Греческая Национальная Туристическая Организация",
  //       description:
  //         "<ul>\r\n\t<li>Греция после пандемии: апдейт по&nbsp;ситуации в&nbsp;стране.</li>\r\n\t<li>Откроется&nbsp;ли Греция 14&nbsp;мая? Прогнозы представителя ГНТО.</li>\r\n\t<li>Какие протоколы безопасности нужно будет соблюдать туристам?</li>\r\n\t<li>Как страна готовится к&nbsp;возобновлению турпотока?</li>\r\n\t<li>Какие отели возобновят работу и&nbsp;как будет организовано пребывание в&nbsp;них после карантина?</li>\r\n\t<li>Какие виды туризма станут приоритетными в&nbsp;этом сезоне?</li>\r\n\t<li>Как турагентам взаимодействовать с&nbsp;клиентами, чтобы успешно продавать направление?</li>\r\n</ul>",
  //       scheduleDescription: null,
  //       experts: [
  //         {
  //           id: 7773,
  //           sorting: 0,
  //           image:
  //             "https://cdn.profi.travel/local-storage/profi-travel/uploads/expert/photo/5af19fc3bba92273651856.jpeg",
  //           fullName: "Георгий Мавроматис",
  //           position: "Специалист по маркетингу Греческой Национальной Туристической Организации",
  //         },
  //       ],
  //       id: 167061,
  //       type: "webinar",
  //       title:
  //         "Осуществится ли план по открытию Греции 14 мая и какая сейчас обстановка в стране? Подробности и прогнозы представителя ГНТО",
  //       viewsCount: 211,
  //       participantsCount: 650,
  //       path: "/events/webinars/show/167061",
  //       date: "2021-04-13T11:00:00+03:00",
  //       dateEnd: "2021-04-13T13:00:00+03:00",
  //       status: 1,
  //       subscribed: true,
  //     },
  //   ],
  //   "Tue Apr 13 2021 13:00:00 GMT+0300": [
  //     {
  //       label: null,
  //       companyTitle: "Курорт Porto Carras Grand Resort",
  //       description:
  //         "<ul>\r\n\t<li>Видеоэкскурсия по основным объектам Porto Carras.</li>\r\n\t<li>Презентация Porto Carras Meliton и всех видов номеров.</li>\r\n\t<li>Винодельня Domaine Porto Carras &mdash; крупнейший органический виноградник в Греции.</li>\r\n\t<li>Зеленая территория комплекса, 9 км песчаных пляжей и 25 бухт.</li>\r\n\t<li>Досуг: водные горки, гольф, дайвинг, казино, талассотерапия, верховая езда и многое другое.</li>\r\n\t<li><strong>Розыгрыш двух ночей на полупансионе с дегустацией вина для двоих в Domaine Porto Carras!</strong></li>\r\n</ul>",
  //       scheduleDescription: null,
  //       experts: [
  //         {
  //           id: 7744,
  //           sorting: 0,
  //           image:
  //             "https://cdn.profi.travel/local-storage/profi-travel/uploads/expert/photo/6069a01d4069a463328626.jpg",
  //           fullName: "Татьяна Веденеева",
  //           position: "Sales Representation SK Hospitality",
  //         },
  //       ],
  //       id: 167039,
  //       type: "webinar",
  //       title:
  //         "Презентация курорта с новой структурой и новым менеджментом. Розыгрыш отдыха на Халкидиках!",
  //       viewsCount: 106,
  //       participantsCount: 821,
  //       path: "/events/webinars/show/167039",
  //       date: "2021-04-13T13:00:00+03:00",
  //       dateEnd: "2021-04-13T14:00:00+03:00",
  //       status: 1,
  //       subscribed: true,
  //     },
  //   ],
  //   "Tue Apr 13 2021 14:00:00 GMT+0300": [
  //     {
  //       label: null,
  //       companyTitle: "Отель Kassandra Palace",
  //       description:
  //         "<p><strong>Знакомство с семейным отелем Kassandra Palace Hotel &amp; Spa:&nbsp;</strong></p>\r\n\r\n<ol>\r\n\t<li>Варианты размещения: множество бунгало с элегантно оформленными номерами и сьютами.</li>\r\n\t<li>Питание:&nbsp;3 ресторана и 3 бара.&nbsp;</li>\r\n\t<li>Досуг:&nbsp;SPA,&nbsp;велнес-центр, 3 открытых бассейна, мини-клуб и другие развлечения.</li>\r\n\t<li><strong>Розыгрыш&nbsp;трех ночей на полупансионе и двух фирменных коктейлей у нового бассейна!</strong></li>\r\n</ol>",
  //       scheduleDescription: null,
  //       experts: [
  //         {
  //           id: 7743,
  //           sorting: 0,
  //           image:
  //             "https://cdn.profi.travel/local-storage/profi-travel/uploads/expert/photo/6065ee1e9b0bf917268126.jpg",
  //           fullName: "Татьяна Веденеева",
  //           position: "Торговый представитель SK Hospitality",
  //         },
  //       ],
  //       id: 167038,
  //       type: "webinar",
  //       title:
  //         "«Пятизвездочный» семейный отдых на Халкидиках: спа-центр, греческая кухня и номера на любой вкус. Розыгрыш проживания!",
  //       viewsCount: 100,
  //       participantsCount: 796,
  //       path: "/events/webinars/show/167038",
  //       date: "2021-04-13T14:00:00+03:00",
  //       dateEnd: "2021-04-13T15:00:00+03:00",
  //       status: 1,
  //       subscribed: true,
  //     },
  //   ],
  //   "Tue Apr 13 2021 15:00:00 GMT+0300": [
  //     {
  //       label: null,
  //       companyTitle: "Сеть отелей MarBella Collection",
  //       description:
  //         "<ol>\r\n\t<li><strong>MarBella Corfu:</strong>\r\n\t<ul>\r\n\t\t<li>семейный отдых премиум-уровня на&nbsp;базе питания &laquo;полупансион&raquo; или &laquo;все включено&raquo;;</li>\r\n\t\t<li>инфраструктура: 388 номеров и&nbsp;сьютов, 4&nbsp;ресторана, 4&nbsp;бара, 2&nbsp;бассейна (Infinity и&nbsp;Lagoon), SPA, тренажерный зал, приватный пляж;</li>\r\n\t\t<li>развлечения: аквапарк, детский клуб, ясли, приключенческий клуб, экскурсии, спорт, водные активности, ночное кино, пляжные вечеринки, живая музыка.</li>\r\n\t</ul>\r\n\t</li>\r\n\t<li><strong>MarBella Nido:</strong>\r\n\t<ul>\r\n\t\t<li>бутик-отель класса люкс с&nbsp;панорамными видами на&nbsp;Ионическое море;</li>\r\n\t\t<li>инфраструктура: 70&nbsp;сьютов, 2&nbsp;ресторана, 2&nbsp;бара, Оранжерея и&nbsp;Патио Лаундж, SPA, тренажерный зал, приватный пляж;</li>\r\n\t\t<li>фишки отеля: персонализированный сервис, размещение 18+;</li>\r\n\t\t<li>развлечения Tailor Made: дегустация вина, кулинарные мастер-классы, воскресный полдник в&nbsp;сопровождении живой музыки.</li>\r\n\t</ul>\r\n\t</li>\r\n\t<li><strong>MarBella Elix:</strong>\r\n\t<ul>\r\n\t\t<li>расположение: материковая Греция, Теспроти, пляж Каравостаси&nbsp;&mdash; рядом Парга, река Ахерон, Метеора, Загори;</li>\r\n\t\t<li>услуги: 3&nbsp;бара, 2&nbsp;ресторана, SPA, тренажерный зал, теннисный корт, дневные и&nbsp;вечерние мероприятия, активный отдых для детей и&nbsp;подростков, услуги няни (по&nbsp;запросу), фуникулер на&nbsp;оборудованный пляж.</li>\r\n\t</ul>\r\n\t</li>\r\n\t<li><strong>Обзор мобильного приложения MarBella Collection Contactless Journey.</strong></li>\r\n</ol>",
  //       scheduleDescription: null,
  //       experts: [
  //         {
  //           id: 7754,
  //           sorting: 0,
  //           image:
  //             "https://cdn.profi.travel/local-storage/profi-travel/uploads/expert/photo/606ea2ecb7ed7767281461.png",
  //           fullName: "Милана Тонева",
  //           position: "Представитель компании MarBella Collection в России и странах СНГ",
  //         },
  //       ],
  //       id: 167046,
  //       type: "webinar",
  //       title:
  //         "Отели на Корфу и Каравостаси в Греции: семейный отдых премиум-уровня, бутик-отель 18+ и мобильное приложение для туристов",
  //       viewsCount: 118,
  //       participantsCount: 712,
  //       path: "/events/webinars/show/167046",
  //       date: "2021-04-13T15:00:00+03:00",
  //       dateEnd: "2021-04-13T16:00:00+03:00",
  //       status: 1,
  //       subscribed: true,
  //     },
  //   ],
  //   "Tue Apr 13 2021 16:00:00 GMT+0300": [
  //     {
  //       label: null,
  //       companyTitle: "Принимающая компания Kalamaki Travel",
  //       description:
  //         "<ul>\r\n\t<li>Остров Крит и&nbsp;его особенности.</li>\r\n\t<li>Регионы острова и&nbsp;их&nbsp;направленность.</li>\r\n\t<li>Новинки сезона-2021.</li>\r\n\t<li>Чем удобно сотрудничество с&nbsp;Kalamaki Travel?</li>\r\n\t<li><strong>Розыгрыш проживаний: 3&nbsp;ночи в&nbsp;отеле Stefan Village 4*,&nbsp;3&nbsp;ночи в&nbsp;отеле Kavros Beach&nbsp;3*, 7 ночей в отеле Galini Sea View 5* и 7 ночей в отеле Airis Boutique Hotel &amp; Suites 4*!</strong></li>\r\n</ul>",
  //       scheduleDescription: null,
  //       experts: [
  //         {
  //           id: 7769,
  //           sorting: 0,
  //           image:
  //             "https://cdn.profi.travel/local-storage/profi-travel/uploads/expert/photo/606f673f5e06b357755597.jpg",
  //           fullName: "Евгения Морозова",
  //           position: "Руководитель отдела продаж Kalamaki Travel",
  //         },
  //       ],
  //       id: 167058,
  //       type: "webinar",
  //       title:
  //         "Крит: обзор направления от принимающего туроператора и новинки сезона-2021. Розыгрыш проживаний в четырех отелях!",
  //       viewsCount: 138,
  //       participantsCount: 641,
  //       path: "/events/webinars/show/167058",
  //       date: "2021-04-13T16:00:00+03:00",
  //       dateEnd: "2021-04-13T17:00:00+03:00",
  //       status: 1,
  //       subscribed: true,
  //     },
  //   ],
  //   "Wed Apr 14 2021 11:00:00 GMT+0300": [
  //     {
  //       label: null,
  //       companyTitle: "Сеть курортов и отелей JA Resorts & Hotels",
  //       description:
  //         "<ol>\r\n\t<li>Новости и&nbsp;новинки JA&nbsp;Resorts &amp;&nbsp;Hotels.</li>\r\n\t<li>Открытие JA&nbsp;Lake View Hotel.</li>\r\n\t<li>Популярные отели на&nbsp;The Walk, JBR.</li>\r\n\t<li>Новой резорт на&nbsp;Сейшелах&nbsp;&mdash; Enchanted Waterfront Villas.</li>\r\n\t<li>Идиллия на&nbsp;Мальдивском острове&nbsp;&mdash; JA&nbsp;Manafaru.</li>\r\n</ol>",
  //       scheduleDescription: null,
  //       experts: [
  //         {
  //           id: 7759,
  //           sorting: 0,
  //           image:
  //             "https://cdn.profi.travel/local-storage/profi-travel/uploads/expert/photo/5f7c244bb612c503284793.jpg",
  //           fullName: "Анастасия Коваленко",
  //           position: "Менеджер по продажам сети отелей JA Resorts & Hotels",
  //         },
  //       ],
  //       id: 167050,
  //       type: "webinar",
  //       title: "Незабываемый отдых летом 2021-го с новинками сети отелей в ОАЭ и Индийском океане!",
  //       viewsCount: 84,
  //       participantsCount: 641,
  //       path: "/events/webinars/show/167050",
  //       date: "2021-04-14T11:00:00+03:00",
  //       dateEnd: "2021-04-14T12:00:00+03:00",
  //       status: 1,
  //       subscribed: false,
  //     },
  //   ],
  //   "Wed Apr 14 2021 12:00:00 GMT+0300": [
  //     {
  //       label: null,
  //       companyTitle: "Отель Hotel Indigo Dubai Downtown",
  //       description:
  //         "<ol>\r\n\t<li>Презентация первого арт-бутик-отеля в эмиратах в сердце Дубая.</li>\r\n\t<li>Услуги и&nbsp;возможности для туристов: ресторан, бар, бизнес-центр, бесплатная&nbsp;частная&nbsp;парковка, открытый&nbsp;бассейн и фитнес-центр.</li>\r\n\t<li>Питание:&nbsp;континентальный завтрак или завтрак &mdash; шведский стол.</li>\r\n\t<li><strong>Розыгрыш призов!</strong></li>\r\n</ol>",
  //       scheduleDescription: null,
  //       experts: [
  //         {
  //           id: 7745,
  //           sorting: 0,
  //           image:
  //             "https://cdn.profi.travel/local-storage/profi-travel/uploads/expert/photo/606726f93b5ba469209721.jpg",
  //           fullName: "Дания Жумашева",
  //           position: "Менеджер по развитию бизнеса в Hotel Indigo Dubai Downtown",
  //         },
  //       ],
  //       id: 167040,
  //       type: "webinar",
  //       title:
  //         "Первый арт-бутик-отель в эмиратах! Знакомство с уголком арабской культуры в самом центре Дубая. Розыгрыш призов!",
  //       viewsCount: 66,
  //       participantsCount: 769,
  //       path: "/events/webinars/show/167040",
  //       date: "2021-04-14T12:00:00+03:00",
  //       dateEnd: "2021-04-14T13:00:00+03:00",
  //       status: 1,
  //       subscribed: false,
  //     },
  //   ],
  //   "Wed Apr 14 2021 13:00:00 GMT+0300": [
  //     {
  //       label: null,
  //       companyTitle: "Комплекс отелей Caesars Palace Dubai",
  //       description:
  //         "<ol>\r\n\t<li>Объекты на острове Bluewaters: luxury-отель Caesars Palace Dubai, самое большое в мире колесо обозрения Ain Dubai, резиденции, рестораны, игровые площадки, сады и развлекательные комплексы.&nbsp;</li>\r\n\t<li>Ребрендинг. Новая концепция отеля Caesars Palace Dubai: атмосфера Древнего Рима и роскошный отдых для пар и всей семьи &mdash; от королевского спа до детского клуба Empire Club:\r\n\t<ul>\r\n\t\t<li>Palace Tower;</li>\r\n\t\t<li>Julius Tower;</li>\r\n\t\t<li>Apartments и The Residences.</li>\r\n\t</ul>\r\n\t</li>\r\n\t<li>Hell&rsquo;s Kitchen&nbsp;&mdash; второй в&nbsp;мире ресторан Гордона Рамзи:\r\n\t<ul>\r\n\t\t<li>удостоен нескольких звезд Мишлен;</li>\r\n\t\t<li>кулинарное шоу мирового класса;</li>\r\n\t\t<li>фирменные блюда Шефа: бургеры, пудинг и&nbsp;знаменитая говядина &laquo;Веллингтон&raquo;.</li>\r\n\t</ul>\r\n\t</li>\r\n\t<li>Молодежная тусовка ROAM&nbsp;&mdash; креативное пространство с&nbsp;игровыми зонами для подростков.</li>\r\n\t<li>Специальные предложения для семей на лето: семейные категории номеров.&nbsp;</li>\r\n\t<li>Коллекция предметов искусства Caesars Palace Dubai от&nbsp;американского дизайнера Джонатана Адлера и&nbsp;другие &laquo;фишки&raquo; отеля.</li>\r\n</ol>",
  //       scheduleDescription: null,
  //       experts: [
  //         {
  //           id: 7775,
  //           sorting: 0,
  //           image:
  //             "https://cdn.profi.travel/local-storage/profi-travel/uploads/expert/photo/5e2184f18897b573779294.jpg",
  //           fullName: "Татьяна Шумилова",
  //           position: "Senior Sales Manager",
  //         },
  //       ],
  //       id: 167062,
  //       type: "webinar",
  //       title:
  //         "Знакомство с отелем-островом в Дубае: 500-метровый пляж, «Адская кухня» Гордона Рамзи и королевский спа-центр",
  //       viewsCount: 62,
  //       participantsCount: 500,
  //       path: "/events/webinars/show/167062",
  //       date: "2021-04-14T13:00:00+03:00",
  //       dateEnd: "2021-04-14T14:00:00+03:00",
  //       status: 1,
  //       subscribed: false,
  //     },
  //   ],
  //   "Wed Apr 14 2021 14:00:00 GMT+0300": [
  //     {
  //       label: null,
  //       companyTitle:
  //         "Отели Le Meridien Al Aqah Beach Hotel, JW Marriott Marquis Dubai Hotel, Al Maha, a Luxury Collection Desert Resort & Spa",
  //       description:
  //         "<ol>\r\n\t<li>Новости из Объединенных Арабских Эмиратов.</li>\r\n\t<li><strong>Le Meridien Al Aqah Beach Resort:</strong> обновленные номера после реновации 2014 года, типы питания и развлечения.</li>\r\n\t<li><strong>JW Marriott Marquis Dubai Hotel:</strong> знакомство с самым высоким в мире пятизвездочным отелем.</li>\r\n\t<li><strong>Al Maha, a Luxury Collection Desert Resort and Spa:</strong> роскошный отель в пустыне, на территории Национального Дубайского Заповедника.</li>\r\n</ol>",
  //       scheduleDescription: null,
  //       experts: [
  //         {
  //           id: 7770,
  //           sorting: 0,
  //           image:
  //             "https://cdn.profi.travel/local-storage/profi-travel/uploads/expert/photo/5f777836a119d508513943.jpg",
  //           fullName: "Нигяр Самедова",
  //           position:
  //             "Менеджер по продажам отелей Le Meridien Al Aqah Beach Hotel, JW Marriott Marquis Dubai Hotel, Al Maha, a Luxury Collection Desert Resort & Spa",
  //         },
  //       ],
  //       id: 167059,
  //       type: "webinar",
  //       title:
  //         "Три уникальных отеля Marriott International в ОАЭ: откройте туристам величие арабской культуры!",
  //       viewsCount: 53,
  //       participantsCount: 602,
  //       path: "/events/webinars/show/167059",
  //       date: "2021-04-14T14:00:00+03:00",
  //       dateEnd: "2021-04-14T15:00:00+03:00",
  //       status: 1,
  //       subscribed: true,
  //     },
  //   ],
  //   "Wed Apr 14 2021 15:00:00 GMT+0300": [
  //     {
  //       label: null,
  //       companyTitle: "Сеть отелей Rotana Hotels & Resorts",
  //       description:
  //         "<ol>\r\n\t<li>Amwaj Rotana Dubai 5*&nbsp;и&nbsp;новые семейные номера.</li>\r\n\t<li>Rose Rayhaan 4*&nbsp;с увеличенным количеством трансферов на&nbsp;пляж.</li>\r\n\t<li>Обзоры отелей Towers Rotana&nbsp;4*, Media Rotana&nbsp;5*, Al&nbsp;Bandar Rotana&nbsp;5*, Jumeira Rotana&nbsp;4*, Centro Barsha 3*&nbsp;и&nbsp;Centro Sharjah&nbsp;3*.</li>\r\n\t<li>Новинка Дубая&nbsp;&mdash; Al&nbsp;Jaddaf Rotana deluxe. Открылся в&nbsp;2020&nbsp;году!</li>\r\n\t<li><strong>Розыгрыш ваучера на проживание!&nbsp;</strong></li>\r\n</ol>",
  //       scheduleDescription: null,
  //       experts: [
  //         {
  //           id: 7755,
  //           sorting: 0,
  //           image:
  //             "https://cdn.profi.travel/local-storage/profi-travel/uploads/expert/photo/5f7c8367c5a3d132567308.png",
  //           fullName: "Надежда Щербакова",
  //           position: "Директор по продажам Rotana Hotels & Resorts в России",
  //         },
  //       ],
  //       id: 167047,
  //       type: "webinar",
  //       title: "Новости сети отелей в Дубае и Шардже. Розыгрыш ваучера на проживание!",
  //       viewsCount: 71,
  //       participantsCount: 767,
  //       path: "/events/webinars/show/167047",
  //       date: "2021-04-14T15:00:00+03:00",
  //       dateEnd: "2021-04-14T16:00:00+03:00",
  //       status: 1,
  //       subscribed: true,
  //     },
  //   ],
  //   "Wed Apr 14 2021 16:00:00 GMT+0300": [
  //     {
  //       label: null,
  //       companyTitle: "Сеть отелей Rotana Hotels & Resorts",
  //       description:
  //         "<ul>\r\n\t<li>Отели Дубая и&nbsp;Шарджи:\r\n\t<ul>\r\n\t\t<li>новые семейные номера 42&nbsp;кв.&nbsp;м&nbsp;Amwaj Rotana Dubai&nbsp;5*;</li>\r\n\t\t<li>Rose Rayhaan&nbsp;4*: увеличение количества трансферов на&nbsp;пляж;</li>\r\n\t\t<li>Towers Rotana&nbsp;4*, Media Rotana&nbsp;5*, Al&nbsp;Bandar Rotana&nbsp;5*, Jumeira Rotana&nbsp;4*, Centro Barsha 3*&nbsp;&amp; Centro Sharjah&nbsp;3*, новинка Дубая 2020&nbsp;&mdash;&nbsp;Al&nbsp;Jaddaf Rotana*;</li>\r\n\t</ul>\r\n\t</li>\r\n\t<li>Fujairah Rotana Resort &amp;&nbsp;SPA 5*&nbsp;&mdash; презентация отеля после ремонта, новые категории номеров и&nbsp;системы питания в&nbsp;деталях;</li>\r\n\t<li>Saadiyat Rotana Resort &amp;&nbsp;SPA 5*&nbsp;&mdash; категории номеров и&nbsp;система питания в&nbsp;деталях.</li>\r\n\t<li><strong>Розыгрыш ваучера на проживание!&nbsp;</strong></li>\r\n</ul>",
  //       scheduleDescription: null,
  //       experts: [
  //         {
  //           id: 7748,
  //           sorting: 0,
  //           image:
  //             "https://cdn.profi.travel/local-storage/profi-travel/uploads/expert/photo/5f7c841d3f10c161494351.jpg",
  //           fullName: "Жанна Злобина",
  //           position: "Менеджер по продажам, Rotana Hotels & Resorts",
  //         },
  //         {
  //           id: 7749,
  //           sorting: 0,
  //           image:
  //             "https://cdn.profi.travel/local-storage/profi-travel/uploads/expert/photo/606f2cb6554b0565233702.jpg",
  //           fullName: "Ирина Шустваль",
  //           position: "Sales Manager, Rotana Hotels & Resorts",
  //         },
  //       ],
  //       id: 167042,
  //       type: "webinar",
  //       title:
  //         "Обзор отелей Fujairah Rotana после ремонта и Saadiyat Rotana 5* deluxe в Абу-Даби. Розыгрыш проживания!",
  //       viewsCount: 97,
  //       participantsCount: 745,
  //       path: "/events/webinars/show/167042",
  //       date: "2021-04-14T16:00:00+03:00",
  //       dateEnd: "2021-04-14T17:00:00+03:00",
  //       status: 1,
  //       subscribed: true,
  //     },
  //   ],
  //   "Thu Apr 15 2021 10:00:00 GMT+0300": [
  //     {
  //       label: null,
  //       companyTitle: "Министерство по туризму Республики Кипр",
  //       description:
  //         "<ol>\r\n\t<li>Как туристам попасть на Кипр без карантина?</li>\r\n\t<li>Что нужно знать агенту перед продажей тура?</li>\r\n\t<li>Правила въезда на остров, протоколы безопасности: CyprusFlightPass, ПЦР-тест за 72 часа до вылета и другие требования для въезда.</li>\r\n</ol>",
  //       scheduleDescription: null,
  //       experts: [
  //         {
  //           id: 7771,
  //           sorting: 0,
  //           image:
  //             "https://cdn.profi.travel/local-storage/profi-travel/uploads/expert/photo/606f0b95712ee779058839.png",
  //           fullName: "Мария Михайлова",
  //           position: "Менеджер по маркетингу, Министерство Туризма Кипра",
  //         },
  //       ],
  //       id: 167060,
  //       type: "webinar",
  //       title:
  //         "Кипр открыт для россиян с 1 апреля! Правила въезда на остров, протоколы безопасности: что нужно знать агенту перед продажей тура?",
  //       viewsCount: 313,
  //       participantsCount: 894,
  //       path: "/events/webinars/show/167060",
  //       date: "2021-04-15T10:00:00+03:00",
  //       dateEnd: "2021-04-15T11:00:00+03:00",
  //       status: 1,
  //       subscribed: false,
  //     },
  //   ],
  //   "Thu Apr 15 2021 11:00:00 GMT+0300": [
  //     {
  //       label: null,
  //       companyTitle: "Сеть отелей Rotana Hotels & Resorts",
  //       description:
  //         "<ul>\r\n\t<li>Прямое включение с&nbsp;отелем Grand Rotana Resort &amp;&nbsp;SPA 5*&nbsp;&mdash; презентация от&nbsp;представителя отеля в&nbsp;деталях, все категории номеров и&nbsp;системы питания.</li>\r\n\t<li>Обзор новых номеров после ремонта.</li>\r\n\t<li><strong>Розыгрыш ваучера на проживание!&nbsp;</strong></li>\r\n</ul>",
  //       scheduleDescription: null,
  //       experts: [
  //         {
  //           id: 7757,
  //           sorting: 0,
  //           image:
  //             "https://cdn.profi.travel/local-storage/profi-travel/uploads/expert/photo/606ec4d667ff1451627181.png",
  //           fullName: "Елена Иванушкина",
  //           position: "Менеджер по продажам Grand Rotana Resort & SPA, Sharm El Sheikh",
  //         },
  //       ],
  //       id: 167048,
  //       type: "webinar",
  //       title:
  //         "Отель Grand Rotana 5* deluxe в Шарм-эль-Шейхе — новости и презентация в деталях. Розыгрыш проживания!",
  //       viewsCount: 69,
  //       participantsCount: 811,
  //       path: "/events/webinars/show/167048",
  //       date: "2021-04-15T11:00:00+03:00",
  //       dateEnd: "2021-04-15T12:00:00+03:00",
  //       status: 1,
  //       subscribed: false,
  //     },
  //   ],
  //   "Thu Apr 15 2021 12:00:00 GMT+0300": [
  //     {
  //       label: null,
  //       companyTitle: "Сеть отелей Leptos Calypso Hotels",
  //       description:
  //         "<ul>\r\n\t<li>Краткое знакомство с&nbsp;группой Leptos Calypso.</li>\r\n\t<li>Описание отеля Coral Beach&nbsp;5*: локация, основные преимущества, спортивные возможности и&nbsp;MICE, анонс открытия.</li>\r\n\t<li>Краткое описание отеля Paphos Gardens&nbsp;3*: инфраструктура, локация, преимущества.</li>\r\n\t<li>Возможности Кипра, преимущества направления.</li>\r\n</ul>",
  //       scheduleDescription: null,
  //       experts: [
  //         {
  //           id: 7768,
  //           sorting: 0,
  //           image:
  //             "https://cdn.profi.travel/local-storage/profi-travel/uploads/expert/photo/606f5b1c8f5b2648318072.png",
  //           fullName: "Лайма Венде",
  //           position: "Представитель группы Leptos Calypso Hotels",
  //         },
  //       ],
  //       id: 167057,
  //       type: "webinar",
  //       title:
  //         "Отели на Кипре: Paphos Gardens Holiday Resort в центре курорта и крупнейший на побережье отель 5* The Coral Beach Hotel & Resort",
  //       viewsCount: 92,
  //       participantsCount: 639,
  //       path: "/events/webinars/show/167057",
  //       date: "2021-04-15T12:00:00+03:00",
  //       dateEnd: "2021-04-15T13:00:00+03:00",
  //       status: 1,
  //       subscribed: false,
  //     },
  //   ],
  //   "Thu Apr 15 2021 13:00:00 GMT+0300": [
  //     {
  //       label: null,
  //       companyTitle: "Принимающая компания CARPE-DIEM Travel",
  //       description:
  //         "<ul>\r\n\t<li>Обзор авторских туров в&nbsp;Камеруне: приключенческое сафари и&nbsp;другие яркие предложения лета.</li>\r\n\t<li>Презентация апарт- и&nbsp;бутик-отелей на&nbsp;Кипре, в&nbsp;Турции и&nbsp;Грузии.</li>\r\n\t<li><strong>Розыгрыш призов!</strong></li>\r\n</ul>",
  //       scheduleDescription: null,
  //       experts: [
  //         {
  //           id: 7777,
  //           sorting: 0,
  //           image: null,
  //           fullName: "Сергей Червяк",
  //           position: "Генеральный директор",
  //         },
  //       ],
  //       id: 167064,
  //       type: "webinar",
  //       title:
  //         "Приключенческое сафари в Камеруне и гид по Кипру — где отдохнуть и что посмотреть летом-2021? Розыгрыш призов!",
  //       viewsCount: 89,
  //       participantsCount: 572,
  //       path: "/events/webinars/show/167064",
  //       date: "2021-04-15T13:00:00+03:00",
  //       dateEnd: "2021-04-15T14:00:00+03:00",
  //       status: 1,
  //       subscribed: false,
  //     },
  //   ],
  //   "Fri Apr 16 2021 11:00:00 GMT+0300": [
  //     {
  //       label: null,
  //       companyTitle: "Отель Bellis Deluxe Hotel 5*, Турция, Белек",
  //       description:
  //         "<ol>\r\n\t<li>Общая информация об&nbsp;отеле.</li>\r\n\t<li>Последние новинки и&nbsp;реновация отеля.</li>\r\n\t<li>Анимационная программа на&nbsp;летний сезон 2021&nbsp;года.</li>\r\n\t<li>Постпандемический период отеля и&nbsp;ситуация в&nbsp;Турции на&nbsp;данный момент.</li>\r\n\t<li><strong>Розыгрыш четырех ночей в&nbsp;отеле Bellis Deluxe!</strong></li>\r\n</ol>",
  //       scheduleDescription: null,
  //       experts: [
  //         {
  //           id: 7761,
  //           sorting: 0,
  //           image:
  //             "https://cdn.profi.travel/local-storage/profi-travel/uploads/expert/photo/606583fabfb49831071880.jpg",
  //           fullName: "Анастасия Шаваринская",
  //           position: "Представитель отдела маркетинга и продаж",
  //         },
  //       ],
  //       id: 167052,
  //       type: "webinar",
  //       title:
  //         "Традиционная встреча с отелем в Белеке: последние новинки, планы на летний сезон 2021 года и розыгрыш отдыха!",
  //       viewsCount: 64,
  //       participantsCount: 801,
  //       path: "/events/webinars/show/167052",
  //       date: "2021-04-16T11:00:00+03:00",
  //       dateEnd: "2021-04-16T12:00:00+03:00",
  //       status: 1,
  //       subscribed: false,
  //     },
  //   ],
  //   "Fri Apr 16 2021 12:00:00 GMT+0300": [
  //     {
  //       label: null,
  //       companyTitle: "Сеть отелей Barut Hotels",
  //       description:
  //         "<ol>\r\n\t<li>Особенности и&nbsp;нюансы продаж.</li>\r\n\t<li>Последние новинки сети за&nbsp;2019&nbsp;&mdash; 2021&nbsp;гг.: изменение концепции, выход на&nbsp;рынок СНГ отеля Barut Sunwing Side Beach&nbsp;4*.</li>\r\n</ol>",
  //       scheduleDescription: null,
  //       experts: [
  //         {
  //           id: 7735,
  //           sorting: 0,
  //           image:
  //             "https://cdn.profi.travel/local-storage/profi-travel/uploads/expert/photo/605f25d8b56ef724032574.jpg",
  //           fullName: "Анна Кондратова",
  //           position: "Представитель Barut Hotels на рынке СНГ",
  //         },
  //       ],
  //       id: 167033,
  //       type: "webinar",
  //       title: "Отдых в Турции: описание отелей, особенности продаж и новинки сети",
  //       viewsCount: 88,
  //       participantsCount: 790,
  //       path: "/events/webinars/show/167033",
  //       date: "2021-04-16T12:00:00+03:00",
  //       dateEnd: "2021-04-16T14:00:00+03:00",
  //       status: 1,
  //       subscribed: false,
  //     },
  //   ],
  //   "Fri Apr 16 2021 14:00:00 GMT+0300": [
  //     {
  //       label: null,
  //       companyTitle: "Отель Riolavitas SPA & Resort 5*, Турция",
  //       description:
  //         "<ol>\r\n\t<li>История и&nbsp;задачи компании.</li>\r\n\t<li>Общая информация об&nbsp;отеле.</li>\r\n\t<li>Здоровый безопасный туризм и&nbsp;другие новинки летнего сезона&nbsp;&mdash; 2021.</li>\r\n\t<li>Партнеры, раннее бронирование.</li>\r\n\t<li>Бонусная программа для турагентов.</li>\r\n\t<li><strong>Розыгрыш бесплатного отдыха на&nbsp;двоих в&nbsp;октябре 2021 года на&nbsp;7&nbsp;ночей по&nbsp;системе &laquo;ультра все включено&raquo;!</strong></li>\r\n</ol>",
  //       scheduleDescription: null,
  //       experts: [
  //         {
  //           id: 7705,
  //           sorting: 0,
  //           image:
  //             "https://cdn.profi.travel/local-storage/profi-travel/uploads/expert/photo/5e16d2ba99657037266651.jpg",
  //           fullName: "Чинара Балиймез",
  //           position: "Руководитель отдела продаж и маркетинга, Турция, Анталья — Манавгат",
  //         },
  //       ],
  //       id: 167021,
  //       type: "webinar",
  //       title:
  //         "Здоровый безопасный туризм и новинки лета-2021. Розыгрыш отдыха для двоих на 7 ночей по системе «ультра все включено»!",
  //       viewsCount: 53,
  //       participantsCount: 778,
  //       path: "/events/webinars/show/167021",
  //       date: "2021-04-16T14:00:00+03:00",
  //       dateEnd: "2021-04-16T15:00:00+03:00",
  //       status: 1,
  //       subscribed: false,
  //     },
  //   ],
  //   "Fri Apr 16 2021 15:00:00 GMT+0300": [
  //     {
  //       label: null,
  //       companyTitle: "Отель Regnum Carya, Турция",
  //       description:
  //         "<ul>\r\n\t<li>Знакомство c&nbsp;Regnum Carya: новинки 2021&nbsp;года, концепция, особенности, детский концепт, гольф днем и&nbsp;ночью.</li>\r\n\t<li>&laquo;Фишки&raquo; отеля:\r\n\t<ul>\r\n\t\t<li>концепт Luxury All Inclusive и&nbsp;трансфер на&nbsp;вертолете;</li>\r\n\t\t<li>пляж с&nbsp;белоснежным песком, пирс с&nbsp;павильонами и&nbsp;джакузи и&nbsp;плавательный бассейн без химии;</li>\r\n\t\t<li>первое и&nbsp;единственное в&nbsp;Европе гольф-поле, освещаемое ночью;</li>\r\n\t\t<li>бесплатные услуги Fast Track и&nbsp;CIP Lounge;</li>\r\n\t\t<li>посещение Land of&nbsp;Legends;</li>\r\n\t\t<li>тайский и&nbsp;японский рестораны а-ля карт;</li>\r\n\t\t<li>реновации в проживании: перепланировка в вилле Crown, обогащение концепции номеров Pearl Pool Suite и Pearl Pool Family, переименование номеров и вилл, пещера Cave виллы Crown;</li>\r\n\t\t<li>летние концерты с&nbsp;участием мировых звезд: Дженнифер Лопез, Тома Джонса, Энн-Мари, Джейсона Деруло, Дуа Липа и&nbsp;не&nbsp;только.</li>\r\n\t</ul>\r\n\t</li>\r\n\t<li>Большой шаг в&nbsp;клеточной регенерации: применение технологии Indiba Deep Care.</li>\r\n\t<li>Уроки футбола у&nbsp;тренеров всемирно известного футбольного клуба Real Madrid Foundation для детей от&nbsp;6&nbsp;до&nbsp;16&nbsp;лет.</li>\r\n\t<li>Обновленный пляж и новый ресторан ALIA.</li>\r\n</ul>",
  //       scheduleDescription: null,
  //       experts: [
  //         {
  //           id: 7751,
  //           sorting: 0,
  //           image:
  //             "https://cdn.profi.travel/local-storage/profi-travel/uploads/expert/photo/5e26e8db94328167022421.jpg",
  //           fullName: "Екатерина Штерн",
  //           position: "Руководитель продаж по странам СНГ и России, отель Regnum Carya",
  //         },
  //       ],
  //       id: 167044,
  //       type: "webinar",
  //       title:
  //         "Отдых класса люкс в Белеке: уникальное поле для гольфа, концерты мировых звезд и клеточное омоложение в спа-центре!",
  //       viewsCount: 70,
  //       participantsCount: 715,
  //       path: "/events/webinars/show/167044",
  //       date: "2021-04-16T15:00:00+03:00",
  //       dateEnd: "2021-04-16T16:00:00+03:00",
  //       status: 1,
  //       subscribed: false,
  //     },
  //   ],
  //   "Fri Apr 16 2021 16:00:00 GMT+0300": [
  //     {
  //       label: "Деловая программа",
  //       companyTitle: null,
  //       description:
  //         "<p><strong>16:00 &mdash; 16:05<br />\r\nДенис Юлин, редактор Profi.Travel</strong></p>\r\n\r\n<ul>\r\n\t<li>В одночасье рынок лишился главного и самого массового направления. Обязаны ли туроператоры возвращать туристам деньги? На что заменить Турцию и как удержать разъяренного клиента?</li>\r\n</ul>\r\n\r\n<p><strong>16:05 &mdash; 16:30<br />\r\nАдем Суверен, руководитель отдела продаж направления Россия и страны СНГ сети Barut Hotels</strong></p>\r\n\r\n<ul>\r\n\t<li>Как Турция будет улучшать эпид-ситуацию, чтобы открыться 1 июня: новые ограничения в стране. Как кризис повлияет на цены и каким образом турецкие отели будут конкурировать за российских туристов этим летом.</li>\r\n</ul>\r\n\r\n<p><strong>16:30 &mdash; 16:55<br />\r\nЯна Муромова, заместитель генерального директора ANEX Tour</strong></p>\r\n\r\n<ul>\r\n\t<li>С какими сложностями сталкиваются туроператоры при переносе туров. Оптимистичные/пессимистичные прогнозы по открытию направления и стратегическое планирование. Почему туроператор отказался от переносов на российские регионы?</li>\r\n</ul>\r\n\r\n<p><strong>16:55 &mdash; 17:20<br />\r\nВоскан Арзуманов, генеральный директор TEZ Tour</strong></p>\r\n\r\n<ul>\r\n\t<li>Как повлияло закрытие Турции на другие направления? Куда переориентировать туриста ... если некуда? Почему выросли цены на Россию и как поведут себя туристы, узнав о доплатах?</li>\r\n</ul>\r\n\r\n<p><strong>17:20 &mdash; 17:45<br />\r\nДмитрий Арутюнов,&nbsp;генеральный директор &laquo;АРТ-ТУР&raquo;</strong></p>\r\n\r\n<ul>\r\n\t<li>Много ли туристов-транзитников пострадало от временной приостановки авиасообщения с Турцией? А также, могут ли они претендовать на возврат средств и как туроператоры решают эти проблемы.</li>\r\n</ul>",
  //       scheduleDescription:
  //         "Какие шаги предпринимают турецкие власти, отельеры и российские туроператоры после приостановки авиасообщения между Россией и Турцией? Также из эфира вы узнаете, чем заменить самое массовое направление сезона и как турагенту не потерять клиента в текущей ситуации.",
  //       experts: [
  //         {
  //           id: 7774,
  //           sorting: 1,
  //           image:
  //             "https://cdn.profi.travel/local-storage/profi-travel/uploads/expert/photo/607979a24d77a977749670.jpg",
  //           fullName: "Адем Суверен",
  //           position:
  //             "Руководитель отдела продаж направления Россия и страны СНГ сети Barut Hotels",
  //         },
  //         {
  //           id: 7787,
  //           sorting: 2,
  //           image:
  //             "https://cdn.profi.travel/local-storage/profi-travel/uploads/expert/photo/5e837cc5e7180235548179.jpg",
  //           fullName: "Яна Муромова",
  //           position: "Заместитель гендиректора ANEX Tour Россия",
  //         },
  //         {
  //           id: 7804,
  //           sorting: 3,
  //           image:
  //             "https://cdn.profi.travel/local-storage/profi-travel/uploads/expert/photo/60784699be4d7171795117.png",
  //           fullName: "Воскан Арзуманов",
  //           position: "Генеральный директор TEZ Tour",
  //         },
  //         {
  //           id: 7788,
  //           sorting: 4,
  //           image:
  //             "https://cdn.profi.travel/local-storage/profi-travel/uploads/expert/photo/5f8d93f925d66219232809.jpg",
  //           fullName: "Дмитрий Арутюнов",
  //           position: "Генеральный директор «АРТ-ТУР»",
  //         },
  //         {
  //           id: 7758,
  //           sorting: 5,
  //           image:
  //             "https://cdn.profi.travel/local-storage/profi-travel/uploads/expert/photo/5f786673f3694028595410.jpg",
  //           fullName: "Денис Юлин",
  //           position: "Журналист Profi.Travel",
  //         },
  //       ],
  //       id: 24,
  //       type: "broadcast",
  //       title: "Турция 2021: как спасать сезон?",
  //       viewsCount: 4409,
  //       participantsCount: 1040,
  //       path: "/broadcast/24",
  //       date: "2021-04-16T16:00:00+03:00",
  //       dateEnd: "2021-04-16T18:00:00+03:00",
  //       status: 1,
  //       subscribed: true,
  //     },
  //   ],
  //   "Mon Apr 19 2021 09:00:00 GMT+0300": [
  //     {
  //       label: null,
  //       companyTitle: "ГУ «Национальное агентство по туризму» Республики Беларусь",
  //       description:
  //         "<ol>\r\n\t<li>Туристические возможности&nbsp;г. Минска.</li>\r\n\t<li>Особенности организации экскурсионных туров в&nbsp;Беларусь.</li>\r\n\t<li>Все о&nbsp;медицинском туризме.</li>\r\n\t<li>MICE-туризм в&nbsp;г. Минске.</li>\r\n\t<li>Готовые туры в&nbsp;столицу Беларуси!</li>\r\n\t<li>&laquo;Минотель&raquo;&nbsp;&mdash; первая сеть гостиниц и&nbsp;ресторанов в&nbsp;Республике Беларусь.</li>\r\n\t<li>Активный отдых и&nbsp;промышленный туризм в&nbsp;г. Минске.</li>\r\n</ol>",
  //       scheduleDescription: null,
  //       experts: [
  //         {
  //           id: 7790,
  //           sorting: 0,
  //           image:
  //             "https://cdn.profi.travel/local-storage/profi-travel/uploads/expert/photo/5ef19f6d99e18973361873.jpg",
  //           fullName: "Елена Лихимович",
  //           position:
  //             "Заместитель директора — начальник отдела маркетинга Национального агентства по туризму Республики Беларусь",
  //         },
  //         {
  //           id: 7791,
  //           sorting: 0,
  //           image:
  //             "https://cdn.profi.travel/local-storage/profi-travel/uploads/expert/photo/5eecc606775c2816068481.jpg",
  //           fullName: "Алексей Русакевич",
  //           position: "Директор учреждения «Информационно-туристский центр «Минск»",
  //         },
  //       ],
  //       id: 167074,
  //       type: "webinar",
  //       title: "Минск: город бизнеса и развлечений! Все об отдыхе в столице и области",
  //       viewsCount: 43,
  //       participantsCount: 440,
  //       path: "/events/webinars/show/167074",
  //       date: "2021-04-19T09:00:00+03:00",
  //       dateEnd: "2021-04-19T11:00:00+03:00",
  //       status: 1,
  //       subscribed: true,
  //     },
  //   ],
  //   "Mon Apr 19 2021 11:00:00 GMT+0300": [
  //     {
  //       label: null,
  //       companyTitle: "ГУ «Национальное агентство по туризму» Республики Беларусь",
  //       description:
  //         "<ol>\r\n\t<li>Программа &laquo;Активный отдых здесь и&nbsp;сейчас&raquo;.</li>\r\n\t<li>Знакомство с&nbsp;Robinson Club Resort &amp;&nbsp;SPA&nbsp;&mdash; уникальным загородным клубом под Минском.</li>\r\n\t<li>&laquo;Чистый воздух и&nbsp;вода вас излечат навсегда&raquo;&nbsp;&mdash; презентация санатория &laquo;Ислочь&raquo;.</li>\r\n</ol>",
  //       scheduleDescription: null,
  //       experts: [
  //         {
  //           id: 7794,
  //           sorting: 0,
  //           image: null,
  //           fullName: "Юлия Ламека",
  //           position: "Начальник гостиничного комплекса Robinson Club Resort & SPA",
  //         },
  //         {
  //           id: 7795,
  //           sorting: 0,
  //           image: null,
  //           fullName: "Анна Зяблова",
  //           position: "Начальник отдела маркетинга",
  //         },
  //       ],
  //       id: 167075,
  //       type: "webinar",
  //       title: "Оздоровление и активный отдых в Минской области, всего в 7 км от столицы",
  //       viewsCount: 37,
  //       participantsCount: 432,
  //       path: "/events/webinars/show/167075",
  //       date: "2021-04-19T11:00:00+03:00",
  //       dateEnd: "2021-04-19T12:00:00+03:00",
  //       status: 1,
  //       subscribed: true,
  //     },
  //   ],
  //   "Mon Apr 19 2021 12:00:00 GMT+0300": [
  //     {
  //       label: null,
  //       companyTitle: "ГУ «Национальное агентство по туризму» Республики Беларусь",
  //       description:
  //         "<ol>\r\n\t<li>Беловежская Пуща&nbsp;&mdash; легкие Европы: варианты для отдыха.</li>\r\n\t<li>Мемориальный комплекс &laquo;Брестская крепость-герой&raquo;. Сохраняем историю.</li>\r\n\t<li>Солнечный отдых в&nbsp;санатории &laquo;Солнечный&raquo;.</li>\r\n</ol>",
  //       scheduleDescription: null,
  //       experts: [
  //         {
  //           id: 7792,
  //           sorting: 0,
  //           image:
  //             "https://cdn.profi.travel/local-storage/profi-travel/uploads/expert/photo/5ef1e07ca0914958841482.jpg",
  //           fullName: "Нина Богуш",
  //           position: "Заместитель генерального директора ГПУ НП «Беловежская Пуща»",
  //         },
  //         {
  //           id: 7808,
  //           sorting: 0,
  //           image: null,
  //           fullName: "Елена Митюкова",
  //           position:
  //             "Начальник научно-исторического отдела ГУ «Мемориальный комплекс „Брестская крепость-герой“»",
  //         },
  //         {
  //           id: 7809,
  //           sorting: 0,
  //           image: null,
  //           fullName: "Евгений Басалай",
  //           position: "Маркетолог санатория «Солнечный»",
  //         },
  //       ],
  //       id: 167076,
  //       type: "webinar",
  //       title:
  //         "Лето-2021 в Беларуси: Беловежская Пуща, «Брестская крепость-герой» и солнечный отдых в санатории!",
  //       viewsCount: 32,
  //       participantsCount: 435,
  //       path: "/events/webinars/show/167076",
  //       date: "2021-04-19T12:00:00+03:00",
  //       dateEnd: "2021-04-19T13:00:00+03:00",
  //       status: 1,
  //       subscribed: true,
  //     },
  //   ],
  //   "Mon Apr 19 2021 13:00:00 GMT+0300": [
  //     {
  //       label: null,
  //       companyTitle: "ГУ «Национальное агентство по туризму» Республики Беларусь",
  //       description:
  //         "<ol>\r\n\t<li>Лучшие музеи Гомеля представляют новинки и&nbsp;самые популярные среди туристов программы.</li>\r\n\t<li>&laquo;Конный двор&raquo;: организация туров в&nbsp;конноспортивный комплекс.</li>\r\n\t<li>Прикоснитесь к&nbsp;прекрасному! Картинная галерея имени Александра Исачева.</li>\r\n\t<li>Незабываемый отдых на&nbsp;природе в&nbsp;усадьбе &laquo;Лошадиный остров&raquo;.</li>\r\n\t<li>&laquo;Серебряные ключи&raquo; &mdash; санаторий со &laquo;светлой душой&raquo;.</li>\r\n</ol>",
  //       scheduleDescription: null,
  //       experts: [
  //         {
  //           id: 7799,
  //           sorting: 0,
  //           image: null,
  //           fullName: "Александр Светилов",
  //           position: "Главный врач санатория «Серебряные ключи»",
  //         },
  //         {
  //           id: 7800,
  //           sorting: 0,
  //           image: null,
  //           fullName: "Александр Овсянкин",
  //           position: "И.о. директора ФСК «Урожай»",
  //         },
  //         {
  //           id: 7810,
  //           sorting: 0,
  //           image: null,
  //           fullName: "Юлия Купреева",
  //           position: "Директор ГУ «Музей истории г. Гомеля»",
  //         },
  //       ],
  //       id: 167077,
  //       type: "webinar",
  //       title:
  //         "Лучшие музеи Гомеля, туры на «Конный двор», отдых в усадьбах и прикосновение к искусству в картинной галерее",
  //       viewsCount: 22,
  //       participantsCount: 428,
  //       path: "/events/webinars/show/167077",
  //       date: "2021-04-19T13:00:00+03:00",
  //       dateEnd: "2021-04-19T14:00:00+03:00",
  //       status: 1,
  //       subscribed: true,
  //     },
  //   ],
  //   "Mon Apr 19 2021 14:00:00 GMT+0300": [
  //     {
  //       label: null,
  //       companyTitle: "ГУ «Национальное агентство по туризму» Республики Беларусь",
  //       description:
  //         "<ol>\r\n\t<li>Хруцкий в&nbsp;Полоцке: лента времени. Брендовый художник и&nbsp;его драма жизни, скрытая за&nbsp;чередой натюрмортов и&nbsp;успехом.</li>\r\n\t<li>Знакомство с&nbsp;программами оздоровительных туров &laquo;Пост-COVID&raquo; и&nbsp;&laquo;Коррекция веса&raquo;.</li>\r\n</ol>",
  //       scheduleDescription: null,
  //       experts: [
  //         {
  //           id: 7801,
  //           sorting: 0,
  //           image: null,
  //           fullName: "Виолетта Грудская",
  //           position: "Директор ОДО «РайдоТур»",
  //         },
  //       ],
  //       id: 167078,
  //       type: "webinar",
  //       title:
  //         "Неожиданная Витебщина: успех и драма брендового художника и оздоровительные туры «Пост-COVID» и «Коррекция веса»",
  //       viewsCount: 25,
  //       participantsCount: 428,
  //       path: "/events/webinars/show/167078",
  //       date: "2021-04-19T14:00:00+03:00",
  //       dateEnd: "2021-04-19T15:00:00+03:00",
  //       status: 1,
  //       subscribed: true,
  //     },
  //   ],
  //   "Mon Apr 19 2021 15:00:00 GMT+0300": [
  //     {
  //       label: null,
  //       companyTitle: "ГУ «Национальное агентство по туризму» Республики Беларусь",
  //       description:
  //         "<ol>\r\n\t<li>Музей-усадьба М. К. Огинского: возвращение &laquo;Северных Афин&raquo;.</li>\r\n\t<li>Лидский триптих: музей В. П. Тавлая, Лидский замок, историко-художественный музей.</li>\r\n\t<li>Отдых и оздоровление в санатории &laquo;Радуга&raquo;.</li>\r\n</ol>",
  //       scheduleDescription: null,
  //       experts: [
  //         {
  //           id: 7796,
  //           sorting: 0,
  //           image: null,
  //           fullName: "Людмила Гродинская",
  //           position: "Директор Музея-усадьбы М.К. Огинского",
  //         },
  //         {
  //           id: 7797,
  //           sorting: 0,
  //           image: null,
  //           fullName: "Ольга Пилипчук",
  //           position: "Директор ГУ «Лидский историко-художественный музей»",
  //         },
  //         {
  //           id: 7798,
  //           sorting: 0,
  //           image: null,
  //           fullName: "Дарья Чигирь",
  //           position: "Менеджер санатория «Радуга»",
  //         },
  //       ],
  //       id: 167079,
  //       type: "webinar",
  //       title:
  //         "Туристическая Гродненщина: возвращение «Северных Афин», Лидский замок и отдых в санатории «Радуга»",
  //       viewsCount: 36,
  //       participantsCount: 425,
  //       path: "/events/webinars/show/167079",
  //       date: "2021-04-19T15:00:00+03:00",
  //       dateEnd: "2021-04-19T16:00:00+03:00",
  //       status: 1,
  //       subscribed: true,
  //     },
  //   ],
  //   "Mon Apr 19 2021 16:00:00 GMT+0300": [
  //     {
  //       label: null,
  //       companyTitle: "ГУ «Национальное агентство по туризму» Республики Беларусь",
  //       description:
  //         "<ol>\r\n\t<li>Откройте Беларусь с&nbsp;туристической компанией &laquo;Могилевоблтурист&raquo;.</li>\r\n\t<li>Тайны дворца Потемкина в&nbsp;г. Кричеве.</li>\r\n\t<li>Уникальные программы в&nbsp;старейшем санатории Беларуси.</li>\r\n\t<li>Уют санатория имени К.&nbsp;П.&nbsp;Орловского.</li>\r\n</ol>",
  //       scheduleDescription: null,
  //       experts: [
  //         {
  //           id: 7811,
  //           sorting: 0,
  //           image: null,
  //           fullName: "Анастасия Радовская",
  //           position: "Научный сотрудник музея ГУК «Исторический музей г. Кричева»",
  //         },
  //         {
  //           id: 7812,
  //           sorting: 0,
  //           image: null,
  //           fullName: "Татьяна Карпова",
  //           position: "Начальник отдела маркетинга «Санаторий имени В. И. Ленина»",
  //         },
  //         {
  //           id: 7813,
  //           sorting: 0,
  //           image: null,
  //           fullName: "Ольга Горшкова",
  //           position: "Директор «Санаторий имени К. П. Орловского»",
  //         },
  //       ],
  //       id: 167080,
  //       type: "webinar",
  //       title:
  //         "Гостеприимная Могилевщина: тайны дворца Потемкина и уникальные программы оздоровления в санаториях",
  //       viewsCount: 38,
  //       participantsCount: 416,
  //       path: "/events/webinars/show/167080",
  //       date: "2021-04-19T16:00:00+03:00",
  //       dateEnd: "2021-04-19T17:00:00+03:00",
  //       status: 1,
  //       subscribed: true,
  //     },
  //   ],
  //   "Tue Apr 20 2021 10:00:00 GMT+0300": [
  //     {
  //       label: null,
  //       companyTitle: "Национальная организация туризма Кореи",
  //       description:
  //         '<p><strong>Московский офис Национальной организации туризма Кореи:</strong></p>\r\n\r\n<ul>\r\n\t<li>знакомство со&nbsp;Страной утренней свежести: туристические особенности;</li>\r\n\t<li>топ причин поехать в&nbsp;Корею.</li>\r\n</ul>\r\n\r\n<p><strong>Gwangju Tourism Foundation:</strong></p>\r\n\r\n<ul>\r\n\t<li>туристические возможности города Кванджу;</li>\r\n\t<li>достопримечательности, виды туризма, которые понравятся гостям города;</li>\r\n\t<li>особенный 2021 год&nbsp;&mdash; в&nbsp;Кванджу пройдут&nbsp;&laquo;13-я&nbsp;биеннале в&nbsp;Кванджу&raquo; и&nbsp;&laquo;9-я&nbsp;биеннале дизайна&raquo;, одна из&nbsp;пяти мировых биеннале. Организация туризма Кванджу станет деловым партнером для туристических компаний при формировании туристического продукта, предоставляя планы туристических маршрутов, поддержку программ мастер-классов и&nbsp;поддержку инсентив-туров.</li>\r\n</ul>\r\n\r\n<p><img alt="" src="https://cdn.profi.travel/storage/profi-travel/uploads/CKEditor/6075bf1f15cc7418894459.png" style="width: 135px; height: 78px;" />&nbsp;</p>',
  //       scheduleDescription: null,
  //       experts: [
  //         {
  //           id: 7766,
  //           sorting: 0,
  //           image:
  //             "https://cdn.profi.travel/local-storage/profi-travel/uploads/expert/photo/5ece2a2d5e18e423954741.jpg",
  //           fullName: "Захар Конкин",
  //           position: "B2B-менеджер, Национальная организация туризма Кореи",
  //         },
  //         {
  //           id: 7767,
  //           sorting: 0,
  //           image: null,
  //           fullName: "Ким Хивон",
  //           position: "Представитель Gwangju Tourism Foundation",
  //         },
  //       ],
  //       id: 167056,
  //       type: "webinar",
  //       title: "Топ причин для поездки в Южную Корею и виртуальное знакомство с городом Кванджу",
  //       viewsCount: 28,
  //       participantsCount: 483,
  //       path: "/events/webinars/show/167056",
  //       date: "2021-04-20T10:00:00+03:00",
  //       dateEnd: "2021-04-20T11:00:00+03:00",
  //       status: 1,
  //       subscribed: true,
  //     },
  //   ],
  //   "Tue Apr 20 2021 11:00:00 GMT+0300": [
  //     {
  //       label: null,
  //       companyTitle: "Туроператор Good Time Travel",
  //       description:
  //         "<ol>\r\n\t<li>Почему Южная Корея? 10&nbsp;необычных фактов о&nbsp;стране.</li>\r\n\t<li>Перелеты. Как добраться выгоднее всего? Логистика маршрута.</li>\r\n\t<li>Начало маршрута&nbsp;&mdash; Сеул:\r\n\t<ul>\r\n\t\t<li>обзор экскурсий, отели, шоу &laquo;Нанта&raquo;, гастрономия;</li>\r\n\t\t<li>посещение королевского дворца Чхандоккун, торговая улица Инсадонг;</li>\r\n\t\t<li>смотровая площадка Сеульской башни N.</li>\r\n\t</ul>\r\n\t</li>\r\n\t<li>Пусан:\r\n\t<ul>\r\n\t\t<li>обзор экскурсий и&nbsp;возможностей;</li>\r\n\t\t<li>буддийский храм Хэдон Йонгунса;</li>\r\n\t\t<li>рыбный рынок, SPA LAND.</li>\r\n\t</ul>\r\n\t</li>\r\n\t<li>Кёнджу: экскурсионная программа.</li>\r\n\t<li>Национальный природный парк &laquo;Сораксан&raquo;.</li>\r\n\t<li>Остановка в&nbsp;Сокчхо, аквапарк &laquo;Сорак Вотопиа&raquo;.</li>\r\n\t<li>Развлекательный парк Everland.</li>\r\n\t<li>Другие возможности Сеула: шопинг, ТРК &laquo;Лотте Уорлд&raquo;, небоскреб &laquo;Лотте Тауэр&raquo;.</li>\r\n</ol>",
  //       scheduleDescription: null,
  //       experts: [
  //         {
  //           id: 7780,
  //           sorting: 0,
  //           image: null,
  //           fullName: "Николай Букреев",
  //           position: "Коммерческий директор Good Time Travel",
  //         },
  //       ],
  //       id: 167067,
  //       type: "webinar",
  //       title:
  //         "Маршруты по Южной Корее от ТО Good Time Travel: развлечения в Сеуле, экскурсии в Кёнджу и Сокчхо, парк Everland и другие",
  //       viewsCount: 30,
  //       participantsCount: 482,
  //       path: "/events/webinars/show/167067",
  //       date: "2021-04-20T11:00:00+03:00",
  //       dateEnd: "2021-04-20T12:00:00+03:00",
  //       status: 1,
  //       subscribed: true,
  //     },
  //   ],
  //   "Tue Apr 20 2021 12:00:00 GMT+0300": [
  //     {
  //       label: null,
  //       companyTitle:
  //         "Национальное туристическое управление Чешской Республики — ЧехТуризм (CzechTourism)",
  //       description:
  //         "<ol>\r\n\t<li>Основная информация по&nbsp;Чехии: транспорт, валюта, телекоммуникации.</li>\r\n\t<li>Актуальная информация по&nbsp;мерам безопасности и&nbsp;условиям для посещения Чехии.</li>\r\n\t<li>Предложения чешских курортов по&nbsp;лечению пост-COVID&nbsp;синдрома.</li>\r\n\t<li>Маркетинг &laquo;ЧехТуризма&raquo; после пандемии.</li>\r\n</ol>",
  //       scheduleDescription: null,
  //       experts: [
  //         {
  //           id: 7720,
  //           sorting: 0,
  //           image:
  //             "https://cdn.profi.travel/local-storage/profi-travel/uploads/expert/photo/5af19ee0b7710250268179.jpeg",
  //           fullName: "Алена Кудилкова",
  //           position:
  //             "Директор национального туристического управления Чешской Республики в Москве",
  //         },
  //       ],
  //       id: 167026,
  //       type: "webinar",
  //       title:
  //         "Чехия после пандемии: безопасность населения и туристов и лечение постковидного синдрома на курортах страны",
  //       viewsCount: 43,
  //       participantsCount: 663,
  //       path: "/events/webinars/show/167026",
  //       date: "2021-04-20T12:00:00+03:00",
  //       dateEnd: "2021-04-20T13:00:00+03:00",
  //       status: 1,
  //       subscribed: false,
  //     },
  //   ],
  //   "Tue Apr 20 2021 13:00:00 GMT+0300": [
  //     {
  //       label: null,
  //       companyTitle: "SPA HOTEL THERMAL KARLOVY VARY",
  //       description:
  //         "<ol>\r\n\t<li>История и&nbsp;архитектура отеля &laquo;Термал&raquo; в&nbsp;Карловых Варах.</li>\r\n\t<li>Номерной фонд.</li>\r\n\t<li>Лечение и&nbsp;постановка диагнозов, обследования и&nbsp;процедуры.</li>\r\n\t<li>О&nbsp;работе конгресс-центра.</li>\r\n\t<li>Информация о&nbsp;ежегодном кинофестивале.</li>\r\n\t<li>Новости о&nbsp;реконструкции.</li>\r\n\t<li><strong>Розыгрыш ваучера на&nbsp;проживание в&nbsp;отеле &laquo;Термал&raquo;, Карловы Вары: две ночи на&nbsp;двоих с&nbsp;завтраком.</strong></li>\r\n</ol>",
  //       scheduleDescription: null,
  //       experts: [
  //         {
  //           id: 7707,
  //           sorting: 0,
  //           image:
  //             "https://cdn.profi.travel/local-storage/profi-travel/uploads/expert/photo/5f71c7a7f26ea150682546.jpg",
  //           fullName: "Radka Ševcová",
  //           position: "Директор по маркетингу и продажам, Director of Sales & Marketing",
  //         },
  //       ],
  //       id: 167023,
  //       type: "webinar",
  //       title:
  //         "Виртуальное путешествие по «Эйфелевой башне» Карловых Вар. MICE, бассейн, лечение. Розыгрыш проживания!",
  //       viewsCount: 31,
  //       participantsCount: 684,
  //       path: "/events/webinars/show/167023",
  //       date: "2021-04-20T13:00:00+03:00",
  //       dateEnd: "2021-04-20T14:00:00+03:00",
  //       status: 1,
  //       subscribed: false,
  //     },
  //   ],
  //   "Tue Apr 20 2021 14:00:00 GMT+0300": [
  //     {
  //       label: null,
  //       companyTitle: "Чешский лечебный курорт Яхимов",
  //       description: "<p><strong>Программа вебинара&nbsp;уточняется.</strong></p>",
  //       scheduleDescription: null,
  //       experts: [
  //         {
  //           id: 7734,
  //           sorting: 0,
  //           image:
  //             "https://cdn.profi.travel/local-storage/profi-travel/uploads/expert/photo/605d9df8c6af1202238351.JPG",
  //           fullName: "Барбора Вольфова",
  //           position: "Директор по продажам",
  //         },
  //       ],
  //       id: 167032,
  //       type: "webinar",
  //       title:
  //         "Лечение и отдых на первом мире радоновом курорте: все о главном богатстве старинной чешской здравницы",
  //       viewsCount: 34,
  //       participantsCount: 653,
  //       path: "/events/webinars/show/167032",
  //       date: "2021-04-20T14:00:00+03:00",
  //       dateEnd: "2021-04-20T15:00:00+03:00",
  //       status: 1,
  //       subscribed: true,
  //     },
  //   ],
  //   "Tue Apr 20 2021 15:00:00 GMT+0300": [
  //     {
  //       label: null,
  //       companyTitle: "Vienna Tourist Board (Венское туристическое агентство)",
  //       description:
  //         "<ol>\r\n\t<li>Город после пандемии. Что сейчас происходит в&nbsp;Вене. Безопасный проезд по&nbsp;городу.</li>\r\n\t<li>Все о&nbsp;Вене: &laquo;Место встречи&nbsp;&mdash; Вена&raquo;, &laquo;Венские особенности&raquo;, &laquo;Чувственная Вена&raquo;.</li>\r\n\t<li>Зеленая Вена.</li>\r\n</ol>",
  //       scheduleDescription: null,
  //       experts: [
  //         {
  //           id: 7738,
  //           sorting: 0,
  //           image:
  //             "https://cdn.profi.travel/local-storage/profi-travel/uploads/expert/photo/60659f081c4ee932110057.jpg",
  //           fullName: "Наталья Генералова",
  //           position: "Лицензированный гид по Австрии",
  //         },
  //       ],
  //       id: 167036,
  //       type: "webinar",
  //       title:
  //         "Столица Австрии с новых сторон: атмосфера старой Европы, яркие объекты, интересные маршруты и безопасность после пандемии",
  //       viewsCount: 43,
  //       participantsCount: 650,
  //       path: "/events/webinars/show/167036",
  //       date: "2021-04-20T15:00:00+03:00",
  //       dateEnd: "2021-04-20T17:00:00+03:00",
  //       status: 1,
  //       subscribed: false,
  //     },
  //   ],
  //   "Wed Apr 21 2021 10:00:00 GMT+0300": [
  //     {
  //       label: null,
  //       companyTitle: "Туроператор «Квинта-тур»",
  //       description:
  //         '<p><strong>Quinta Tour</strong></p>\r\n\r\n<ol>\r\n\t<li>Нетривиальные маршруты для путешествий в&nbsp;Корее.</li>\r\n\t<li>В&nbsp;каких отелях стоит остановиться?</li>\r\n\t<li>Чем занять туристов и&nbsp;как развлечь, чтобы о&nbsp;поездке остались самые незабываемые впечатления?</li>\r\n</ol>\r\n\r\n<p><br />\r\n<strong>Gwangju Tourism Foundation</strong></p>\r\n\r\n<ol>\r\n\t<li>&laquo;13-я&nbsp;биеннале в&nbsp;Кванджу&raquo;.</li>\r\n\t<li>&laquo;9-я&nbsp;биеннале дизайна&raquo;&nbsp;&mdash; одна из&nbsp;пяти мировых биеннале.</li>\r\n\t<li>Планы туристических маршрутов, программы мастер-классов и&nbsp;инсентив-туров.</li>\r\n</ol>\r\n\r\n<p><br />\r\n<strong>Центр медицинского и оздоровительного туризма MEDIWELL в Кванджу</strong></p>\r\n\r\n<p><img alt="" src="https://cdn.profi.travel/storage/profi-travel/uploads/CKEditor/607526a38afde416459066.png" style="width: 135px; height: 65px;" /></p>\r\n\r\n<ol>\r\n\t<li>Краткий рассказ о компании:&nbsp;поддержка всех&nbsp;видов деятельности и услуг медицинского туризма в Кванджу.</li>\r\n\t<li>Услуги организации:\r\n\t<ul>\r\n\t\t<li>ознакомительные туры и зарубежные маркетинговые мероприятия;</li>\r\n\t\t<li>медицинские туры для иностранных пациентов;</li>\r\n\t\t<li>One-stop service&nbsp;&mdash; непрерывная поддержка иностранных пациентов&nbsp;от прибытия в страну до отъезда.</li>\r\n\t</ul>\r\n\t</li>\r\n</ol>',
  //       scheduleDescription: null,
  //       experts: [
  //         {
  //           id: 7781,
  //           sorting: 0,
  //           image: null,
  //           fullName: "Юлия Фрундина",
  //           position: "Начальник отдела, специалист по Китаю, Южной Корее и Японии, Quinta Tour",
  //         },
  //         {
  //           id: 7805,
  //           sorting: 0,
  //           image: null,
  //           fullName: "Чхве Сану",
  //           position:
  //             "Руководитель Центра медицинского и оздоровительного туризма MEDIWELL в Кванджу",
  //         },
  //       ],
  //       id: 167068,
  //       type: "webinar",
  //       title:
  //         "Маршруты, отели, развлечения в Корее от Quinta Tour, а также биеннале и медицинский туризм в Кванджу",
  //       viewsCount: 10,
  //       participantsCount: 489,
  //       path: "/events/webinars/show/167068",
  //       date: "2021-04-21T10:00:00+03:00",
  //       dateEnd: "2021-04-21T11:00:00+03:00",
  //       status: 1,
  //       subscribed: true,
  //     },
  //   ],
  //   "Wed Apr 21 2021 11:00:00 GMT+0300": [
  //     {
  //       label: null,
  //       companyTitle: "Туроператор China Travel",
  //       description:
  //         "<ol>\r\n\t<li>Южная Корея&nbsp;&mdash; один из&nbsp;главных хабов в&nbsp;комбинации с&nbsp;другими странами: экскурсии, бизнес, шопинг, пляжный отдых.</li>\r\n\t<li>Перезагрузка осеннего сезона&nbsp;&mdash; 2020: обзор программ и&nbsp;фестивалей.</li>\r\n\t<li>Плановый разбор самой рекомендованной программы.</li>\r\n\t<li>Обзор важных моментов: объекты, еда, достопримечательности в&nbsp;турах.</li>\r\n</ol>",
  //       scheduleDescription: null,
  //       experts: [
  //         {
  //           id: 7782,
  //           sorting: 0,
  //           image:
  //             "https://cdn.profi.travel/local-storage/profi-travel/uploads/expert/photo/607fd1ffcc3c3613948153.jpeg",
  //           fullName: "Елена Волкова",
  //           position: "Эксперт China Travel",
  //         },
  //       ],
  //       id: 167070,
  //       type: "webinar",
  //       title:
  //         "Пляжный отдых, экскурсионные туры и обзор ключевых объектов в Южной Корее от China Travel",
  //       viewsCount: 12,
  //       participantsCount: 491,
  //       path: "/events/webinars/show/167070",
  //       date: "2021-04-21T11:00:00+03:00",
  //       dateEnd: "2021-04-21T12:00:00+03:00",
  //       status: 1,
  //       subscribed: true,
  //     },
  //   ],
  //   "Wed Apr 21 2021 12:00:00 GMT+0300": [
  //     {
  //       label: null,
  //       companyTitle: "Карловарский край",
  //       description:
  //         "<ol>\r\n\t<li><strong>Карловы Вары</strong>&nbsp;&mdash; курорт, доказавший свою эффективность. Вода из&nbsp;недр земли помогает справиться с&nbsp;проблемами ЖКТ, активирует иммунную систему человека, защищает его от&nbsp;вирусов и&nbsp;иных внешних воздействий, в&nbsp;том числе и&nbsp;от&nbsp;онкологии.</li>\r\n\t<li><strong>Марианские Лазни</strong>&nbsp;&mdash; королевский курорт. Первый в&nbsp;мире anti-age, источник долгой жизни. После открытия границ именно он&nbsp;станет главным местом реабилитации людей с&nbsp;поражением легких после COVID-19. А&nbsp;также курортом, который поможет укрепить дыхательную систему взрослых и&nbsp;детей.</li>\r\n\t<li><strong>Франтишковы Лазни</strong>&nbsp;&mdash; курорт, созданный специально для женщин. Как для тех, кто не&nbsp;может забеременеть, так и&nbsp;для тех, кто подходит к&nbsp;периоду менопаузы.</li>\r\n\t<li><strong>Яхимов&nbsp;</strong>&mdash; первый в&nbsp;мире радоновый курорт. Радоновая вода&nbsp;&mdash; одно из&nbsp;самых мощных природных противовоспалительных средств.</li>\r\n</ol>",
  //       scheduleDescription: null,
  //       experts: [
  //         {
  //           id: 7719,
  //           sorting: 0,
  //           image:
  //             "https://cdn.profi.travel/local-storage/profi-travel/uploads/expert/photo/5ece456acb391611066832.jpg",
  //           fullName: "Максим Приймак",
  //           position:
  //             "Медицинский Амбассадор в России и странах СНГ Государственного агентства по развитию туризма в Карловарском крае «Живой Край»",
  //         },
  //       ],
  //       id: 167025,
  //       type: "webinar",
  //       title:
  //         "Санаторно-курортное лечение, оздоровление, программы реабилитации после COVID-19 и превентивная медицина",
  //       viewsCount: 8,
  //       participantsCount: 639,
  //       path: "/events/webinars/show/167025",
  //       date: "2021-04-21T12:00:00+03:00",
  //       dateEnd: "2021-04-21T13:00:00+03:00",
  //       status: 1,
  //       subscribed: false,
  //     },
  //   ],
  //   "Wed Apr 21 2021 13:00:00 GMT+0300": [
  //     {
  //       label: null,
  //       companyTitle: "Отель Savoy Westend Hotel 5*, Чехия",
  //       description: "<p><strong>Программа вебинара&nbsp;уточняется.</strong></p>",
  //       scheduleDescription: null,
  //       experts: [
  //         {
  //           id: 7732,
  //           sorting: 0,
  //           image:
  //             "https://cdn.profi.travel/local-storage/profi-travel/uploads/expert/photo/5af19ca8c3111299497177.jpeg",
  //           fullName: "Ада Карпова",
  //           position: "Директор по продажам/заместитель генерального менеджера Savoy Westend Hotel",
  //         },
  //       ],
  //       id: 167031,
  //       type: "webinar",
  //       title:
  //         "Новости сезона-2021, услуги и презентация лечебных программ по профилактике и восстановлению после COVID-19",
  //       viewsCount: 13,
  //       participantsCount: 623,
  //       path: "/events/webinars/show/167031",
  //       date: "2021-04-21T13:00:00+03:00",
  //       dateEnd: "2021-04-21T14:00:00+03:00",
  //       status: 1,
  //       subscribed: false,
  //     },
  //   ],
  //   "Wed Apr 21 2021 14:00:00 GMT+0300": [
  //     {
  //       label: null,
  //       companyTitle: "Barceló Hotel Group. Occidental Hotels & Resorts",
  //       description:
  //         "<ol>\r\n\t<li>Презентация компании.</li>\r\n\t<li>Презентация отелей в&nbsp;Чешской Республике.</li>\r\n\t<li>Возможность проведения конференций в&nbsp;Праге и&nbsp;в&nbsp;Брно.</li>\r\n\t<li>Презентация всех отелей сети в&nbsp;Праге.</li>\r\n\t<li>Презентация отеля в&nbsp;Брно.</li>\r\n</ol>",
  //       scheduleDescription: null,
  //       experts: [
  //         {
  //           id: 7737,
  //           sorting: 0,
  //           image:
  //             "https://cdn.profi.travel/local-storage/profi-travel/uploads/expert/photo/60633e5c26323627348643.JPG",
  //           fullName: "Маркета Янатова",
  //           position:
  //             "Директор по маркетингу и продажам Чешской Республики сети отелей Barceló Hotel Group",
  //         },
  //       ],
  //       id: 167035,
  //       type: "webinar",
  //       title:
  //         "Одна из ведущих туристических компаний Европы — презентация отелей в Чешской Республике",
  //       viewsCount: 12,
  //       participantsCount: 634,
  //       path: "/events/webinars/show/167035",
  //       date: "2021-04-21T14:00:00+03:00",
  //       dateEnd: "2021-04-21T15:00:00+03:00",
  //       status: 1,
  //       subscribed: false,
  //     },
  //   ],
  //   "Wed Apr 21 2021 15:00:00 GMT+0300": [
  //     {
  //       label: null,
  //       companyTitle: "Malaysia Tourism Promotion Board",
  //       description:
  //         "<ul>\r\n\t<li>Что привлекает туристов в&nbsp;Малайзии?</li>\r\n\t<li>Общая информация: обзор достопримечательностей и&nbsp;мест для отдыха, способы добраться.</li>\r\n\t<li>Когда страна откроет границы?</li>\r\n\t<li><strong>Розыгрыш памятных сувениров!</strong></li>\r\n</ul>",
  //       scheduleDescription: null,
  //       experts: [
  //         {
  //           id: 7746,
  //           sorting: 0,
  //           image:
  //             "https://cdn.profi.travel/local-storage/profi-travel/uploads/expert/photo/5d4d70255d9fe494816317.jpg",
  //           fullName: "Александр Доля",
  //           position: "Специалист по маркетингу, Malaysia Tourism Promotion Board",
  //         },
  //       ],
  //       id: 167041,
  //       type: "webinar",
  //       title:
  //         "Когда Малайзия откроет границы и чем она привлекает туристов? Обзор от турофиса страны и розыгрыш призов!",
  //       viewsCount: 10,
  //       participantsCount: 519,
  //       path: "/events/webinars/show/167041",
  //       date: "2021-04-21T15:00:00+03:00",
  //       dateEnd: "2021-04-21T16:00:00+03:00",
  //       status: 1,
  //       subscribed: true,
  //     },
  //   ],
  //   "Wed Apr 21 2021 16:00:00 GMT+0300": [
  //     {
  //       label: null,
  //       companyTitle: "Malaysia Tourism Promotion Board",
  //       description:
  //         "<p><strong>Отель One&amp;Only Desaru Coast на&nbsp;побережье Южно-Китайского моря:</strong></p>\r\n\r\n<ul>\r\n\t<li><strong>трансфер:</strong>&nbsp;4&nbsp;часа от&nbsp;аэропорта Куала-Лумпур и&nbsp;2,5 часа от&nbsp;аэропорта Чанги;</li>\r\n\t<li><strong>номерной фонд:</strong>&nbsp;44&nbsp;сьюта, 50&nbsp;частных домов и&nbsp;вилла Villa One с&nbsp;4&nbsp;спальнями;</li>\r\n\t<li><strong>отдых:</strong>&nbsp;спа, частный пляж, водные активити, клубы, поддел-теннис, гольф, фитнес, пилатес, йога и&nbsp;развлечения для детей&nbsp;&mdash; клубы, верховая езда, лаборатории, кружки, клуб для рейнджеров и&nbsp;др.;</li>\r\n\t<li><strong>MICE:</strong>&nbsp;большой зал Grand Ballroom и&nbsp;3&nbsp;конференц-зала;</li>\r\n\t<li><strong>экскурсии</strong>&nbsp;и&nbsp;развлечения на&nbsp;побережье Десару;</li>\r\n\t<li><strong>питание:</strong>&nbsp;бренд-шеф Дэвид Дальхаус и&nbsp;кухня Малайзии в&nbsp;трех фирменных ресторанах, динамичном баре и&nbsp;пляжном клубе Ember Beach Club.</li>\r\n</ul>",
  //       scheduleDescription: null,
  //       experts: [
  //         {
  //           id: 7750,
  //           sorting: 0,
  //           image:
  //             "https://cdn.profi.travel/local-storage/profi-travel/uploads/expert/photo/60671b3c2269c230951309.png",
  //           fullName: "Виктория Кузнецова",
  //           position:
  //             "Менеджер по работе с ключевыми клиентами представительства Kerzner International",
  //         },
  //       ],
  //       id: 167043,
  //       type: "webinar",
  //       title:
  //         "Обзор отеля One&Only Desaru Coast: идеальный отдых класса «люкс» на побережье Десару в Малайзии",
  //       viewsCount: 13,
  //       participantsCount: 487,
  //       path: "/events/webinars/show/167043",
  //       date: "2021-04-21T16:00:00+03:00",
  //       dateEnd: "2021-04-21T17:00:00+03:00",
  //       status: 1,
  //       subscribed: true,
  //     },
  //   ],
  //   "Thu Apr 22 2021 10:00:00 GMT+0300": [
  //     {
  //       label: null,
  //       companyTitle: "ВАНД ТРЕВЕЛ",
  //       description:
  //         '<ol>\r\n\t<li>В&nbsp;ожидании восстановления турпотока с&nbsp;Южной Кореей: что происходит в&nbsp;стране?</li>\r\n\t<li>Освежаем знания и&nbsp;получаем новые: какие экскурсии привлекают туристов в&nbsp;Корее?</li>\r\n\t<li>Успешная реализация экскурсионного продукта: советы опытного туроператора.</li>\r\n\t<li>Организация туризма провинции Чолла-Намдо.\r\n\t<ul>\r\n\t\t<li>\r\n\t\t<p>Одно из&nbsp;самых популярных туристических направлений в&nbsp;Корее: красивые природные пейзажи, богатая гастрономия и&nbsp;различные культурные программы.</p>\r\n\t\t</li>\r\n\t\t<li>\r\n\t\t<p>Основные медицинские учреждения:</p>\r\n\r\n\t\t<ul>\r\n\t\t\t<li>\r\n\t\t\t<p>клиника университета Хвасун-Чоннам, которая специализируется на&nbsp;лечении раковых заболеваний, в&nbsp;том числе тяжелых стадий;</p>\r\n\t\t\t</li>\r\n\t\t\t<li>\r\n\t\t\t<p>клиника восточной медицины Мокпхо при университете Донсин, которая предлагает процедуры эстетической медицины, такие как подтяжка кожи и&nbsp;улучшение тонуса кожи. Это лучшее место для оздоровительного туризма, где гости смогут совместить отдых и&nbsp;посещение достопримечательностей с&nbsp;оздоровлением.</p>\r\n\t\t\t</li>\r\n\t\t</ul>\r\n\t\t</li>\r\n\t</ul>\r\n\t</li>\r\n</ol>\r\n\r\n<p><img alt="" src="https://cdn.profi.travel/storage/profi-travel/uploads/CKEditor/607988ce16d5b074797980.jpg" style="width: 659px; height: 70px;" /></p>',
  //       scheduleDescription: null,
  //       experts: [
  //         {
  //           id: 7765,
  //           sorting: 0,
  //           image:
  //             "https://cdn.profi.travel/local-storage/profi-travel/uploads/expert/photo/606f5088dd434906785639.jpg",
  //           fullName: "Людмила Озик",
  //           position: "Заместитель директора по туризму компании VAND",
  //         },
  //         {
  //           id: 7789,
  //           sorting: 0,
  //           image:
  //             "https://cdn.profi.travel/local-storage/profi-travel/uploads/expert/photo/6076b2dcb0180912694713.png",
  //           fullName: "Ли Кырин",
  //           position: "Заместитель директора департамента",
  //         },
  //       ],
  //       id: 167055,
  //       type: "webinar",
  //       title:
  //         "Южная Корея: познаем особенности экскурсионного туризма — мастер-класс от туроператора VAND",
  //       viewsCount: 0,
  //       participantsCount: 452,
  //       path: "/events/webinars/show/167055",
  //       date: "2021-04-22T10:00:00+03:00",
  //       dateEnd: "2021-04-22T11:00:00+03:00",
  //       status: 0,
  //       subscribed: true,
  //     },
  //   ],
  //   "Thu Apr 22 2021 11:00:00 GMT+0300": [
  //     {
  //       label: null,
  //       companyTitle: "KMP Group",
  //       description:
  //         "<ol>\r\n\t<li>О&nbsp;туроператоре KMP Group.</li>\r\n\t<li>Когда лучше ехать в&nbsp;Корею?</li>\r\n\t<li>Транспортное сообщение.</li>\r\n\t<li>Остров Чеджу&nbsp;&mdash; лучшее летнее направление в&nbsp;Корее: топ-3&nbsp;пляжей, особенности отдыха, достопримечательности и&nbsp;отели.</li>\r\n\t<li>Туры на&nbsp;лето-2021&nbsp;в Корею от&nbsp;KMP Group.</li>\r\n</ol>",
  //       scheduleDescription: null,
  //       experts: [
  //         {
  //           id: 7764,
  //           sorting: 0,
  //           image:
  //             "https://cdn.profi.travel/local-storage/profi-travel/uploads/expert/photo/5f6e19cfcaec8879846092.jpg",
  //           fullName: "Елена Милованова",
  //           position: "Ведущий менеджер отдела экзотики и стран Юго-Восточной Азии, KMP Group",
  //         },
  //       ],
  //       id: 167054,
  //       type: "webinar",
  //       title:
  //         "Летний отдых в Южной Корее с ТО KMP Group: лучшее направление на жаркий сезон, топ пляжей, советы турагентам и туры на лето-2021",
  //       viewsCount: 0,
  //       participantsCount: 446,
  //       path: "/events/webinars/show/167054",
  //       date: "2021-04-22T11:00:00+03:00",
  //       dateEnd: "2021-04-22T12:00:00+03:00",
  //       status: 0,
  //       subscribed: true,
  //     },
  //   ],
  //   "Thu Apr 22 2021 12:00:00 GMT+0300": [
  //     {
  //       label: null,
  //       companyTitle: "Сеть отелей Barceló Hotel Group",
  //       description:
  //         "<p>Актуальные новости от&nbsp;Barcel&oacute; Hotel Group. Новинки, обновления, излюбленные отели и&nbsp;СПО на&nbsp;летний период.</p>\r\n\r\n<ol>\r\n\t<li>Три отеля в&nbsp;Тунисе. Каникулы в&nbsp;Суссе и&nbsp;Хаммамете.</li>\r\n\t<li>Лучшие виды на&nbsp;остров Идра&nbsp;&mdash; греческий Barcel&oacute; Hydra Beach Resort.</li>\r\n\t<li>Barcel&oacute; Royal Beach на&nbsp;Солнечном Берегу (Болгария).</li>\r\n\t<li>Новые отели в&nbsp;Испании: Коста-Бланка и&nbsp;Коста-дель-Соль.</li>\r\n\t<li>Программа лояльности Barcel&oacute; Partner Club: все преимущества бронирования отелей сети Barcel&oacute;.</li>\r\n\t<li><strong>Розыгрыш ваучера на&nbsp;проживание в&nbsp;одном из&nbsp;отелей сети Barcel&oacute;!</strong></li>\r\n</ol>",
  //       scheduleDescription: null,
  //       experts: [
  //         {
  //           id: 7736,
  //           sorting: 0,
  //           image:
  //             "https://cdn.profi.travel/local-storage/profi-travel/uploads/expert/photo/5ecc0d80528f5011769556.jpg",
  //           fullName: "Елена Третьякова",
  //           position: "Представитель сети отелей Barceló Hotel Group, EMEA",
  //         },
  //       ],
  //       id: 167034,
  //       type: "webinar",
  //       title:
  //         "Тунис, Греция, Болгария, Испания — новинки и обновления к 2021 году: самая актуальная информация и СПО. Розыгрыш проживания!",
  //       viewsCount: 0,
  //       participantsCount: 702,
  //       path: "/events/webinars/show/167034",
  //       date: "2021-04-22T12:00:00+03:00",
  //       dateEnd: "2021-04-22T13:00:00+03:00",
  //       status: 0,
  //       subscribed: true,
  //     },
  //   ],
  //   "Thu Apr 22 2021 13:00:00 GMT+0300": [
  //     {
  //       label: null,
  //       companyTitle: "Принимающая компания Meeting Tour Travel & SPA Consultants",
  //       description:
  //         "<ol>\r\n\t<li>Вкратце о&nbsp;компании Meeting Tour Travel &amp;&nbsp;SPA Consultants. Преимущества сотрудничества.</li>\r\n\t<li>Новые реалии туризма в&nbsp;Латвии: неторопливые путешествия по&nbsp;регионам, посещение маленьких городов, хозяйств, погружение в&nbsp;культуру и&nbsp;традиции, отдых на&nbsp;природе.</li>\r\n\t<li>Истинное наслаждение жизнью: лечебно-оздоровительные программы в&nbsp;сезоне-2021.</li>\r\n</ol>",
  //       scheduleDescription: null,
  //       experts: [
  //         {
  //           id: 7776,
  //           sorting: 0,
  //           image:
  //             "https://cdn.profi.travel/local-storage/profi-travel/uploads/expert/photo/5f755d36778f8672926481.png",
  //           fullName: "Ивета Кравале",
  //           position:
  //             "Директор принимающей компании MEETING TOUR Travel & SPA Consultants (DMC, Латвия)",
  //         },
  //       ],
  //       id: 167063,
  //       type: "webinar",
  //       title:
  //         "Латвия в сезоне-2021: обзор направления от DMC, отдых в новых реалиях и оздоровительные программы",
  //       viewsCount: 0,
  //       participantsCount: 449,
  //       path: "/events/webinars/show/167063",
  //       date: "2021-04-22T13:00:00+03:00",
  //       dateEnd: "2021-04-22T14:00:00+03:00",
  //       status: 0,
  //       subscribed: true,
  //     },
  //   ],
  //   "Thu Apr 22 2021 14:00:00 GMT+0300": [
  //     {
  //       label: null,
  //       companyTitle: "Malaysia Tourism Promotion Board",
  //       description:
  //         "<ol>\r\n\t<li>Общая информация о&nbsp;путешествиях с&nbsp;Singapore Airlines.</li>\r\n\t<li>Новые протоколы безопасности и&nbsp;охраны здоровья пассажиров.</li>\r\n\t<li>Гибкость планирования будущих поездок.</li>\r\n\t<li>Как выглядит сервис премиальной авиакомпании в&nbsp;новой реальности?</li>\r\n</ol>",
  //       scheduleDescription: null,
  //       experts: [
  //         {
  //           id: 7779,
  //           sorting: 0,
  //           image:
  //             "https://cdn.profi.travel/local-storage/profi-travel/uploads/expert/photo/606f29d690475669811686.jpeg",
  //           fullName: "Светлана Краснобородько",
  //           position: "Менеджер по развитию бизнеса, Singapore Airlines",
  //         },
  //       ],
  //       id: 167066,
  //       type: "webinar",
  //       title:
  //         "Премиальная авиакомпания Singapore Airlines — гибкое планирование путешествий летом-2021, безопасность и охрана здоровья пассажиров",
  //       viewsCount: 0,
  //       participantsCount: 440,
  //       path: "/events/webinars/show/167066",
  //       date: "2021-04-22T14:00:00+03:00",
  //       dateEnd: "2021-04-22T16:00:00+03:00",
  //       status: 0,
  //       subscribed: true,
  //     },
  //   ],
  //   "Thu Apr 22 2021 16:00:00 GMT+0300": [
  //     {
  //       label: "Деловая программа",
  //       companyTitle: "Profi.Travel",
  //       description:
  //         "<p>В рамках деловой программы ОТМ: Лето 2021 поговорим о самых горячих юридических темах. Георгий Мохов, основатель компании &laquo;Персона Грата&raquo; и ведущий юрист в российской туротрасли, поделится последними новостями о переносах туров, обсудит законодательные новеллы и расскажет о важных нюансах в связи с &laquo;турецкими событиями&raquo;. Эфир ведет Антон Тримайлов, редактор международного отдела Profi.Travel.</p>\r\n\r\n<p>Узнаем:</p>\r\n\r\n<ul>\r\n\t<li>Как действовать с турами в Турцию, которые попадают на период приостановки полетов?</li>\r\n\t<li>Какие проблемы возникают для турбизнеса в судебной практике по &laquo;ковидным турам&raquo;?</li>\r\n\t<li>Как реестр турагентов может повлиять на договорные отношения с туроператорами?</li>\r\n</ul>",
  //       scheduleDescription: null,
  //       experts: [
  //         {
  //           id: 7727,
  //           sorting: 0,
  //           image:
  //             "https://cdn.profi.travel/local-storage/profi-travel/uploads/expert/photo/5e83837982fd1426973026.jpg",
  //           fullName: "Георгий Мохов",
  //           position:
  //             "Бизнес-омбудсмен, директор юридического агентства «Персона грата», руководитель правовой комиссии Российского союза туриндустрии",
  //         },
  //         {
  //           id: 7728,
  //           sorting: 0,
  //           image:
  //             "https://cdn.profi.travel/local-storage/profi-travel/uploads/expert/photo/5f786d895d30a242270617.jpg",
  //           fullName: "Антон Тримайлов",
  //           position: "Редактор международного отдела Profi.Travel, модератор",
  //         },
  //       ],
  //       id: 167029,
  //       type: "webinar",
  //       title: "«Турецкий гамбит»: аннулировать или переносить?",
  //       viewsCount: 0,
  //       participantsCount: 803,
  //       path: "/events/webinars/show/167029",
  //       date: "2021-04-22T16:00:00+03:00",
  //       dateEnd: "2021-04-22T18:00:00+03:00",
  //       status: 0,
  //       subscribed: false,
  //     },
  //   ],
  //   "Fri Apr 23 2021 10:00:00 GMT+0300": [
  //     {
  //       label: null,
  //       companyTitle: "Resort Life Travel",
  //       description:
  //         "<ol>\r\n\t<li>Resort Life Travel&nbsp;&mdash; 14&nbsp;лет сервиса на&nbsp;Мальдивах.</li>\r\n\t<li>Новый эксклюзив компании&nbsp;&mdash; Nakai Resorts.</li>\r\n\t<li>Crown and Champa Resorts&nbsp;&mdash; особенности продаж курортов в&nbsp;сезоне:\r\n\t<ul>\r\n\t\t<li>KAGI Maldives SPA Island;</li>\r\n\t\t<li>Kuredu Island Resort;</li>\r\n\t\t<li>Innahura Maldives Resort.</li>\r\n\t</ul>\r\n\t</li>\r\n</ol>",
  //       scheduleDescription: null,
  //       experts: [
  //         {
  //           id: 7752,
  //           sorting: 0,
  //           image:
  //             "https://cdn.profi.travel/local-storage/profi-travel/uploads/expert/photo/60771eb24c4e5412909302.jpeg",
  //           fullName: "Даша Караман",
  //           position: "Представитель Resort Life Travel",
  //         },
  //         {
  //           id: 7753,
  //           sorting: 0,
  //           image:
  //             "https://cdn.profi.travel/local-storage/profi-travel/uploads/expert/photo/606d718b964ff690051524.jpg",
  //           fullName: "Анна Кривогуз",
  //           position: "Sales & Marketing Manager",
  //         },
  //       ],
  //       id: 167045,
  //       type: "webinar",
  //       title:
  //         "Эксклюзив от принимающей компании на Мальдивах: Nakai Resorts и новости сети Crown & Champa Resorts!",
  //       viewsCount: 0,
  //       participantsCount: 665,
  //       path: "/events/webinars/show/167045",
  //       date: "2021-04-23T10:00:00+03:00",
  //       dateEnd: "2021-04-23T11:00:00+03:00",
  //       status: 0,
  //       subscribed: true,
  //     },
  //   ],
  //   "Fri Apr 23 2021 11:00:00 GMT+0300": [
  //     {
  //       label: null,
  //       companyTitle: "Minor Hotel Group",
  //       description:
  //         "<ol>\r\n\t<li><strong>Anantara Kihavah Villas:&nbsp;</strong>подводный ресторан SEA, уникальная надводная обсерватория, домашний риф.</li>\r\n\t<li><strong>Anantara Dhigu Resort:</strong>&nbsp;поездка на&nbsp;понтоне на&nbsp;остров Гулифуши, пикник на&nbsp;пустынных пляжах, снорклинг и&nbsp;другие развлечения.</li>\r\n\t<li><strong>Niyama Private Islands:&nbsp;</strong>круглосуточный спа-центр и&nbsp;первый в&nbsp;мире подводный ночной клуб.</li>\r\n\t<li>Все об&nbsp;отдыхе в&nbsp;<strong>Anantara Veli Resort&nbsp;</strong>и<strong>&nbsp;Naladhu Private Island.</strong></li>\r\n\t<li>СПО на&nbsp;лето-2021:\r\n\t<ul>\r\n\t\t<li>бесплатный обед для двоих в&nbsp;подводном ресторане SEA;</li>\r\n\t\t<li>бесплатная экскурсия для двоих в&nbsp;единственную надводную обсерваторию на&nbsp;Мальдивах;</li>\r\n\t\t<li>бесплатный снорклинг или круиз к&nbsp;дельфинам на&nbsp;двоих.</li>\r\n\t</ul>\r\n\t</li>\r\n</ol>",
  //       scheduleDescription: null,
  //       experts: [
  //         {
  //           id: 7763,
  //           sorting: 0,
  //           image:
  //             "https://cdn.profi.travel/local-storage/profi-travel/uploads/expert/photo/606f0798a303d233186840.jpg",
  //           fullName: "Александра Ефремова",
  //           position: "Менеджер по продажам и маркетингу, Minor Hotels",
  //         },
  //       ],
  //       id: 167053,
  //       type: "webinar",
  //       title:
  //         "На Мальдивы за впечатлениями: подводные ресторан и клуб, снорклинг с мантами, круглосуточный спа и СПО на лето-2021",
  //       viewsCount: 0,
  //       participantsCount: 681,
  //       path: "/events/webinars/show/167053",
  //       date: "2021-04-23T11:00:00+03:00",
  //       dateEnd: "2021-04-23T12:00:00+03:00",
  //       status: 0,
  //       subscribed: true,
  //     },
  //   ],
  //   "Fri Apr 23 2021 12:00:00 GMT+0300": [
  //     {
  //       label: null,
  //       companyTitle: "Exciting Travel Holidays",
  //       description:
  //         "<ol>\r\n\t<li>Знакомство с&nbsp;принимающей компанией Exciting Travel Holidays. Предоставляемые услуги:\r\n\t<ul>\r\n\t\t<li>встреча и&nbsp;прием гостей в&nbsp;аэропорту;</li>\r\n\t\t<li>полное сопровождение туристов в&nbsp;стране пребывания;</li>\r\n\t\t<li>русский Guest relations 24/7;</li>\r\n\t\t<li>услуги CIP-лаунджа: встреча у&nbsp;трапа + VIP-обслуживание;</li>\r\n\t\t<li>индивидуальный трансфер, экскурсия по&nbsp;Мале и&nbsp;многое другое.</li>\r\n\t</ul>\r\n\t</li>\r\n\t<li>Хиты сезона-2021 и&nbsp;новинки сезона-2022.</li>\r\n\t<li>Отели на&nbsp;Мальдивах: рекомендации, новинки.</li>\r\n\t<li><strong>Розыгрыш 2&nbsp;ночей в&nbsp;Movenpick Maldives и&nbsp;2&nbsp;ночей в&nbsp;Hideaway!</strong></li>\r\n</ol>",
  //       scheduleDescription: null,
  //       experts: [
  //         {
  //           id: 7815,
  //           sorting: 0,
  //           image: null,
  //           fullName: "Елена Овчарук",
  //           position: "Менеджер по продажам в России, Украине и СНГ, Exciting Travel Holidays",
  //         },
  //         {
  //           id: 7816,
  //           sorting: 0,
  //           image: null,
  //           fullName: "Олег Дыбов",
  //           position: "Региональный директор по продажам и маркетингу Lily Hotels Maldives",
  //         },
  //       ],
  //       id: 167086,
  //       type: "webinar",
  //       title:
  //         "Мальдивы — обзор отелей на любой вкус: от гестхаусов до приватных островов-резортов. Розыгрыш проживания!",
  //       viewsCount: 0,
  //       participantsCount: 135,
  //       path: "/events/webinars/show/167086",
  //       date: "2021-04-23T12:00:00+03:00",
  //       dateEnd: "2021-04-23T13:00:00+03:00",
  //       status: 0,
  //       subscribed: false,
  //     },
  //   ],
  //   "Fri Apr 23 2021 13:00:00 GMT+0300": [
  //     {
  //       label: null,
  //       companyTitle: "Reollo Travel Maldives",
  //       description:
  //         "<p><strong>1. Reollo Travel Maldives</strong></p>\r\n\r\n<ul>\r\n\t<li>О&nbsp;компании: возможности и&nbsp;преимущества.</li>\r\n\t<li>Услуги и&nbsp;VIP-услуги компании.</li>\r\n\t<li>Рекомендованные курорты.</li>\r\n\t<li>Почему Reollo Travel?</li>\r\n\t<li>Контакты компании.</li>\r\n</ul>\r\n\r\n<p><strong>2. Отель Kandima</strong></p>\r\n\r\n<ul>\r\n\t<li>Обзор отеля.</li>\r\n\t<li>Новости 2021&nbsp;года.</li>\r\n\t<li>Что такое lifestyle resort? Кому и&nbsp;как его продавать?</li>\r\n</ul>\r\n\r\n<p><strong>3. Розыгрыш трех ночей в Sky Studio на базе завтраков для двоих!</strong></p>",
  //       scheduleDescription: null,
  //       experts: [
  //         {
  //           id: 7741,
  //           sorting: 0,
  //           image:
  //             "https://cdn.profi.travel/local-storage/profi-travel/uploads/expert/photo/606aabb50b59d989297884.jpg",
  //           fullName: "Наталья Гребнева",
  //           position: "Менеджер по продажам и маркетингу в России, компания Reollo Travel",
  //         },
  //         {
  //           id: 7742,
  //           sorting: 0,
  //           image:
  //             "https://cdn.profi.travel/local-storage/profi-travel/uploads/expert/photo/606aaa4e5767d748689032.jpg",
  //           fullName: "Марина Мирошникова",
  //           position: "Менеджер отдела продаж отеля Kandima, Россия и СНГ",
  //         },
  //       ],
  //       id: 167037,
  //       type: "webinar",
  //       title:
  //         "Аренда частного острова или встреча со звездой? Организуйте отдых на Мальдивах любого уровня сложности! Розыгрыш проживания!",
  //       viewsCount: 0,
  //       participantsCount: 674,
  //       path: "/events/webinars/show/167037",
  //       date: "2021-04-23T13:00:00+03:00",
  //       dateEnd: "2021-04-23T14:00:00+03:00",
  //       status: 0,
  //       subscribed: false,
  //     },
  //   ],
  //   "Fri Apr 23 2021 14:00:00 GMT+0300": [
  //     {
  //       label: null,
  //       companyTitle: "The Lux Collective",
  //       description:
  //         "<ol>\r\n\t<li>Отдых в&nbsp;стиле LUX*&nbsp;на Мальдивах&nbsp;&mdash; открываем с&nbsp;новой стороны! Особенности бренда и&nbsp;новинки летнего сезона.</li>\r\n\t<li>Сюрпризы от&nbsp;LUX*: обжаренный прямо на&nbsp;острове кофе, кинопоказы под звездным небом и&nbsp;волшебное дерево желаний.</li>\r\n\t<li>Жемчужина гостеприимства Мальдив: LUX* South Ari Atoll 5&nbsp;star.</li>\r\n</ol>",
  //       scheduleDescription: null,
  //       experts: [
  //         {
  //           id: 7718,
  //           sorting: 0,
  //           image:
  //             "https://cdn.profi.travel/local-storage/profi-travel/uploads/expert/photo/5af19ed67a0d1229431993.jpeg",
  //           fullName: "Наталья Веббер",
  //           position: "Директор по продажам и маркетингу",
  //         },
  //       ],
  //       id: 167024,
  //       type: "webinar",
  //       title:
  //         "Кинопоказы под звездным небом и волшебное дерево желаний — обзор отеля LUX* South Ari Atoll на Мальдивах с новой стороны!",
  //       viewsCount: 0,
  //       participantsCount: 663,
  //       path: "/events/webinars/show/167024",
  //       date: "2021-04-23T14:00:00+03:00",
  //       dateEnd: "2021-04-23T15:00:00+03:00",
  //       status: 0,
  //       subscribed: false,
  //     },
  //   ],
  //   "Fri Apr 23 2021 15:00:00 GMT+0300": [
  //     {
  //       label: null,
  //       companyTitle: "Aitken Spence Travels",
  //       description:
  //         "<ol>\r\n\t<li>Знакомство с&nbsp;группой компаний Aitken Spence.</li>\r\n\t<li>Секреты отдыха на&nbsp;Шри-Ланке с&nbsp;принимающим туроператором Aitken Spence Travels:\r\n\t<ul>\r\n\t\t<li>Почему Шри-Ланка&nbsp;&mdash; идеальное направление для путешествий?</li>\r\n\t\t<li>Основные туристические направления Шри-Ланки и&nbsp;лучшее время для поездки.</li>\r\n\t\t<li>Направления экскурсионных туров.</li>\r\n\t\t<li>Популярные пляжные отели Шри-Ланки.</li>\r\n\t\t<li>Меры по&nbsp;предотвращению распространения COVID-19.</li>\r\n\t\t<li>Визовая и&nbsp;иммиграционная информация.</li>\r\n\t\t<li>Вопросы и&nbsp;ответы.</li>\r\n\t</ul>\r\n\t</li>\r\n</ol>",
  //       scheduleDescription: null,
  //       experts: [
  //         {
  //           id: 7785,
  //           sorting: 0,
  //           image: null,
  //           fullName: "Марина Велиханова",
  //           position: "Специалист направления Россия и СНГ",
  //         },
  //       ],
  //       id: 167073,
  //       type: "webinar",
  //       title:
  //         "Шри-Ланка — направление, идеальное в любой сезон: обзор экскурсионных маршрутов и популярных отелей для пляжного отдыха",
  //       viewsCount: 0,
  //       participantsCount: 467,
  //       path: "/events/webinars/show/167073",
  //       date: "2021-04-23T15:00:00+03:00",
  //       dateEnd: "2021-04-23T16:00:00+03:00",
  //       status: 0,
  //       subscribed: true,
  //     },
  //   ],
  //   "Mon Apr 26 2021 10:00:00 GMT+0300": [
  //     {
  //       label: null,
  //       companyTitle: "Centara Hotels & Resorts",
  //       description:
  //         "<ol>\r\n\t<li><strong>Centara Grand Island Resort &amp;&nbsp;Spa Maldives 5*</strong> ― изменения концепта питания, сюрпризы для гостей с&nbsp;детьми, новое о&nbsp;дайвинге и&nbsp;организации свадеб.</li>\r\n\t<li><strong>Centara Ras Fushi Resort &amp;&nbsp;Spa Maldives 4*</strong> ― изменения концепта питания, новости активного отдыха для молодоженов и&nbsp;организация свадеб.</li>\r\n\t<li><strong>Centara Ceysands Resort &amp;&nbsp;Spa Sri Lanka 4*</strong> ― как отель встречает гостей в&nbsp;условиях новой эры путешествий и&nbsp;какие услуги доступны для нескучного отдыха на&nbsp;территории курорта с&nbsp;детьми и&nbsp;без детей.</li>\r\n\t<li><strong>Centara Reserve Samui </strong>&mdash; открытие нового отеля в сегменте luxury в преддверии открытия границ Таиланда.</li>\r\n\t<li><strong>Викторина с&nbsp;розыгрышем ваучера на&nbsp;проживание&nbsp;&mdash; две ночи на&nbsp;двоих на&nbsp;Мальдивах на&nbsp;питании all inclusive.</strong></li>\r\n</ol>",
  //       scheduleDescription: null,
  //       experts: [
  //         {
  //           id: 7706,
  //           sorting: 0,
  //           image:
  //             "https://cdn.profi.travel/local-storage/profi-travel/uploads/expert/photo/605e12caaf06a469924242.jpg",
  //           fullName: "Светлана Рос",
  //           position: "Директор по продажам сети Centara Hotels & Resorts, Таиланд, Бангкок",
  //         },
  //       ],
  //       id: 167022,
  //       type: "webinar",
  //       title:
  //         "Нескучный отдых на Мальдивах, Шри-Ланке и Таиланде: спецпредложения на 2021-й и виды услуг. Розыгрыш ваучера на проживание!",
  //       viewsCount: 0,
  //       participantsCount: 706,
  //       path: "/events/webinars/show/167022",
  //       date: "2021-04-26T10:00:00+03:00",
  //       dateEnd: "2021-04-26T11:00:00+03:00",
  //       status: 0,
  //       subscribed: false,
  //     },
  //   ],
  //   "Mon Apr 26 2021 11:00:00 GMT+0300": [
  //     {
  //       label: null,
  //       companyTitle: "Adaaran Resorts, Heritance Aarah, Heritance Ayurveda",
  //       description:
  //         "<ol>\r\n\t<li>Знакомство с&nbsp;брендами Adaaran Club, Adaaran Select и&nbsp;Adaaran Prestige.</li>\r\n\t<li>История появления бренда Adaaran на&nbsp;Мальдивах и&nbsp;обзор отелей для семейного отдыха и других развлечений:\r\n\t<ul>\r\n\t\t<li>Adaaran Select Meedhupparu&nbsp;&mdash; концепция Premium All Inclusive Concept;</li>\r\n\t\t<li>Adaaran Select Hudhuranfushi&nbsp;&mdash; рай для серферов;</li>\r\n\t\t<li>Adaaran Club Rannalhi&nbsp;&mdash; клубная концепция;</li>\r\n\t\t<li>Adaaran Prestige Vadoo&nbsp;&mdash; идеальный курорт для пар и&nbsp;романтического отдыха.</li>\r\n\t</ul>\r\n\t</li>\r\n\t<li>Презентация нового отеля Heritance Aarah и&nbsp;его концепции Premium All Inclusive.</li>\r\n\t<li>Ответы на&nbsp;вопросы.</li>\r\n</ol>",
  //       scheduleDescription: null,
  //       experts: [
  //         {
  //           id: 7783,
  //           sorting: 0,
  //           image:
  //             "https://cdn.profi.travel/local-storage/profi-travel/uploads/expert/photo/6075592b71609231491369.jpg",
  //           fullName: "Шриниваса Редди",
  //           position:
  //             "Менеджер по развитию бизнеса, Adaaran Resorts, Heritance Aarah, Heritance Ayurveda Premium All Inclusive",
  //         },
  //         {
  //           id: 7786,
  //           sorting: 0,
  //           image:
  //             "https://cdn.profi.travel/local-storage/profi-travel/uploads/expert/photo/607697ea9d82a100859200.JPG",
  //           fullName: "Марина Смирнова",
  //           position: "Менеджер по развитию бизнеса в России и СНГ, Heritance Aarah",
  //         },
  //       ],
  //       id: 167071,
  //       type: "webinar",
  //       title:
  //         "Отели на Мальдивах: рай для семейного отдыха, презентация нового отеля и концепция Premium All Inclusive",
  //       viewsCount: 0,
  //       participantsCount: 408,
  //       path: "/events/webinars/show/167071",
  //       date: "2021-04-26T11:00:00+03:00",
  //       dateEnd: "2021-04-26T12:00:00+03:00",
  //       status: 0,
  //       subscribed: true,
  //     },
  //   ],
  //   "Mon Apr 26 2021 13:00:00 GMT+0300": [
  //     {
  //       label: null,
  //       companyTitle: "Anantara на Шри-Ланке",
  //       description:
  //         "<ol>\r\n\t<li>Особенности оформления виз и&nbsp;правила въезда на&nbsp;Шри-Ланку.</li>\r\n\t<li>Правила нахождения в&nbsp;стране, возможности для отдыха и&nbsp;развлечений.</li>\r\n\t<li>Рассказ об&nbsp;отелях, их&nbsp;расположении и&nbsp;услугах:\r\n\t<ul>\r\n\t\t<li>Anantara Peace Haven Tangalle Resort;</li>\r\n\t\t<li>Anantara Kalutara;</li>\r\n\t\t<li>AVANI&nbsp;Kalutara.</li>\r\n\t</ul>\r\n\t</li>\r\n</ol>",
  //       scheduleDescription: null,
  //       experts: [
  //         {
  //           id: 7756,
  //           sorting: 0,
  //           image:
  //             "https://cdn.profi.travel/local-storage/profi-travel/uploads/expert/photo/5f58c86030473561173190.png",
  //           fullName: "Виктория Коликова",
  //           position: "Директор по продажам в России, СНГ и Восточной Европе, Minor Hotels",
  //         },
  //       ],
  //       id: 167049,
  //       type: "webinar",
  //       title:
  //         "Отели бренда на Шри-Ланке: особенности въезда, правила нахождения в стране и обзор трех объектов",
  //       viewsCount: 0,
  //       participantsCount: 585,
  //       path: "/events/webinars/show/167049",
  //       date: "2021-04-26T13:00:00+03:00",
  //       dateEnd: "2021-04-26T14:00:00+03:00",
  //       status: 0,
  //       subscribed: true,
  //     },
  //   ],
  //   "Mon Apr 26 2021 16:00:00 GMT+0300": [
  //     {
  //       label: "Деловая программа",
  //       companyTitle: "Profi.Travel",
  //       description:
  //         "<p>С&nbsp;1&nbsp;июля 2021 года онлайн-касса становится обязательной для всех турагентств, включая&nbsp;ИП без наемных сотрудников. О&nbsp;том, что необходимо знать турагенту накануне важной даты, чтобы не&nbsp;столкнуться с&nbsp;проблемами в&nbsp;налоговой отчетности расскажет генеральный директор аудиторской компании &laquo;Аудит-Контур&raquo; Елена Иванова.</p>\r\n\r\n<p>В&nbsp;рамках эфира узнаем:</p>\r\n\r\n<ul>\r\n\t<li>Нужна&nbsp;ли касса при продаже онлайн?</li>\r\n\t<li>Какая информация должна быть в&nbsp;чеке?</li>\r\n\t<li>Как оформить оплату тура двумя платежами в&nbsp;разные даты?</li>\r\n\t<li>Чем грозит &laquo;пробитие&raquo; чека без внесенных данных о&nbsp;турпродукте?</li>\r\n</ul>",
  //       scheduleDescription: null,
  //       experts: [
  //         {
  //           id: 7730,
  //           sorting: 0,
  //           image:
  //             "https://cdn.profi.travel/local-storage/profi-travel/uploads/expert/photo/606c0fd846bbc818692855.png",
  //           fullName: "Елена Иванова",
  //           position: "Генеральный директор аудиторской компании «Аудит-Контур»",
  //         },
  //         {
  //           id: 7731,
  //           sorting: 0,
  //           image:
  //             "https://cdn.profi.travel/local-storage/profi-travel/uploads/expert/photo/606466c0254de907984308.png",
  //           fullName: "Ольга Осадчих",
  //           position: "Ведущая международной онлайн-выставки ОТМ. Лето",
  //         },
  //       ],
  //       id: 167030,
  //       type: "webinar",
  //       title: "Кассы в массы: комментарии эксперта по нововведениям в работе с онлайн-кассами",
  //       viewsCount: 0,
  //       participantsCount: 669,
  //       path: "/events/webinars/show/167030",
  //       date: "2021-04-26T16:00:00+03:00",
  //       dateEnd: "2021-04-26T17:00:00+03:00",
  //       status: 0,
  //       subscribed: false,
  //     },
  //   ],
  //   "Tue Apr 27 2021 14:00:00 GMT+0300": [
  //     {
  //       label: null,
  //       companyTitle: "Принимающая компания CARPE-DIEM Travel",
  //       description:
  //         "<ul>\r\n\t<li>Обзор авторских туров в&nbsp;Армении, Грузии и&nbsp;Украине.</li>\r\n\t<li>Новинка: Армения&nbsp;&mdash; тур Всемирного наследия ЮНЕСКО.</li>\r\n\t<li>Комбинированные туры Беларусь&nbsp;&mdash; Украина.</li>\r\n\t<li>Экотуры в&nbsp;Украине и речной круиз по маршруту Мозырь &mdash; Киев &mdash; Мозырь.</li>\r\n\t<li><strong>Розыгрыш призов!</strong></li>\r\n</ul>",
  //       scheduleDescription: null,
  //       experts: [
  //         {
  //           id: 7778,
  //           sorting: 0,
  //           image: null,
  //           fullName: "Сергей Червяк",
  //           position: "Генеральный директор",
  //         },
  //       ],
  //       id: 167065,
  //       type: "webinar",
  //       title:
  //         "Предложения лета-2021: трипы по Армении и Грузии, тур Всемирного наследия ЮНЕСКО, речные круизы и комби-туры. Розыгрыш!",
  //       viewsCount: 0,
  //       participantsCount: 377,
  //       path: "/events/webinars/show/167065",
  //       date: "2021-04-27T14:00:00+03:00",
  //       dateEnd: "2021-04-27T15:00:00+03:00",
  //       status: 0,
  //       subscribed: true,
  //     },
  //   ],
  //   "Tue Apr 27 2021 15:00:00 GMT+0300": [
  //     {
  //       label: null,
  //       companyTitle: "Туроператор «Спектрум»",
  //       description:
  //         "<ol>\r\n\t<li>Куда едем, как отдыхаем?\r\n\t<ul>\r\n\t\t<li>ОАЭ, Мальдивы, Сейшелы, Кипр, Армения, Абхазия&nbsp;&mdash; правила въезда и&nbsp;пребывания, ПЦР-тесты.</li>\r\n\t\t<li>Полетная программа из&nbsp;Москвы и&nbsp;регионов.</li>\r\n\t</ul>\r\n\t</li>\r\n\t<li>Пляжный отдых.\r\n\t<ul>\r\n\t\t<li>Изучаем ОАЭ: какой курорт выбрать для отдыха самого избирательного туриста.</li>\r\n\t\t<li>Мальдивы и&nbsp;Сейшелы&nbsp;&mdash; райские острова в&nbsp;Индийском океане.</li>\r\n\t\t<li>Кипр&nbsp;&mdash; наслаждаемся Средиземным морем.</li>\r\n\t\t<li>Абхазия&nbsp;&mdash; топ отелей для отдыха с&nbsp;детьми.</li>\r\n\t</ul>\r\n\t</li>\r\n\t<li>Экскурсионные туры.\r\n\t<ul>\r\n\t\t<li>Армения&nbsp;&mdash; гостеприимная страна.</li>\r\n\t\t<li>Винные дни в&nbsp;Ереване.</li>\r\n\t\t<li>Топ-10&nbsp;достопримечательностей, которые надо посмотреть в&nbsp;Армении.</li>\r\n\t\t<li>Экскурсии в&nbsp;Абхазии: что посмотреть во&nbsp;время путешествия.</li>\r\n\t\t<li>Гастрономические туры.</li>\r\n\t</ul>\r\n\t</li>\r\n\t<li>Лечение и&nbsp;SPA-программы.\r\n\t<ul>\r\n\t\t<li>Топ-5 пансионатов и&nbsp;санаториев Абхазии.</li>\r\n\t\t<li>SPA-программы отелей Кипра.</li>\r\n\t</ul>\r\n\t</li>\r\n\t<li>Для всех участников онлайн-презентации специальные условия по&nbsp;сотрудничеству!</li>\r\n</ol>",
  //       scheduleDescription: null,
  //       experts: [
  //         {
  //           id: 7802,
  //           sorting: 0,
  //           image:
  //             "https://cdn.profi.travel/local-storage/profi-travel/uploads/expert/photo/5ebd684d3fa81579712845.png",
  //           fullName: "Анна Додонова",
  //           position: "Начальник отдела маркетинга и развития агентской сети, «Спектрум»",
  //         },
  //         {
  //           id: 7803,
  //           sorting: 0,
  //           image:
  //             "https://cdn.profi.travel/local-storage/profi-travel/uploads/expert/photo/5ebd691121a5c372594363.png",
  //           fullName: "Елена Седова",
  //           position: "Ведущий специалист департамента по туризму, «Спектрум»",
  //         },
  //       ],
  //       id: 167081,
  //       type: "webinar",
  //       title:
  //         "Как отдыхаем, куда едем? Предложения туроператора на летние каникулы: пляжный отдых, экскурсионные туры, лечение и SPA-программы",
  //       viewsCount: 0,
  //       participantsCount: 419,
  //       path: "/events/webinars/show/167081",
  //       date: "2021-04-27T15:00:00+03:00",
  //       dateEnd: "2021-04-27T16:00:00+03:00",
  //       status: 0,
  //       subscribed: true,
  //     },
  //   ],
  //   "Wed Apr 28 2021 10:00:00 GMT+0300": [
  //     {
  //       label: null,
  //       companyTitle: "PHĀEA Resorts, Греция",
  //       description:
  //         "<ol>\r\n\t<li>Blue Palace a&nbsp;Luxury Collection Resort &amp;&nbsp;Spa&nbsp;&mdash; роскошный отель с&nbsp;видом на&nbsp;реликтовый остров Спиналонга, спа-центр на&nbsp;пляже, плавание на&nbsp;каяках, экскурсионные пикники.</li>\r\n\t<li>Cretan Malia Park, Member of&nbsp;Design Hotels&nbsp;&mdash; уединенный песчаный пляж, длинный бассейн в&nbsp;форме реки, йога и&nbsp;медитация, органический кухонный сад.</li>\r\n\t<li>Agapi Beach Resort&nbsp;&mdash; курортный поселок с&nbsp;бунгало, уроки танца &laquo;Сиртаки&raquo;, изучение греческого языка, театр Garden.</li>\r\n</ol>",
  //       scheduleDescription: null,
  //       experts: [
  //         {
  //           id: 7814,
  //           sorting: 0,
  //           image:
  //             "https://cdn.profi.travel/local-storage/profi-travel/uploads/expert/photo/5dfb670bbc74e190930500.jpg",
  //           fullName: "Таисия Кутепова",
  //           position: "Менеджер по продажам",
  //         },
  //       ],
  //       id: 167085,
  //       type: "webinar",
  //       title:
  //         "Пикники на островах, органический кухонный сад, театр и спа на побережье Элунда — идеальный отдых в отелях на Крите!",
  //       viewsCount: 0,
  //       participantsCount: 95,
  //       path: "/events/webinars/show/167085",
  //       date: "2021-04-28T10:00:00+03:00",
  //       dateEnd: "2021-04-28T11:00:00+03:00",
  //       status: 0,
  //       subscribed: false,
  //     },
  //   ],
  //   "Wed Apr 28 2021 11:00:00 GMT+0300": [
  //     {
  //       label: null,
  //       companyTitle: "Авиакомпания Turkish Airlines",
  //       description:
  //         "<ol>\r\n\t<li>География полетов авиакомпании Turkish Airlines в&nbsp;России и&nbsp;мире.</li>\r\n\t<li>Меры безопасности на&nbsp;борту.</li>\r\n\t<li>Обслуживание во&nbsp;время полета.</li>\r\n\t<li>Программа для часто летающих пассажиров Miles &amp;&nbsp;Smiles.</li>\r\n\t<li>Новые рейсы в&nbsp;Бодрум и&nbsp;Даламан из&nbsp;Москвы.</li>\r\n</ol>",
  //       scheduleDescription: null,
  //       experts: [
  //         {
  //           id: 7760,
  //           sorting: 0,
  //           image:
  //             "https://cdn.profi.travel/local-storage/profi-travel/uploads/expert/photo/606ed6f8869ef796847285.JPG",
  //           fullName: "Евгения Муслу",
  //           position: "Специалист отдела маркетинга, Turkish Airlines",
  //         },
  //       ],
  //       id: 167051,
  //       type: "webinar",
  //       title:
  //         "Безопасные и комфортные полеты в сезоне-2021: правила компании, новые рейсы в Бодрум и Даламан и программа для постоянных клиентов",
  //       viewsCount: 0,
  //       participantsCount: 678,
  //       path: "/events/webinars/show/167051",
  //       date: "2021-04-28T11:00:00+03:00",
  //       dateEnd: "2021-04-28T12:00:00+03:00",
  //       status: 0,
  //       subscribed: false,
  //     },
  //   ],
  //   "Wed Apr 28 2021 12:00:00 GMT+0300": [
  //     {
  //       label: null,
  //       companyTitle: "Туроператор по морским круизам CruClub",
  //       description:
  //         "<ol>\r\n\t<li>Как круизные компании и&nbsp;операторы переживают пандемию?</li>\r\n\t<li>Какие круизы и&nbsp;направления доступны для россиян летом-2021?</li>\r\n\t<li>Royal Caribbean выбирает CruClub! В&nbsp;гостях представитель компании Александр Самунджян.</li>\r\n\t<li>Royal Caribbean&nbsp;&mdash; старт продаж для граждан России и&nbsp;не&nbsp;только.</li>\r\n\t<li>Протоколы безопасности: что ждет пассажиров на&nbsp;борту?</li>\r\n\t<li>Что надо брать, чтобы потом не&nbsp;пожалеть?</li>\r\n\t<li>&laquo;Что делать, если...&raquo;&nbsp;&mdash; ответы на&nbsp;вопросы.</li>\r\n\t<li>CruClub рядом&nbsp;&mdash; поддержка от&nbsp;компании.</li>\r\n</ol>",
  //       scheduleDescription: null,
  //       experts: [
  //         {
  //           id: 7784,
  //           sorting: 0,
  //           image:
  //             "https://cdn.profi.travel/local-storage/profi-travel/uploads/expert/photo/5b7c067cc2ff4832405404.jpg",
  //           fullName: "Ирина Старкова",
  //           position: "Руководитель агентского отдела туроператора по морским круизам CruClub",
  //         },
  //       ],
  //       id: 167072,
  //       type: "webinar",
  //       title:
  //         "Какие круизы будут доступны россиянам летом-2021? Новости компании: перезапуск круизов с Royal Caribbean!",
  //       viewsCount: 0,
  //       participantsCount: 436,
  //       path: "/events/webinars/show/167072",
  //       date: "2021-04-28T12:00:00+03:00",
  //       dateEnd: "2021-04-28T13:00:00+03:00",
  //       status: 0,
  //       subscribed: true,
  //     },
  //   ],
  //   "Wed Apr 28 2021 14:00:00 GMT+0300": [
  //     {
  //       label: null,
  //       companyTitle: "Profi.Travel",
  //       description: "Программа уточняется",
  //       scheduleDescription: null,
  //       experts: [
  //         {
  //           id: 7793,
  //           sorting: 0,
  //           image:
  //             "https://cdn.profi.travel/local-storage/profi-travel/uploads/expert/photo/606466c0254de907984308.png",
  //           fullName: "Ольга Осадчих",
  //           position: "Ведущая международной онлайн-выставки ОТМ. Лето",
  //         },
  //       ],
  //       id: 167069,
  //       type: "webinar",
  //       title:
  //         "Эфир закрытия онлайн-выставки «ОТМ: Лето 2021». Подводим итоги и дарим главные призы",
  //       viewsCount: 0,
  //       participantsCount: 369,
  //       path: "/events/webinars/show/167069",
  //       date: "2021-04-28T14:00:00+03:00",
  //       dateEnd: "2021-04-28T16:00:00+03:00",
  //       status: 0,
  //       subscribed: true,
  //     },
  //   ],
  //   "Thu Jun 10 2021 11:00:00 GMT+0300": [
  //     {
  //       label: null,
  //       companyTitle: "NKAR Travels & Tours",
  //       description: null,
  //       scheduleDescription: null,
  //       experts: [],
  //       id: 167088,
  //       type: "webinar",
  //       title: "Шри-Ланка — особенности продаж",
  //       viewsCount: 0,
  //       participantsCount: 39,
  //       path: "/events/webinars/show/167088",
  //       date: "2021-06-10T11:00:00+03:00",
  //       dateEnd: "2021-06-10T13:00:00+03:00",
  //       status: 0,
  //       subscribed: false,
  //     },
  //   ],
  // },
};

export default (state = InitialState, action: any) => {
  switch (action.type) {
    case Action.Schedule.SET_DATA:
      return { ...state, data: action.data };
    case Action.Schedule.SET_STATUS:
      return { ...state, status: action.data };
    case Action.Schedule.SET_ERROR:
      return { ...state, error: action.data };
    case Action.Schedule.CLEAR:
      return { ...state, data: {} };
    default:
      return state;
  }
};
